import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Domain_LocalResourcesDefinition  {
    _originalTypeClassName = "zERP.BO.Domain_LocalResourcesDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Domain_LocalResourcesDefinition.translate = translateService;
}
this.InventoryManagementBO_Res_ASSOC_Address_Warehouse_Address = null;
this.InventoryManagementBO_Res_ASSOC_Warehouse_ParentWarehouse_Warehouse_Warehouses = null;
this.InventoryManagementBO_Res_ASSOC_Warehouse_GoodStock_Warehouse = null;
this.InventoryManagementBO_Res_ASSOC_GoodStock_Transfers_GoodTransfer_Stock = null;
this.InventoryManagementBO_Res_ASSOC_Employee_Warehouse_Responsible = null;
this.InventoryManagementBO_Res_ASSOC_BusinessEntity_GoodBase_Entity = null;
this.InventoryManagementBO_Res_ASSOC_BusinessEntity_Warehouse_Entity = null;
this.InventoryManagementBO_Res_ASSOC_ERPFiscalYear_GoodTransferTransaction_FiscalYear = null;
this.InventoryManagementBO_Res_ASSOC_BusinessEntity_GoodTransferTransaction_Entity = null;
this.InventoryManagementBO_Res_ASSOC_GoodBase_GoodTransfer_Good = null;
this.InventoryManagementBO_Res_ASSOC_ExpensesClassificationCategoryValueObject_TransactionItemClassification_ExpensesClassificationCategory = null;
this.InventoryManagementBO_Res_ASSOC_IncomeClassificationCategoryValueObject_TransactionItemClassification_IncomeClassificationCategory = null;
this.InventoryManagementBO_Res_ASSOC_ExpensesClassificationTypeValueObject_TransactionItemClassification_ExpensesClassificationTypes = null;
this.InventoryManagementBO_Res_ASSOC_IncomeClassificationTypeValueObject_TransactionItemClassification_IncomeClassificationTypes = null;
this.InventoryManagementBO_Res_ASSOC_InvoiceTypeValueObject_TransactionItemClassification_InvoiceType = null;
this.InventoryManagementBO_Res_ASSOC_TaxCategoryValueObject_GoodBase_WithheldPercentCategory = null;
this.InventoryManagementBO_Res_ASSOC_VatCategoryValueObject_GoodBase_VATCategory = null;
this.InventoryManagementBO_Res_ASSOC_VatExemptionCategoryValueObject_GoodBase_VATExemptionCategory = null;
this.InventoryManagementBO_Res_ASSOC_BudgetItem_GoodBase_IncomeBudgetItems = null;
this.InventoryManagementBO_Res_ASSOC_MeasurementUnitValueObject_Good_MeasurementUnitValueObject = null;
this.InventoryManagementBO_Res_ASSOC_BusinessEntity_GoodCategory_Entity = null;
this.InventoryManagementBO_Res_ASSOC_GoodCategory_Good_GoodCat = null;
this.InventoryManagementBO_Res_ASSOC_GoodCategory_Children_GoodCategory_Parent = null;
this.InventoryManagementBO_Res_ASSOC_AadeBookInvoiceType_GoodTransferTransaction_Invoice = null;
this.InventoryManagementBO_Res_ASSOC_Warehouse_GoodPlacementDTO_Warehouse = null;
this.InventoryManagementBO_Res_ASSOC_Good_TransactionPlacementDTO_Good = null;
this.InventoryManagementBO_Res_ASSOC_TransactionPlacementDTO_GoodPlacements_GoodPlacementDTO_TransactionPlacementDTO = null;
this.InventoryManagementBO_Res_ASSOC_BusinessEntity_GoodPhysicalInventory_Entity = null;
this.InventoryManagementBO_Res_ASSOC_Good_GoodPhysicalInventoryGood_Good = null;
this.InventoryManagementBO_Res_ASSOC_Warehouse_GoodPhysicalInventoryWarehouse_Warehouse = null;
this.InventoryManagementBO_Res_ASSOC_PackagingUnitValueObject_Good_PackagingUnitValueObject = null;
this.InventoryManagementBO_Res_ASSOC_BudgetItem_GoodBase_ExpenseBudgetItems = null;
this.InventoryManagementBO_Res_ASSOC_GoodCategory_Good_GoodSubCat = null;
this.Res_ENUM_GoodTransactionType_Purchase = null;
this.Res_ENUM_GoodTransactionType_Sale = null;
this.Res_ENUM_GoodTransactionType_Internal = null;
this.Res_ENUM_GoodTransactionType_PhysicalInventory = null;
this.Res_ENUM_GoodStockType_Available = null;
this.Res_ENUM_GoodStockType_Reserved = null;
this.Res_ENUM_GoodStockType_AtSupplier = null;
this.Res_ENUM_TransactionItemType_Good = null;
this.Res_ENUM_TransactionItemType_Service = null;
this.Res_ENUM_TransactionItemType_Other = null;
this.Res_ENUM_TransactionItemType_Asset = null;
this.InventoryManagementBO_RES_NEGATIVE_STOCK = null;
this.InventoryManagementBO_RES_NO_TRANSFERS = null;
this.InventoryManagementBO_RES_STOCK_EXCEEDS_INVOICE = null;
this.InventoryManagementBO_RES_DUPLICATE_TRANSFERS = null;
this.InventoryManagementBO_RES_NULL_WAREHOUSE = null;
this.InventoryManagementBO_RES_NULL_GOOD = null;
this.InventoryManagementBO_RES_GOOD_NO_TRACK_STOCK = null;
this.InventoryManagementBO_RES_DUPLICATE_WAREHOUSES = null;
this.InventoryManagementBO_RES_NULL_COST = null;
this.InventoryManagementBO_RES_NULL_REFERENCE_DATE = null;
this.InventoryManagementBO_RES_DUPLICATE_GOODS = null;
this.InventoryManagementBO_QUANTITY_SUM_UNEQUAL = null;
this.InventoryManagementBO_RES_NEGATIVE_QUANTITY = null;
this.InventoryManagementBO_RES_INVENTORY_NAME = null;
this.InventoryManagementBO_RES_PACKAGING_UNIT_NAME_EMPTY = null;
this.InventoryManagementBO_RES_PACKAGING_UNIT_MULTIPLIER_NEGATIVE = null;
this.InventoryManagementBO_RES_PACKAGING_UNIT_UNIT_OR_PARENT = null;
this.InventoryManagementBO_RES_GOOD_CATEGORY_EMPTY_CODE = null;
this.InventoryManagementBO_RES_GOOD_CATEGORY_NAME_EMPTY = null;
this.CommonBO_Res_ASSOC_Country_Address_Country = null;
this.CommonBO_Res_ASSOC_Region_Address_Region = null;
this.CommonBO_Res_ASSOC_FileData_FileUpload_File = null;
this.CommonBO_Res_ASSOC_City_Address_City_ = null;
this.Res_ENUM_PaymentMethodType_Cash = null;
this.Res_ENUM_PaymentMethodType_Check = null;
this.Res_ENUM_PaymentMethodType_BankTransfer = null;
this.Res_ENUM_NoteEntity_SpendingRequestDetail = null;
this.Res_ENUM_NoteEntity_InvoiceDetail = null;
this.Res_ENUM_RoundingMethod_Closest = null;
this.Res_ENUM_RoundingMethod_Ceil = null;
this.Res_ENUM_RoundingMethod_Floor = null;
this.Res_ENUM_InstitutionType_VocationalEducation = null;
this.Res_ENUM_InstitutionType_BasicEducation = null;
this.Res_ENUM_InstitutionType_CertificationOrganization = null;
this.CommonBO_RES_CUSTOM_BANC_ACCOUNT_TYPE_CURRENT = null;
this.CommonBO_RES_CUSTOM_BANC_ACCOUNT_TYPE_SAVINGS = null;
this.CommonBO_RES_CUSTOM_MONEY_TRANSACTION_TYPE_WITHDRAW = null;
this.CommonBO_RES_CUSTOM_MONEY_TRANSACTION_TYPE_DEPOSIT = null;
this.CommonBO_MASS_IMPORT_COMPLETE = null;
this.CommonBO_MASS_IMPORT_PARENT = null;
this.CommonBO_MASS_IMPORT_COUNTRY_NO = null;
this.CommonBO_MASS_IMPORT_COUNTRY_ENGLISH_NO = null;
this.CommonBO_MASS_IMPORT_COUNTRY_CODE_LENGTH = null;
this.CommonBO_MASS_IMPORT_COUNTRY_CODE_NO = null;
this.CommonBO_MASS_IMPORT_TAXOFFICE_NAME_NO = null;
this.CommonBO_MASS_IMPORT_TAXOFFICE_CODE_NO = null;
this.CommonBO_MASS_IMPORT_TAXOFFICE_NUMERICALCODE_NO = null;
this.BusinessEntityBO_Res_ASSOC_Department_Children_Department_Parent = null;
this.BusinessEntityBO_Res_ASSOC_ContactDetails_Department_ContactDetails = null;
this.BusinessEntityBO_Res_ASSOC_ContactDetails_BusinessEntity_ContactDetails = null;
this.BusinessEntityBO_Res_ASSOC_TaxOffice_BusinessEntity_TaxOffice = null;
this.BusinessEntityBO_Res_ASSOC_BusinessEntityType_BusinessEntity_Type = null;
this.BusinessEntityBO_Res_ASSOC_Country_BusinessEntity_Country = null;
this.BusinessEntityBO_Res_ASSOC_SIC_BusinessEntitySIC_SIC = null;
this.BusinessEntityBO_Res_ASSOC_Employee_DepartmentSupervisorReplaceRule_Replacement = null;
this.BusinessEntityBO_Res_ASSOC_Employee_Department_ReplacementSupervisor = null;
this.Res_ENUM_BusinessEntityStatus_Active = null;
this.Res_ENUM_BusinessEntityStatus_UnderLiquidation = null;
this.Res_ENUM_BusinessEntityStatus_Disabled = null;
this.Res_ENUM_BusinessEntityStatus_Nothing = null;
this.Res_ENUM_BusinessEntityKind_Company = null;
this.Res_ENUM_BusinessEntityKind_Group = null;
this.Res_ENUM_BusinessEntityKind_Branch = null;
this.Res_ENUM_BusinessEntityKind_Nothing = null;
this.Res_ENUM_AccountingBookType_Level1 = null;
this.Res_ENUM_AccountingBookType_Level2 = null;
this.Res_ENUM_AccountingBookType_Level3 = null;
this.Res_ENUM_AccountingBookType_Nothing = null;
this.Res_ENUM_RepresentativesType_Technitian = null;
this.Res_ENUM_RepresentativesType_Doctor = null;
this.BusinessEntityBO_RES_CIRCULAR_DEPARTMENT_REFERENCE = null;
this.BusinessEntityBO_MASS_IMPORT_WORK_POSITION_START_DATE = null;
this.BusinessEntityBO_MASS_IMPORT_COMPLETE = null;
this.BusinessEntityBO_EmployeeBO_MASS_IMPORT_SENIORITY_LEVEL = null;
this.BusinessEntityBO_MASS_IMPORT_Department_NO = null;
this.BusinessEntityBO_MASS_IMPORT_Code_NO = null;
this.BusinessEntityBO_MASS_IMPORT_WorkPosition_NO = null;
this.BusinessEntityBO_MASS_IMPORT_D_NO = null;
this.BusinessEntityBO_MASS_IMPORT_From = null;
this.BusinessEntityBO_MASS_IMPORT_To = null;
this.BusinessEntityBO_MASS_IMPORT_DepPosType = null;
this.BusinessEntityBO_MASS_IMPORT_EmployeeCat = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_DEPARTMENT_NO = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_WORK_POSITION_NO = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_TITLE_NO = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_DEPARTMENT = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_WORK_POSITION = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_TITLE = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_FROM = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_TO = null;
this.BusinessEntityBO_MASS_IMPORT_DEP_POSITION_TYPE = null;
this.BusinessEntityBO_MASS_IMPORT_IMPORT_DEP_EMPLOYEE_CATEGORY = null;
this.BusinessEntityBO_MASS_IMPORT_NAME_NO = null;
this.BusinessEntityBO_MASS_IMPORT_POSITIONS_NO = null;
this.BusinessEntityBO_MASS_IMPORT_ENTITY_NO = null;
this.BusinessEntityBO_MASS_IMPORT_ENTITY = null;
this.BusinessEntityBO_MASS_IMPORT_DEPCAT = null;
this.BusinessEntityBO_MASS_IMPORT_COSTCENTER = null;
this.BusinessEntityBO_MASS_IMPORT_SUPERVISOR = null;
this.BusinessEntityBO_MASS_IMPORT_SUPERVISORREP = null;
this.BusinessEntityBO_MASS_IMPORT_IMPORT_TECHNOLOGY = null;
this.BusinessEntityBO_Technology_MASS_IMPORT_COMPLETE = null;
this.BusinessEntityBO_BusinessEntityType_MASS_IMPORT_COMPLETE = null;
this.BusinessEntityBO_SeniorityLevel_MASS_IMPORT_COMPLETE = null;
this.BusinessEntityBO_DUTIESRESPONSIBILITIES_MASS_IMPORT_COMPLETE = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_COMPLETE = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_NAME_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_SHORTNAME_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_KIND_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_COUNTRY_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_STREET_NAME_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_STREET_NUMBER_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_CITY_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_POSTALCODE_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_TAXOFFICE_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_TAXNUMBER_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_BOOKTYPE_NO = null;
this.BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_AME_NO = null;
this.BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_COMPANY_TYPE = null;
this.BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_COUNTRY = null;
this.BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_START_DATE = null;
this.BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_ADMIN_START_PERIOD = null;
this.BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_ADMIN_END_PERIOD = null;
this.BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_TAX_OFFICE = null;
this.BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_BOOK_TYPE = null;
this.BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_PARENT = null;
this.EmployeeBO_Res_ASSOC_Country_Employee_DocumentIssueCountry = null;
this.EmployeeBO_Res_ASSOC_Country_Employee_Citizenship = null;
this.EmployeeBO_Res_ASSOC_Country_Employee_Nationality = null;
this.EmployeeBO_Res_ASSOC_Bank_Employee_Bank = null;
this.EmployeeBO_Res_ASSOC_TaxOffice_Employee_TaxOffice = null;
this.EmployeeBO_Res_ASSOC_Address_Employee_Address = null;
this.EmployeeBO_Res_ASSOC_UserAccount_Employee_Employee_UserAccount = null;
this.Res_ENUM_Gender_Male = null;
this.Res_ENUM_Gender_Female = null;
this.Res_ENUM_Gender_Other = null;
this.Res_ENUM_FamilyStatus_Single = null;
this.Res_ENUM_FamilyStatus_Married = null;
this.Res_ENUM_FamilyStatus_Divorced = null;
this.Res_ENUM_FamilyStatus_Widowed = null;
this.Res_ENUM_DocumentType_IdCard = null;
this.Res_ENUM_DocumentType_Passport = null;
this.Res_ENUM_Relationship_Child = null;
this.Res_ENUM_Relationship_Spouse = null;
this.Res_ENUM_Relationship_Parent = null;
this.Res_ENUM_Relationship_Sibling = null;
this.Res_ENUM_MilitaryObligations_Yes = null;
this.Res_ENUM_MilitaryObligations_No = null;
this.Res_ENUM_MilitaryObligations_NotRequired = null;
this.Res_ENUM_CEFRLevel_A1 = null;
this.Res_ENUM_CEFRLevel_A2 = null;
this.Res_ENUM_CEFRLevel_B1 = null;
this.Res_ENUM_CEFRLevel_B2 = null;
this.Res_ENUM_CEFRLevel_C1 = null;
this.Res_ENUM_CEFRLevel_C2 = null;
this.Res_ENUM_DepMemberEducation_No = null;
this.Res_ENUM_DepMemberEducation_SecondStep = null;
this.Res_ENUM_DepMemberEducation_ThirdStep = null;
this.Res_ENUM_GroupEmployeeStatus_Active = null;
this.Res_ENUM_GroupEmployeeStatus_InActive = null;
this.Res_ENUM_RequestStates_Request = null;
this.Res_ENUM_RequestStates_Approved = null;
this.Res_ENUM_RequestStates_Rejected = null;
this.Res_ENUM_RequestStates_Correction = null;
this.Res_ENUM_HRState_Complete = null;
this.Res_ENUM_HRState_Uncomplete = null;
this.Res_ENUM_FMY_Full = null;
this.Res_ENUM_FMY_Half = null;
this.Res_ENUM_FMY_None = null;
this.EmployeeBO_RES_CUSTOM_ID = null;
this.EmployeeBO_MASS_IMPORT_COMPLETE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_FIRST = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_LAST = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_FATHER = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_MOTHER = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_BIRTHDATE_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_BIRTHDATE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_NATIONALITY = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DEFERRAL_EXPIRES = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_CITIZENSHIP = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DEFERRAL_EXPIRES_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_POSTAL_CODE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_STREETNAME = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_STREETNUM = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_COUNTRY_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_COUNTRY = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_CITY = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_POSTAL_CODE_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_REGION = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_MOBILE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_PHONE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_EMAIL = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_EMAIL_BUSINESS = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_ISSUE_DATE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_ISSUE_COUNTRY = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_TAX_OFFICE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_TAX_NUMBER = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_FIRST_INSURANCE_DATE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_ALLOWANCE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_WORK_PERMIT_FROM = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_WORK_PERMIT_TO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_WORK_PERMIT_COUNTRY = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_RELATIONSHIP = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_GENDER = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_PRIVATE_INSURANCE_START = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_PRIVATE_INSURANCE_EXPIRES = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_EDUCATION_START = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_LANGUAGE_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_LANGUAGE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_INSTITUTION = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_OBTAINING_DATE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_EXPIRE_DATE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DIRECTION = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_LEVEL = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_GRADUATION_DATE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_VOCATIONAL_EDUCATION_FROM = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_VOCATIONAL_EDUCATION_TO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DOMAIN = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_PASTWORK_DATEFROM = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_PASTWORK_DATETO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_PASTWORK_PROJECT_DATETO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_PASTWORK_PROJECT_DATEFROM = null;
this.EmployeeBO_MASS_IMPORT_PASTWORK_COMPANY_NO = null;
this.EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_EMPLOYEE = null;
this.EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_COMPANY = null;
this.EmployeeBO_MASS_IMPORT_PASTWORK_CODE_NO = null;
this.EmployeeBO_MASS_IMPORT_CONTRACTNAME = null;
this.EmployeeBO_MASS_IMPORT_CONTRACT = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_MOBILE_BUSINESS = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_INTERNAL_PHONE = null;
this.EmployeeBO_MASS_IMPORT_WORK_FULLNAME_NO = null;
this.EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_FULLNAME = null;
this.EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_MEMBERROLE = null;
this.EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_PROJECT = null;
this.EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_CHARACTERIAZATION = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DATEFROM = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DATETO = null;
this.EmployeeBO_RES_CIRCULAR_PROJECTWORKEXPERIENCE_REFERENCE = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DEPMEMBER_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_VOCATIONALEDUCATION_NO = null;
this.EmployeeBO_MASS_IMPORT_DEPMEMBER_NAME = null;
this.EmployeeBO_MASS_IMPORT_LANGUAGE_NAME = null;
this.EmployeeBO_MASS_IMPORT_DIPLOMATITLE_NAME = null;
this.EmployeeBO_MASS_IMPORT_FOREIGNLANGUAGE = null;
this.EmployeeBO_MASS_IMPORT_CERTIFICATION_DOCUMENT_TYPE = null;
this.EmployeeBO_MASS_IMPORT_VOCATIONALEDU_DOC_PATH_NO = null;
this.EmployeeBO_MASS_IMPORT2_VOCATIONALEDUCATION_VOCEDU = null;
this.EmployeeBO_MASS_IMPORT_VOCEDUCATION_NAME_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_TITLENAME_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_TITLENAME = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_PATH_NO = null;
this.EmployeeBO_MASS_IMPORT_EMPLOYEE_CITY_ = null;
this.BudgetBO_Res_ASSOC_BudgetItem_BudgetDetail_BudgetItem = null;
this.BudgetBO_Res_ASSOC_BudgetDetail_Adjustments_BudgetAdjustmentDetail_BudgetDetail = null;
this.BudgetBO_Res_ASSOC_Budget_Modifications_BudgetAdjustment_Budget = null;
this.BudgetBO_Res_ASSOC_BusinessEntity_Budget_Entity = null;
this.BudgetBO_Res_ASSOC_ERPFiscalYear_Budget_FiscalYear = null;
this.BudgetBO_Res_ASSOC_BusinessEntity_BudgetItemCategory_Entity = null;
this.BudgetBO_Res_ASSOC_BusinessEntity_BudgetAdjustment_BusinessEntity = null;
this.BudgetBO_Res_ASSOC_BudgetDetail_BudgetDetailTransaction_BudgetDetail = null;
this.BudgetBO_Res_ASSOC_Budget_BudgetTransaction_Budget = null;
this.BudgetBO_Res_ASSOC_BudgetItem_BudgetAdjustmentDetail_BudgetItem = null;
this.BudgetBO_Res_ASSOC_TransactionEntity_BudgetTransaction_TransactionEntity = null;
this.Res_ENUM_BudgetStatus_Draft = null;
this.Res_ENUM_BudgetStatus_Approved = null;
this.Res_ENUM_BudgetStatus_Rejected = null;
this.Res_ENUM_BudgetStatus_Submited = null;
this.Res_ENUM_BudgetStatus_Canceled = null;
this.Res_ENUM_BudgetDetailTransactionType_Approval = null;
this.Res_ENUM_BudgetDetailTransactionType_Adjustment = null;
this.Res_ENUM_BudgetDetailTransactionType_Request = null;
this.Res_ENUM_BudgetDetailTransactionType_Invoicing = null;
this.Res_ENUM_BudgetDetailTransactionType_ReleaseRemainingAmount = null;
this.Res_ENUM_BudgetDetailTransactionType_Cancelation = null;
this.Res_ENUM_BudgetDetailTransactionType_Order = null;
this.Res_ENUM_BudgetDetailTransactionType_Payment = null;
this.Res_ENUM_BudgetDetailTransactionType_Issue = null;
this.Res_ENUM_BudgetEntity_Budget = null;
this.Res_ENUM_BudgetEntity_BudgetAdjustment = null;
this.Res_ENUM_BudgetEntity_SpendingRequest = null;
this.Res_ENUM_BudgetEntity_Invoice = null;
this.Res_ENUM_BudgetEntity_PaymentOrder = null;
this.Res_ENUM_BudgetEntity_Payment = null;
this.Res_ENUM_BudgetEntity_IncomeReceipt = null;
this.Res_ENUM_BudgetEntity_SettlementPaymentOrder = null;
this.BudgetBO_RES_EXCEPTION_BUDGET_CANNOT_SUBMIT = null;
this.BudgetBO_RES_EXCEPTION_BUDGET_CANNOT_APPROVE = null;
this.BudgetBO_RES_EXCEPTION_BUDGET_ALREADY_SUBMITTED = null;
this.BudgetBO_RES_EXCEPTION_BUDGET_CANNOT_SUBMIT_APPROVED_BUDGET_EXISTS = null;
this.BudgetBO_RES_EXCEPTION_BUDGET_CANNOT_DRAFT = null;
this.AssetManagementBO_Res_ASSOC_AssetCategory_Asset_Category = null;
this.AssetManagementBO_Res_ASSOC_Department_Asset_Department = null;
this.AssetManagementBO_Res_ASSOC_Department_Asset_Direction = null;
this.AssetManagementBO_Res_ASSOC_AssetDepreciationCategory_Asset_AccountingDepreciationCategory = null;
this.AssetManagementBO_Res_ASSOC_AssetDepreciationCategory_Asset_TaxDepreciationCategory = null;
this.AssetManagementBO_Res_ASSOC_TransactionEntity_Asset_Supplier = null;
this.AssetManagementBO_Res_ASSOC_AssetDepreciationRate_Asset_DepreciationRate = null;
this.AssetManagementBO_Res_ASSOC_AssetDepreciationRate_AssetCategory_DepreciationRate = null;
this.AssetManagementBO_Res_ASSOC_VatCategoryValueObject_Asset_VATRate = null;
this.AssetManagementBO_Res_ASSOC_AssetGroup_Asset_AssetGroup = null;
this.AssetManagementBO_Res_ASSOC_AssetResponsible_Asset_AssetResponsible = null;
this.AssetManagementBO_Res_ASSOC_BusinessEntity_AssetGroup_Entity = null;
this.AssetManagementBO_Res_ASSOC_BusinessEntity_AssetResponsible_Entity = null;
this.Res_ENUM_AssetType_Fixed = null;
this.Res_ENUM_AssetType_RealEstateBuilding = null;
this.Res_ENUM_AssetType_Intangible = null;
this.Res_ENUM_AssetType_RealEstateLand = null;
this.Res_ENUM_AssetType_UnderConstruction = null;
this.Res_ENUM_AssetStatus_Initialized = null;
this.Res_ENUM_AssetStatus_Acquired = null;
this.Res_ENUM_AssetStatus_Destructed = null;
this.Res_ENUM_AssetStatus_Sold = null;
this.Res_ENUM_AssetStatus_Depreciated = null;
this.Res_ENUM_UnitOfMeasurement_Piece = null;
this.Res_ENUM_UnitOfMeasurement_Meter = null;
this.Res_ENUM_UnitOfMeasurement_SquareMeter = null;
this.AssetManagementBO_ASSET_ALREADY_ACQUIRED = null;
this.AssetManagementBO_RES_ASSET_DEPRECIATED = null;
this.AssetManagementBO_DEPRECIATION_NEWER_DATE = null;
this.AssetManagementBO_ASSET_NON_DEPRECIABLE = null;
this.AssetManagementBO_RES_ASSET_DELETE_HAS_TRANSACTIONS = null;
this.AssetManagementBO_RES_ASSET_DELETE_HAS_SUBASSETS = null;
this.PayrollDataBO_Res_ASSOC_EmployeeContract_EmployeePayroll_Contract = null;
this.PayrollDataBO_Res_ASSOC_SalaryRule_PayrollSalaryDetail_Salary = null;
this.PayrollDataBO_Res_ASSOC_ContributionRule_PayrollContributionDetail_Rule = null;
this.PayrollDataBO_Res_ASSOC_ExternalSalaryType_PayrollContributionDetail_SalaryType = null;
this.PayrollDataBO_Res_ASSOC_Employee_Payments_EmployeePayroll_Employee = null;
this.PayrollDataBO_Res_ASSOC_BusinessEntity_Payroll_Entity = null;
this.PayrollDataBO_Res_ASSOC_AadeBookInvoiceType_Payroll_AdvanceInvoice = null;
this.PayrollDataBO_Res_ASSOC_PaymentOrder_Payroll_AdvancePaymentOrder = null;
this.PayrollDataBO_Res_ASSOC_PaymentOrder_Payroll_PaymentOrder = null;
this.PayrollDataBO_Res_ASSOC_BankAccount_Payroll_BankAccount = null;
this.PayrollDataBO_Res_ASSOC_PayrollCalculatedExpressionVersion_PayrollSalaryDetail_ExpressionVersion = null;
this.PayrollDataBO_Res_ASSOC_PayrollScaleData_PayrollSalaryDetail_ScaleVersion = null;
this.PayrollDataBO_Res_ASSOC_SalaryDeductionRule_PayrollDeductionDetail_Rule = null;
this.PayrollDataBO_Res_ASSOC_SalaryPeriod_PayrollPeriod_Type = null;
this.PayrollDataBO_Res_ASSOC_SalaryPeriod_PayrollCalculation_Type = null;
this.PayrollDataBO_Res_ASSOC_PayrollPeriod_Calculations_PayrollCalculation_Period = null;
this.PayrollDataBO_Res_ASSOC_PayrollIntegration_PayrollAPDFileExportDetail_PayrollIntegration = null;
this.Res_ENUM_PayrollStatus_Draft = null;
this.Res_ENUM_PayrollStatus_Calculating = null;
this.Res_ENUM_PayrollStatus_Completed = null;
this.Res_ENUM_PayrollStatus_Cancelled = null;
this.Res_ENUM_PayrollStatus_Deleted = null;
this.Res_ENUM_ContractTerminationReasonSystem_None = null;
this.Res_ENUM_ContractTerminationReasonSystem_VoluntaryResignation = null;
this.Res_ENUM_EapPeriods_Item1 = null;
this.Res_ENUM_EapPeriods_Item2 = null;
this.Res_ENUM_EapPeriods_Item3 = null;
this.Res_ENUM_EapPeriods_Item4 = null;
this.Res_ENUM_EapPeriods_Item5 = null;
this.Res_ENUM_EapPeriods_Item6 = null;
this.Res_ENUM_EapPeriods_Item7 = null;
this.Res_ENUM_EapPeriods_Item8 = null;
this.Res_ENUM_EapPeriods_Item9 = null;
this.Res_ENUM_EapPeriods_Item10 = null;
this.Res_ENUM_EapPeriods_Item11 = null;
this.Res_ENUM_EapPeriods_Item12 = null;
this.Res_ENUM_EapPeriods_Item13 = null;
this.Res_ENUM_EapPeriods_Item14 = null;
this.Res_ENUM_EapPeriods_Item15 = null;
this.Res_ENUM_EapIncomeType_Item0 = null;
this.Res_ENUM_EapIncomeType_Item1 = null;
this.Res_ENUM_EapIncomeType_Item2 = null;
this.Res_ENUM_EapIncomeType_Item3 = null;
this.Res_ENUM_EapIncomeType_Item4 = null;
this.Res_ENUM_EapIncomeType_item5 = null;
this.Res_ENUM_EapIncomeType_Item6 = null;
this.Res_ENUM_ApdStatus_Draft = null;
this.Res_ENUM_ApdStatus_Completed = null;
this.PayrollDataBO_RES_Payroll_Cannot_Reopen = null;
this.UserBO_RES_CUSTOM_INVALID_CURRENT_PASSWORD = null;
this.UserBO_RES_CUSTOM_USER_WITH_USERNAME_NOT_FOUND = null;
this.UserBO_RES_CUSTOM_RESET_PASSWORD = null;
this.UserBO_RES_CUSTOM_ClickToReset = null;
this.UserBO_RES_CUSTOM_CopyPaste = null;
this.UserBO_RES_CUSTOM_NO_VALID_EMAIL_FOUND = null;
this.UserBO_RES_CUSTOM_InvalidLink = null;
this.UserBO_RES_CUSTOM_NotFound = null;
this.Res_ENUM_TrialBalanceReportType_UnAdjusted = null;
this.Res_ENUM_TrialBalanceReportType_Adjusted = null;
this.Res_ENUM_TrialBalanceReportType_PostClosing = null;
this.Res_ENUM_TrialBalanceAdjustringHandling_ShowColumn = null;
this.Res_ENUM_TrialBalanceAdjustringHandling_HideColumn = null;
this.Res_ENUM_TrialBalanceAdjustringHandling_HideAndIncludeInPrevBalance = null;
this.Res_ENUM_TrialBalanceColumnTitles_Text = null;
this.Res_ENUM_TrialBalanceColumnTitles_Period = null;
this.Res_ENUM_TrialBalanceColumnTitles_TextAndPeriod = null;
this.Ledger_Res_ASSOC_FiscalPeriod_Ledgers_Ledger_FiscalPeriod = null;
this.Ledger_Res_ASSOC_AccountCategory_ChildAccountCategories_AccountCategory_ParentAccountCategory = null;
this.Ledger_Res_ASSOC_AccountCode_Ledger_AccountCodeRule = null;
this.Ledger_Res_ASSOC_Ledger_SubLedgers_Ledger_ParentLedger = null;
this.Ledger_Res_ASSOC_AccountingBusinessEntity_Ledger_Entity = null;
this.Ledger_Res_ASSOC_Account_Ledger_ParentAccount = null;
this.Res_ENUM_LedgerType_Main = null;
this.Res_ENUM_LedgerType_SubLedger = null;
this.Res_ENUM_AccountCategoryType_None = null;
this.Res_ENUM_AccountCategoryType_Asset = null;
this.Res_ENUM_AccountCategoryType_Liability = null;
this.Res_ENUM_AccountCategoryType_Equity = null;
this.Res_ENUM_AccountCategoryType_LiabilityEquity = null;
this.Res_ENUM_AccountCategoryType_Revenue = null;
this.Res_ENUM_AccountCategoryType_Expense = null;
this.Res_ENUM_AccountCategoryType_IncomeStatement = null;
this.Res_ENUM_AccountCategoryType_CostOfSales = null;
this.Res_ENUM_AccountCategoryType_MemorandumAccounts = null;
this.Ledger_RES_CUSTOM_DEFAULT_LEDGER_EXISTS = null;
this.GeneralJournalTemplate_Res_ASSOC_Ledger_GeneralJournalTemplate_Ledger = null;
this.GeneralJournalTemplate_Res_ASSOC_Account_GeneralJournalTemplateDetail_ParentAccount = null;
this.GeneralJournalTemplate_Res_ASSOC_Account_GeneralJournalTemplateDetail_Account = null;
this.GeneralJournalTemplate_Res_ASSOC_AccountingBusinessEntity_GeneralJournalTemplate_Entity = null;
this.GeneralJournalTemplate_Res_ASSOC_FiscalPeriod_GeneralJournalTemplate_FiscalPeriod = null;
this.GeneralJournalTemplate_Res_ASSOC_AccountingJournal_GeneralJournalTemplate_AccountingJournal = null;
this.GeneralJournalRule_Res_ASSOC_FiscalPeriod_GeneralJournalRule_FiscalPeriod = null;
this.GeneralJournalRule_Res_ASSOC_AccountingEvent_GeneralJournalRule_AccountingEvents = null;
this.GeneralJournalRule_Res_ASSOC_AccountCategory_GeneralJournalRuleDetail_ChartOfAccount_Category = null;
this.GeneralJournalRule_Res_ASSOC_AccountingBusinessEntity_GeneralJournalRule_Entity = null;
this.GeneralJournalRule_Res_ASSOC_AccountingSystemEntity_GeneralJournalRule_BO = null;
this.GeneralJournalRule_Res_ASSOC_Ledger_GeneralJournalRuleEntry_Ledger = null;
this.GeneralJournalRule_Res_ASSOC_AccountingJournal_GeneralJournalRuleEntry_Journal = null;
this.GeneralJournalRule_Res_ASSOC_GeneralJournalRuleField_GeneralJournalRuleConditionLine_Operand1 = null;
this.Res_ENUM_GeneralJournalRuleFieldType_Account = null;
this.Res_ENUM_GeneralJournalRuleFieldType_Collection = null;
this.Res_ENUM_GeneralJournalRuleFieldType_Amount = null;
this.Res_ENUM_GeneralJournalRuleFieldType_Text = null;
this.Res_ENUM_GeneralJournalRuleFieldType_Date = null;
this.Res_ENUM_GeneralJournalRuleFieldType_Currency = null;
this.Res_ENUM_GeneralJournalRuleFieldType_Boolean = null;
this.Res_ENUM_AccountingEqualityOperators_Equals = null;
this.Res_ENUM_AccountingEqualityOperators_NotEquals = null;
this.Res_ENUM_AccountingEqualityOperators_HasValue = null;
this.Res_ENUM_AccountingConditionJoinOperator_AND = null;
this.Res_ENUM_AccountingConditionJoinOperator_OR = null;
this.GeneralJournalRule_FOUND_ENTRY_FINALIZED = null;
this.GeneralJournal_Res_ASSOC_TAccount_GeneralJournalDetail_Account = null;
this.GeneralJournal_Res_ASSOC_FiscalPeriod_GeneralJournal_FiscalPeriod = null;
this.GeneralJournal_Res_ASSOC_AccountingCurrency_GeneralJournal_Currency = null;
this.GeneralJournal_Res_ASSOC_Ledger_GeneralJournal_Ledger = null;
this.GeneralJournal_Res_ASSOC_AccountingEvent_GeneralJournal_AccountingEvent = null;
this.GeneralJournal_Res_ASSOC_AccountingJournal_GeneralJournal_Journal = null;
this.GeneralJournal_Res_ASSOC_AccountingPeriod_GeneralJournal_AccountingPeriod = null;
this.GeneralJournal_Res_ASSOC_AccountingBusinessEntity_GeneralJournal_Entity = null;
this.GeneralJournal_Res_ASSOC_TAccount_SubLedgerEntryDetail_TAccount = null;
this.GeneralJournal_Res_ASSOC_Ledger_SubLedgerEntryDetail_SubLedger = null;
this.Res_ENUM_GeneralJournalType_Transaction = null;
this.Res_ENUM_GeneralJournalType_Opening = null;
this.Res_ENUM_GeneralJournalType_Adjusting = null;
this.Res_ENUM_GeneralJournalType_Closing = null;
this.FiscalPeriod_Res_ASSOC_AccountingBusinessEntity_FiscalPeriod_Entity = null;
this.FiscalPeriod_RES_MULTIPLE_FISCAL_PERIODS_PER_DAY = null;
this.FiscalPeriod_RES_START_DATE_BEFORE_END_DATE = null;
this.FiscalPeriod_RES_OVERLAP_EXISTS = null;
this.FiscalPeriod_RES_NAME_EXISTS = null;
this.FinalizeAccEntries_Res_ASSOC_AccountingBusinessEntity_FinalizeAccEntries_Entity = null;
this.FinalizeAccEntries_Res_ASSOC_UserAccount_FinalizeAccEntries_ExecutedBy = null;
this.AccountRelation_Res_ASSOC_AccountingEvent_AccountRelationDetail_AccountingEvent = null;
this.AccountRelation_Res_ASSOC_TAccount_AccountRelationDetail_DetailAccount = null;
this.AccountRelation_Res_ASSOC_TAccount_AccountRelation_Account = null;
this.AccountRelation_Res_ASSOC_AccountRelationType_AccountRelation_AccountRelationType = null;
this.AccountRelation_Res_ASSOC_Ledger_AccountRelation_Ledger = null;
this.AccountRelation_Res_ASSOC_AccountingJournal_AccountRelation_Journal = null;
this.AccountRelation_Res_ASSOC_AccountingEvent_AccountRelation_AccountingEvent = null;
this.AccountingRule_Res_ASSOC_Account_EntityToAccountItem_Account = null;
this.AccountingRule_Res_ASSOC_AccountingEntityCategoryValue_AccountingCategorySelectedValues_FirstSelectedValue = null;
this.Res_ENUM_AccountSelectionType_SelectSpecific = null;
this.Res_ENUM_AccountSelectionType_SelectParent = null;
this.Res_ENUM_AccountSelectionType_DynamicMappings = null;
this.AccountingEventEntriesTemplate_Res_ASSOC_AccountingEvent_AccountingEventEntriesTemplate_Event = null;
this.AccountingEventEntriesTemplate_Res_ASSOC_FiscalPeriod_AccountingEventEntriesTemplate_FiscalPeriod = null;
this.AccountingEventEntriesTemplate_Res_ASSOC_AccountingCurrency_AccountingEventEntriesTemplate_Currency = null;
this.AccountingEventEntriesTemplate_Res_ASSOC_AccountCategory_AccountingEventAmount_AccountCategory = null;
this.AccountingEventEntriesTemplate_Res_ASSOC_Ledger_AccountingEventAmountGroup_Ledger = null;
this.AccountingEventEntriesTemplate_Res_ASSOC_AccountingJournal_AccountingEventAmountGroup_Journal = null;
this.AccountingEvent_Res_ASSOC_AccountingSystemEntity_AccountingEvent_Entity = null;
this.Res_ENUM_AccountingEventSystemType_NonSystemic = null;
this.Res_ENUM_AccountingEventSystemType_PaymentOrderPayment = null;
this.Res_ENUM_AccountingEventSystemType_PayrollIssue = null;
this.Res_ENUM_AccountingEventSystemType_PayrollAdvance = null;
this.Res_ENUM_AccountingEventSystemType_AssetAcquisition = null;
this.Res_ENUM_AccountingEventSystemType_AssetSale = null;
this.Res_ENUM_AccountingEventSystemType_AssetDestruction = null;
this.Res_ENUM_AccountingEventSystemType_AssetDepreciation = null;
this.Res_ENUM_AccountingEventSystemType_AssetImprovment = null;
this.Res_ENUM_AccountingEventSystemType_AssetLoss = null;
this.Res_ENUM_AccountingEventSystemType_AssetProfit = null;
this.Res_ENUM_AccountingEventSystemType_AssetDepreciationInvoice = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionDepositToAcount = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionWithdrawFromAcount = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionTransferBetweenAccounts = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionPaymentWithCheck = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionPaymentWithBank = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionPaymentWithCash = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionReceiptWithCheck = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionReceiptWithBank = null;
this.Res_ENUM_AccountingEventSystemType_MoneyTransactionReceiptWithCash = null;
this.Res_ENUM_AccountingEventSystemType_SettlementPaymentOrderPayment = null;
this.Res_ENUM_AccountingEventSystemType_CheckIssue = null;
this.Res_ENUM_AccountingEventSystemType_CheckCollect = null;
this.Res_ENUM_AccountingEventSystemType_CheckDeliver = null;
this.Res_ENUM_AccountingEventSystemType_BudgetApproval = null;
this.Res_ENUM_AccountingEventSystemType_IncomeReceiptPayment = null;
this.AccountConsolidationRel_Res_ASSOC_Ledger_AccountConsolidationRelation_SourceLedger = null;
this.AccountConsolidationRel_Res_ASSOC_Ledger_AccountConsolidationRelation_TargetLedger = null;
this.AccountConsolidationRel_Res_ASSOC_FiscalPeriod_AccountConsolidationRelation_FiscalPeriod = null;
this.AccountConsolidationRel_Res_ASSOC_TAccount_AccountConsolidationRelation_TargetAccount = null;
this.AccountConsolidationRel_Res_ASSOC_AccountCategory_AccountConsolidationRelation_SourceAccountCategory = null;
this.Account_Res_ASSOC_Ledger_ChartOfAccounts_Account_Ledger = null;
this.Account_Res_ASSOC_FiscalPeriod_Account_FiscalPeriod = null;
this.Account_Res_ASSOC_Account_ChildChartOfAccounts_Account_ParentChartOfAccount = null;
this.Account_Res_ASSOC_AccountCategory_Account_AccountCategory = null;
this.Account_Res_ASSOC_AccountingEntityCategory_AccountTag_Category = null;
this.Account_Res_ASSOC_AccountingEntityCategoryValue_AccountTag_Value = null;
this.Res_ENUM_AccountSign_Debit = null;
this.Res_ENUM_AccountSign_Credit = null;
this.Res_ENUM_AccountSign_DebitAndCredit = null;
this.Res_ENUM_AccountSign_NoTransactions = null;
this.Account_RES_CUSTOM_SAME_CODE_VALIDATION = null;
this.Account_RES_CUSTOM_LEGER_CODE_VALIDATION = null;
this.ErpBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_PaymentOrderApprovalCondition_PaymentMethod = null;
this.ErpBO_Res_ASSOC_InvoiceTypeValueObject_ERPConfiguration_CancellationInvoiceType = null;
this.ErpBO_Res_ASSOC_DynamicReport_ERPConfiguration_PaymentOrderWithCheckDynamicReport = null;
this.Res_ENUM_ERPMessageType_None = null;
this.Res_ENUM_ERPMessageType_Information = null;
this.Res_ENUM_ERPMessageType_Warning = null;
this.Res_ENUM_ERPMessageType_Error = null;
this.TransactionEntity_Res_ASSOC_Address_TransactionEntity_InvoiceAddress = null;
this.TransactionEntity_Res_ASSOC_BusinessType_TransactionEntity_BusinessType = null;
this.TransactionEntity_Res_ASSOC_ContactDetails_TransactionEntity_MainContactDetails = null;
this.TransactionEntity_Res_ASSOC_BusinessEntity_TransactionEntity_Entity = null;
this.TransactionEntity_Res_ASSOC_AccountingSystemEntityConfig_TransactionEntity_AccountingConfig = null;
this.TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_CustomerCategory = null;
this.TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_SupplierCategory = null;
this.TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_EmployeeCategory = null;
this.TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_CreditorCategory = null;
this.TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_DebtorCategory = null;
this.TransactionEntity_Res_ASSOC_BusinessEntity_TransactionEntityInventoryInvoice_Entity = null;
this.TransactionEntity_Res_ASSOC_TransactionEntity_TransactionEntityInventoryInvoiceDetail_TransactionEntity = null;
this.Res_ENUM_VATStatus_Normal = null;
this.Res_ENUM_VATStatus_Exemption = null;
this.Res_ENUM_VATStatus_Deduction = null;
this.Res_ENUM_VATStatus_WithinEU = null;
this.Res_ENUM_VATStatus_OutEU = null;
this.Res_ENUM_AFMType_Greek = null;
this.Res_ENUM_AFMType_EU = null;
this.Res_ENUM_AFMType_Individual = null;
this.Res_ENUM_AFMType_OutEU = null;
this.Res_ENUM_DocumentStatus_Draft = null;
this.Res_ENUM_DocumentStatus_Issued = null;
this.Res_ENUM_DocumentStatus_Cancelled = null;
this.Res_ENUM_TransactionEntityType_Customer = null;
this.Res_ENUM_TransactionEntityType_Supplier = null;
this.Res_ENUM_TransactionEntityType_Employee = null;
this.Res_ENUM_TransactionEntityType_Creditor = null;
this.Res_ENUM_TransactionEntityType_Debtor = null;
this.Res_ENUM_TransactionEntityType_Treasury = null;
this.TransactionEntity_RES_CODE_EXISTS = null;
this.SpendingRequestBO_Res_ASSOC_BusinessEntity_SpendingRequest_Entity = null;
this.SpendingRequestBO_Res_ASSOC_Budget_SpendingRequest_Budget = null;
this.SpendingRequestBO_Res_ASSOC_BudgetDetail_SpendingRequests_SpendingRequestDetail_Item = null;
this.SpendingRequestBO_Res_ASSOC_ERPFiscalYear_SpendingRequest_FiscalYear = null;
this.SpendingRequestBO_Res_ASSOC_UserAccount_SpendingRequest_ReleasedBy = null;
this.SpendingRequestBO_Res_ASSOC_GoodBase_SpendingRequestDetail_Good = null;
this.SpendingRequestBO_Res_ASSOC_SpendingRequestCategory_SpendingRequest_Category = null;
this.SpendingRequestBO_Res_ASSOC_SpendingRequestSubCategory_SpendingRequest_SubCategory = null;
this.SpendingRequestBO_Res_ASSOC_Department_SpendingRequest_Department = null;
this.SpendingRequestBO_Res_ASSOC_TransactionEntity_SpendingRequest_TransactionEntity = null;
this.SpendingRequestBO_Res_ASSOC_InvoiceRowType_SpendingRequestInvoicing_SpendingRequestInvoicing_InvoiceRow = null;
this.SpendingRequestBO_Res_ASSOC_SpendingRequestDetail_InvoicingInfo_SpendingRequestInvoicing_SpendingRequestDetail = null;
this.SpendingRequestBO_Res_ASSOC_UserAccount_SpendingRequest_Owner = null;
this.SpendingRequestBO_Res_ASSOC_SpendingRequestDetail_NonDeductibleVATInvoicingInfo_SpendingRequestInvoicing_NonDeductibleVATSpendingRequestDetail = null;
this.SpendingRequestBO_Res_ASSOC_Note_SpendingRequestDetail_Note = null;
this.SpendingRequestBO_RES_CUSTOM_CANNOT_RELEASE = null;
this.SpendingRequestBO_RES_CUSTOM_CANNOT_CANCEL = null;
this.SpendingRequestBO_RES_INVOICE = null;
this.SIC_BO_Res_ASSOC_SIC_SICProfessionPackage_SIC = null;
this.SIC_BO_Res_ASSOC_InsuranceProfession_Packages_SICProfessionPackage_InsuranceProfession = null;
this.SIC_BO_Res_ASSOC_InsuranceCoveragePackage_Professions_SICProfessionPackage_InsuranceCoveragePackage = null;
this.SIC_BO_Res_ASSOC_InsuranceCoveragePackage_SpecialInsuranceCaseVersion_FromConveragePackage = null;
this.SIC_BO_Res_ASSOC_InsuranceCoveragePackage_SpecialInsuranceCaseVersion_ToCoveragePackage = null;
this.SIC_BO_Res_ASSOC_SpecialInsuranceCase_MappingCodeConfig_SpecialInsuranceCase = null;
this.Res_ENUM_SIC_System_EFKA = null;
this.Res_ENUM_SIC_System_OAED = null;
this.Res_ENUM_SIC_System_EFORIA = null;
this.Res_ENUM_SIC_System_OSYK = null;
this.Res_ENUM_SIC_PackageType_PublicSector = null;
this.Res_ENUM_SIC_PackageType_PrivateSector = null;
this.Res_ENUM_SIC_PackageType_TEKA = null;
this.PaymentOrderBO_Res_ASSOC_BusinessEntity_PaymentOrder_Entity = null;
this.PaymentOrderBO_Res_ASSOC_TransactionEntity_PaymentOrder_TransactionEntity = null;
this.PaymentOrderBO_Res_ASSOC_ERPFiscalYear_PaymentOrder_FiscalYear = null;
this.PaymentOrderBO_Res_ASSOC_SpendingRequestDetail_PaymentOrderDetails_PaymentOrderDetail_SpendingRequestDetail = null;
this.PaymentOrderBO_Res_ASSOC_TaxCategoryValueObject_PaymentOrderDeductionDetail_TaxCategory = null;
this.PaymentOrderBO_Res_ASSOC_Budget_PaymentOrder_Budget = null;
this.PaymentOrderBO_Res_ASSOC_AadeBookInvoiceType_PaymentOrderInvoices_PaymentOrderInvoice_Invoice = null;
this.PaymentOrderBO_Res_ASSOC_PaymentOrderSeries_PaymentOrder_Series = null;
this.PaymentOrderBO_Res_ASSOC_AadeBookInvoiceType_PaymentOrderDeductionDetail_Invoice = null;
this.Res_ENUM_PaymentOrderType_Normal = null;
this.Res_ENUM_PaymentOrderType_Deductions = null;
this.Res_ENUM_PaymentOrderType_Prepayment = null;
this.PaymentOrderBO_WITHHELD_TAX_WITHOUT_TREASURY = null;
this.PaymentOrderBO_RES_CANNOT_MODIFY_PAYMENT_ORDER_SERIES = null;
this.PaymentOrderBO_RES_PAYMENT_ORDER_SERIES_NAME_EMPTY = null;
this.PaymentOrderBO_RES_PAYMENT_ORDER_MISSING_SERIES = null;
this.PaymentOrderBO_RES_PAYMENT = null;
this.PaymentOrderBO_RES_GENERAL_JOURNAL = null;
this.PaymentOrderBO_RES_VALIDATION_ERRORS = null;
this.PaymentOrderBO_RES_CUSTOM_CANNOT_APPROVE = null;
this.PaymentOrderBO_RES_MONEY_TRANSACTION_IS_MISSING = null;
this.PaymentOrderBO_RES_PAYABLE_AMOUNT_DOES_NOT_MATCH = null;
this.PaymentOrderBO_RES_CUSTOM_PAYMENT_ORDER_WRONG_STATUS = null;
this.PaymentOrderBO_RES_PAYMENT_ORDER = null;
this.CheckBO_Res_ASSOC_BankAccount_Check_BankAccount = null;
this.CheckBO_Res_ASSOC_TransactionEntity_Check_Beneficiary = null;
this.CheckBO_Res_ASSOC_BusinessEntity_Check_Entity = null;
this.CheckBO_Res_ASSOC_Currency_Check_Currency = null;
this.CheckBO_Res_ASSOC_BusinessEntity_Checkbook_Entity = null;
this.CheckBO_Res_ASSOC_BankAccount_Checkbook_BankAccount = null;
this.CheckBO_Res_ASSOC_Checkbook_Checks_Check_Checkbook = null;
this.CheckBO_Res_ASSOC_CheckStatus_Check_Status = null;
this.CheckBO_Res_ASSOC_CheckStatus_CheckTransactionType_SupportedStatusesFrom = null;
this.CheckBO_Res_ASSOC_CheckStatus_CheckTransactionType_StatusAfterTransaction = null;
this.CheckBO_Res_ASSOC_CheckTransactionType_CheckTransaction_Type = null;
this.CheckBO_Res_ASSOC_Check_CheckTransaction_Check = null;
this.CheckBO_Res_ASSOC_Check_ChecksList_ChecksList_Checks = null;
this.CheckBO_Res_ASSOC_CheckStatus_ChecksList_CurrentChecksStatus = null;
this.CheckBO_Res_ASSOC_BusinessEntity_ChecksList_Entity = null;
this.CheckBO_Res_ASSOC_ChecksList_ChecksListTransaction_ChecksList = null;
this.CheckBO_Res_ASSOC_AccountingEvent_CheckTransactionType_AccountingEvent = null;
this.Res_ENUM_CheckType_Income = null;
this.Res_ENUM_CheckType_Expense = null;
this.Res_ENUM_CheckEntityType_Checkbook = null;
this.Res_ENUM_CheckEntityType_SupplierCustomer = null;
this.Res_ENUM_CheckEntityType_Bank = null;
this.Res_ENUM_CheckDigitAlgorithm_None = null;
this.Res_ENUM_CheckDigitAlgorithm_Piraeus1 = null;
this.CheckBO_RES_INSUFFICIENT_BANK_ACCOUNT_BALANCE = null;
this.CheckBO_RES_CHECKBOOK_IS_COMPLETED = null;
this.CheckBO_RES_CHECKBOOK_NUMBER_EMPTY = null;
this.CheckBO_RES_CHECKBOOK_NUMBER_ORDER_EMPTY = null;
this.CheckBO_RES_CHECKBOOK_NUMBER_ORDER_DUPLICATE = null;
this.CheckBO_RES_CHECKBOOK_NUMBER_IS_TOP = null;
this.CheckBO_RES_CHECKBOOK_NUMBER_IS_BOTTOM = null;
this.CheckBO_RES_CHECK_TRANSACTION_ALREADY_FINALIZED = null;
this.CheckBO_RES_CHECK_DELIVERY_TYPE_NOT_SPECIFIED = null;
this.CheckBO_RES_CHECK_ISSUE_TYPE_NOT_SPECIFIED = null;
this.CheckBO_RES_CHECK_IS_CASHED = null;
this.CheckBO_RES_CHECK_TRANSACTION_NOT_VALID_FOR_INCOME = null;
this.CheckBO_RES_CHECK_TRANSACTION_NOT_VALID_FOR_EXPENSE = null;
this.CheckBO_RES_CHECK_TRANSACTION_STATUS_INVALID = null;
this.CheckBO_RES_CUSTOM_CHECK_TRANSACTION_TYPE_STATUS_UNSPECIFIED = null;
this.CheckBO_RES_CHECK_CASHING_TYPE_NOT_SPECIFIED = null;
this.CheckBO_RES_CUSTOM_CHECK_SETTING_DELIVERY_THRESHOLD_NULL = null;
this.CheckBO_RES_CUSTOM_CHECK_SETTING_DELIVERY_THRESHOLD_NEGATIVE = null;
this.CheckBO_RES_NO_ACCOUNTING_EVENT = null;
this.CheckBO_RES_CUSTOM_CHECK_TRANSACTION = null;
this.CheckBO_RES_CHECK_IS_USED = null;
this.CheckBO_RES_CHECKDIGIT_ALGORITHM_NOT_FOUND = null;
this.CheckBO_RES_PIRAEUS_CHECK_DIGIT_INVALID_DIGITS = null;
this.EmployeeContractBO_Res_ASSOC_ContractTerminationReason_EmployeeContract_TerminationReason = null;
this.EmployeeContractBO_Res_ASSOC_BusinessEntity_EmployeeContract_Entity = null;
this.EmployeeContractBO_Res_ASSOC_EmploymentContractTemplate_EmployeeContract_Template = null;
this.EmployeeContractBO_Res_ASSOC_PayrollCalculatedExpression_EmployeeContract_CompensationCalculatedExpression = null;
this.EmployeeContractBO_Res_ASSOC_MainSalary_EmployeeContractMainSalary_Rule = null;
this.EmployeeContractBO_Res_ASSOC_BasicSalary_EmployeeContractBasicSalary_Rule = null;
this.EmployeeContractBO_Res_ASSOC_OtherSalary_EmployeeContractOtherSalary_Rule = null;
this.EmployeeContractBO_Res_ASSOC_ContributionRule_EmployeeContractContribution_Rule = null;
this.EmployeeContractBO_Res_ASSOC_SalaryDeductionRule_EmployeeContractDeduction_Rule = null;
this.EmployeeContractBO_Res_ASSOC_SpecialInsuranceCase_EmployeeContractContribution_SpecialInsuranceCase = null;
this.EmployeeContractBO_Res_ASSOC_Department_EmployeeContract_Department = null;
this.EmployeeContractBO_Res_ASSOC_Employee_EmployeeContract_Supervisor = null;
this.EmployeeContractBO_Res_ASSOC_BusinessEntity_EmployeeContract_Branch = null;
this.EmployeeContractBO_Res_ASSOC_PayrollCategory_EmployeeContract_PayrollCategory = null;
this.EmployeeContractBO_Res_ASSOC_PayrollCategoryLevel_EmployeeContract_PayrollCategoryLevel = null;
this.EmployeeContractBO_Res_ASSOC_PayrollCategory_PayrollCategoryHistoryEntry_PayrollCategory = null;
this.EmployeeContractBO_Res_ASSOC_EmployeeContractContribution_SICProfessionPackage_SICProfessionPackage_EmployeeContractContribution = null;
this.EmployeeContractBO_Res_ASSOC_SalaryPeriod_EmployeeContractSalaryPeriod_SalaryPeriod = null;
this.EmployeeContractBO_Res_ASSOC_CivilServantBranch_PayRollCategory_PayrollCategory_Branch = null;
this.Res_ENUM_Placement_Organic = null;
this.Res_ENUM_Placement_Temporary = null;
this.Res_ENUM_Placement_AdPersonam = null;
this.Res_ENUM_InterviewState_Active = null;
this.Res_ENUM_InterviewState_Complete = null;
this.Res_ENUM_EmploymentProperty_Worker = null;
this.Res_ENUM_EmploymentProperty_Employee = null;
this.Res_ENUM_EmployementSpecialCase_Internship = null;
this.Res_ENUM_EmployementSpecialCase_PrivateAndClosedPublic = null;
this.Res_ENUM_EmployementSpecialCase_PrivateAndWidePublic = null;
this.Res_ENUM_EmploymentResponsiblePosition_None = null;
this.Res_ENUM_EmploymentResponsiblePosition_Executive = null;
this.Res_ENUM_EmploymentResponsiblePosition_SalarySixTimesTheBasic = null;
this.Res_ENUM_EmploymentResponsiblePosition_SalaryEightTimesTheBasic = null;
this.Res_ENUM_ResidencePermitGroup_PermitWithAccessToJobMarket = null;
this.Res_ENUM_ResidencePermitGroup_PermitRequiringApproval = null;
this.Res_ENUM_ResidencePermitGroup_SeasonalWork = null;
this.Res_ENUM_EapContractType_Item1 = null;
this.Res_ENUM_EapContractType_Item2 = null;
this.Res_ENUM_EapContractType_Item3 = null;
this.Res_ENUM_EapContractType_Item4 = null;
this.Res_ENUM_EapContractType_Item5 = null;
this.Res_ENUM_EapContractType_Item6 = null;
this.Res_ENUM_EapContractType_Item7 = null;
this.Res_ENUM_EapContractType_Item8 = null;
this.Res_ENUM_EapContractType_Item9 = null;
this.Res_ENUM_EapContractType_Item10 = null;
this.Res_ENUM_EapContractType_Item11 = null;
this.Res_ENUM_EapContractType_Item12 = null;
this.Res_ENUM_EapContractType_Item13 = null;
this.Res_ENUM_EapContractType_Item14 = null;
this.Res_ENUM_EapContractType_Item15 = null;
this.Res_ENUM_EapContractType_Item16 = null;
this.Res_ENUM_EapContractType_Item18 = null;
this.Res_ENUM_EapContractType_Item19 = null;
this.Res_ENUM_EapContractType_Item20 = null;
this.Res_ENUM_EapContractType_Item21 = null;
this.Res_ENUM_EapContractType_Item22 = null;
this.Res_ENUM_EapContractType_Item23 = null;
this.Res_ENUM_EapContractType_Item24 = null;
this.Res_ENUM_EapContractType_Item25 = null;
this.Res_ENUM_EapContractType_Item26 = null;
this.Res_ENUM_EapContractType_Item27 = null;
this.Res_ENUM_EapContractType_Item28 = null;
this.Res_ENUM_EapContractType_Item29 = null;
this.Res_ENUM_EapContractType_Item30 = null;
this.Res_ENUM_EapContractType_Item31 = null;
this.EmployeeContractBO_MASS_IMPORT_COMPLETE = null;
this.EmployeeContractBO_MASS_IMPORT_EMPLOYEE_CODE_NO = null;
this.EmployeeContractBO_MASS_IMPORT_TEMPLATE_NO = null;
this.EmployeeContractBO_MASS_IMPORT_ENTITY_NO = null;
this.EmployeeContractBO_MASS_IMPORT_DEPARTMENT_NO = null;
this.EmployeeContractBO_MASS_IMPORT_EMPLOYEE_CODE = null;
this.EmployeeContractBO_MASS_IMPORT_TEMPLATE = null;
this.EmployeeContractBO_MASS_IMPORT_ENTITY = null;
this.EmployeeContractBO_MASS_IMPORT_DEPARTMENT = null;
this.EmployeeContractBO_MASS_IMPORT_BRANCH = null;
this.EmployeeContractBO_MASS_IMPORT_POSITION = null;
this.EmployeeContractBO_MASS_IMPORT_EMPLOYEE_SUPERVISOR = null;
this.EmployeeContractBO_MASS_IMPORT_INSITUTION = null;
this.EmployeeContractBO_MASS_IMPORT_STARTDATE = null;
this.EmployeeContractBO_MASS_IMPORT_ENDDATE = null;
this.EmployeeContractBO_MASS_IMPORT_TERMINATION_REASON = null;
this.EmployeeContractBO_MASS_IMPORT_TERMINATION_DATE = null;
this.EmployeeContractBO_MASS_IMPORT_PROFESSION_SPECIALIZATION = null;
this.EmployeeContractBO_MASS_IMPORT_START_DATE_NO = null;
this.EmployeeContractBO_MASS_IMPORT_COST_CENTER = null;
this.EmployeeContractBO_MASS_COST_CENTER_FROM = null;
this.EmployeeContractBO_MASS_COST_CENTER_TO = null;
this.EmployeeContractBO_MASS_IMPORT_FLOOR = null;
this.EmployeeContractBO_MASS_IMPORT_LOCATION = null;
this.EmployeeContractBO_MASS_IMPORT_EMPLOYEE_POSTION = null;
this.EmployeeContractBO_MASS_IMPORT_LOCATION_NO = null;
this.EmployeeContractBO_MASS_IMPORT_FLOOR_NO = null;
this.EmployeeContractBO_MASS_IMPORT_DEPFLOOR_NO = null;
this.EmployeeContractBO_MASS_IMPORT_HAZARD_FROM = null;
this.EmployeeContractBO_MASS_IMPORT_HAZARD_TO = null;
this.EmployeeContractBO_MASS_IMPORT_ELIGIBILITY_FROM = null;
this.EmployeeContractBO_MASS_IMPORT_ELIGIBILITY_TO = null;
this.EmployeeContractBO_MASS_IMPORT_HAZARD_ID = null;
this.EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_PROJECT = null;
this.EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_STARTDATE = null;
this.EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_ENDDATE = null;
this.EmployeeContractBO_MASS_IMPORT_WORK_PROGRAM = null;
this.EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_EMPLOYEE_CODE = null;
this.EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_COMPLETE = null;
this.EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_CUSTOMER_CODE = null;
this.EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_LOCATION_CODE = null;
this.EmployeeContractBO_MASS_IMPORT_DEPARTMENT_FLOOR = null;
this.EmployeeContractBO_MASS_IMPORT_DEPARTMENT_NO_POSITIONS = null;
this.EmployeeContractBO_NonPermanentOver3Years = null;
this.EmployeeContractBO_NonPermanentOver3 = null;
this.IncomeReceiptBO_Res_ASSOC_TransactionEntity_IncomeReceipt_TransactionEntity = null;
this.IncomeReceiptBO_Res_ASSOC_BusinessEntity_IncomeReceipt_Entity = null;
this.IncomeReceiptBO_Res_ASSOC_Budget_IncomeReceipt_Budget = null;
this.IncomeReceiptBO_Res_ASSOC_BudgetDetail_IncomeReceiptDetail_IncomeBudgetDetail = null;
this.IncomeReceiptBO_Res_ASSOC_BudgetDetail_IncomeReceiptDetail_ExpenseBudgetDetail = null;
this.IncomeReceiptBO_Res_ASSOC_ERPFiscalYear_IncomeReceipt_FiscalYear = null;
this.IncomeReceiptBO_Res_ASSOC_UserAccount_IncomeReceipt_IncomeReceipt_CreatedBy = null;
this.IncomeReceiptBO_Res_ASSOC_AadeBookInvoiceType_IncomeReceipt_IncomeReceipt_Documents = null;
this.IncomeReceiptBO_Res_ASSOC_InvoiceRowType_IncomeReceiptDetail_DocumentLine = null;
this.IncomeReceiptBO_RES_SERIES_NAME_EMPTY = null;
this.IncomeReceiptBO_RES_CANNOT_MODIFY_SERIES = null;
this.IncomeReceiptBO_RES_INCOME_RECEIPT = null;
this.SalariesBO_Res_ASSOC_BasicSalary_RelatedBasicSalary_BasicSalary = null;
this.SalariesBO_Res_ASSOC_ExternalSalaryType_SalaryRule_AADECode = null;
this.SalariesBO_Res_ASSOC_ExternalSalaryType_SalaryRule_APDCode = null;
this.SalariesBO_Res_ASSOC_PayrollCalculatedExpression_SalaryRule_TaxTypeCalculatedExpression = null;
this.SalariesBO_Res_ASSOC_PayrollVariable_SalaryRule_ParameterVariable = null;
this.SalariesBO_Res_ASSOC_PayrollVariable_SalaryRule_OutputVariable = null;
this.Res_ENUM_ParameterCalculationMethod_Fixed = null;
this.Res_ENUM_ParameterCalculationMethod_Parameter = null;
this.Res_ENUM_ParameterCalculationMethod_Expression = null;
this.Res_ENUM_ParameterCalculationMethod_Scale = null;
this.Res_ENUM_ParameterCalculationMethod_AutoCalculated = null;
this.Res_ENUM_SystemSalaryPeriod_Basic = null;
this.Res_ENUM_SystemSalaryPeriod_Leave = null;
this.Res_ENUM_SystemSalaryPeriod_Sickness = null;
this.Res_ENUM_SystemSalaryPeriod_EasterBonus = null;
this.Res_ENUM_SystemSalaryPeriod_ChristmassBonus = null;
this.Res_ENUM_SystemSalaryPeriod_Recursive = null;
this.Res_ENUM_SystemSalaryPeriod_Overtime = null;
this.Res_ENUM_SystemSalaryPeriod_BalanceBonus = null;
this.Res_ENUM_SystemSalaryPeriod_LeaveBonus = null;
this.Res_ENUM_SystemSalaryPeriod_LeaveRefund = null;
this.Res_ENUM_SystemSalaryPeriod_DismissalRefund = null;
this.Res_ENUM_SystemSalaryPeriod_PlafonRecursive = null;
this.Res_ENUM_SalaryRuleOpenPeriodHandling_UserValue = null;
this.Res_ENUM_SalaryRuleOpenPeriodHandling_DefinitionValue = null;
this.Res_ENUM_SalaryRuleType_Basic = null;
this.Res_ENUM_SalaryRuleType_Main = null;
this.Res_ENUM_SalaryRuleType_Other = null;
this.Res_ENUM_SalaryHistoricVariableHandlingOption_KeepFirst = null;
this.Res_ENUM_SalaryHistoricVariableHandlingOption_KeepLast = null;
this.Res_ENUM_SalaryHistoricVariableHandlingOption_Average = null;
this.Res_ENUM_SystemSalaryPeriod_DismissalRefundDS = null;
this.PayrollScaleBO_Res_ASSOC_PayrollCategory_PayrollScaleItem_PayrollCategory = null;
this.PayrollScaleBO_Res_ASSOC_PayrollVariable_PayrollScaleData_PayrollVariable = null;
this.Res_ENUM_PayrollScaleValueType_WorkExpirience = null;
this.Res_ENUM_PayrollScaleValueType_NumberOfChildren = null;
this.Res_ENUM_PayrollScaleValueType_PayrollCategory = null;
this.Res_ENUM_PayrollScaleValueType_ManualInput = null;
this.Res_ENUM_PayrollScaleSystemicType_NoneSystemic = null;
this.Res_ENUM_PayrollScaleSystemicType_FMY = null;
this.EmploymentContractBO_Res_ASSOC_EmploymentContractType_EmploymentContractTemplate_ContractType = null;
this.EmploymentContractBO_Res_ASSOC_BasicSalary_EmploymentContractTemplate_BasicSalaries = null;
this.EmploymentContractBO_Res_ASSOC_MainSalary_EmploymentContractTemplate_MainSalaries = null;
this.EmploymentContractBO_Res_ASSOC_OtherSalary_EmploymentContractTemplate_OtherSalaries = null;
this.EmploymentContractBO_Res_ASSOC_SalaryDeductionRule_EmploymentContractTemplate_Deductions = null;
this.EmploymentContractBO_Res_ASSOC_ContributionRule_EmploymentContractTemplate_Contributions = null;
this.EmploymentContractBO_Res_ASSOC_EmployeeContractSalaryPeriod_EmploymentContractTemplate_EmploymentContractTemplate_SalaryPeriodConfig = null;
this.EmploymentContractBO_Res_ASSOC_PayrollCalculatedExpression_EmploymentContractType_TaxTypeCalculatedExpression = null;
this.Res_ENUM_EmploymentRelationshipType_Salaried = null;
this.Res_ENUM_EmploymentRelationshipType_DailySalaried = null;
this.Res_ENUM_EmploymentRelationshipType_HourlySalaried = null;
this.Res_ENUM_EmploymentRelationshipType_SelfEmployment = null;
this.Res_ENUM_EmploymentRelationshipType_ReceiptOfExpense = null;
this.Res_ENUM_EmploymentRelationshipType_Management = null;
this.Res_ENUM_EmploymentRelationshipType_Internship = null;
this.Res_ENUM_EmploymentRelationshipType_Trainee = null;
this.Res_ENUM_EmploymentType_FullTime = null;
this.Res_ENUM_EmploymentType_PartTime = null;
this.Res_ENUM_EmploymentType_Intermitting = null;
this.Res_ENUM_EmploymentType_ByRotation = null;
this.Res_ENUM_EmploymentType_Director = null;
this.Res_ENUM_EmploymentType_Internship = null;
this.Res_ENUM_EmploymentKind_Permanent = null;
this.Res_ENUM_EmploymentKind_FixedTerm = null;
this.Res_ENUM_EmploymentKind_ByProject = null;
this.Res_ENUM_EmploymentKind_SubContract = null;
this.Res_ENUM_EmploymentKind_Internship = null;
this.Res_ENUM_EmploymentKind_Trainee = null;
this.Res_ENUM_EmploymentKind_IDAX = null;
this.Res_ENUM_EmploymentKind_IDOX = null;
this.Res_ENUM_EmploymentKind_Installed = null;
this.Res_ENUM_EmploymentWorkingSchedule_FixedWeekly = null;
this.Res_ENUM_EmploymentWorkingSchedule_ChangeDaily = null;
this.Res_ENUM_EmploymentWorkingSchedule_Free = null;
this.Res_ENUM_EmploymentOpenPeriodCalculation_StartDate = null;
this.Res_ENUM_EmploymentOpenPeriodCalculation_EndDate = null;
this.Res_ENUM_EmploymentOpenPeriodCalculation_Calendar = null;
this.Res_ENUM_BonusPaymentType_Legal = null;
this.Res_ENUM_BonusPaymentType_Full = null;
this.Res_ENUM_CompensationType_Salaried = null;
this.Res_ENUM_CompensationType_DailySalaried = null;
this.Res_ENUM_CompensationType_ByContract = null;
this.Res_ENUM_CompensationType_NoPayment = null;
this.Res_ENUM_WorkingDaysCalculationMethod_Method1 = null;
this.Res_ENUM_WorkingDaysCalculationMethod_Method2 = null;
this.Res_ENUM_WorkingDaysCalculationMethod_Method3 = null;
this.Res_ENUM_APDDailyWageEarner_FiveDays = null;
this.Res_ENUM_APDDailyWageEarner_SixDays = null;
this.Res_ENUM_ParameterType_Days = null;
this.Res_ENUM_ParameterType_Hours = null;
this.Res_ENUM_ParameterType_Fixed = null;
this.Res_ENUM_InsuranceDailySalaryCalculationMethod_Value = null;
this.Res_ENUM_InsuranceDailySalaryCalculationMethod_ValueMultiplier = null;
this.Res_ENUM_InsuranceDailySalaryCalculationMethod_Manual = null;
this.Res_ENUM_InsuranceDailySalaryCalculationMethod_Expression = null;
this.Res_ENUM_MainSalaryTaxType_FMY = null;
this.Res_ENUM_MainSalaryTaxType_Multiplier = null;
this.Res_ENUM_MainSalaryTaxType_Expression = null;
this.Res_ENUM_MainSalaryTaxType_TaxFree = null;
this.Res_ENUM_ExpressionTemplate_Bonus = null;
this.Res_ENUM_ExpressionTemplate_Overtime = null;
this.Res_ENUM_ExpressionTemplate_NonWorkingDay = null;
this.Res_ENUM_ExpressionTemplate_PerQuantity = null;
this.Res_ENUM_ExpressionTemplate_Custom = null;
this.Res_ENUM_OtherSalaryMultiplierA_Fixed = null;
this.Res_ENUM_OtherSalaryMultiplierA_Hours = null;
this.Res_ENUM_OtherSalaryMultiplierA_Days = null;
this.Res_ENUM_OtherSalaryMultiplierA_Quantity = null;
this.Res_ENUM_OtherSalaryMultiplierA_ExpressionType = null;
this.Res_ENUM_OtherSalaryMultiplierB_DailySalary = null;
this.Res_ENUM_OtherSalaryMultiplierB_HourlyRate = null;
this.Res_ENUM_OtherSalaryMultiplierB_Fixed = null;
this.Res_ENUM_OtherSalaryMultiplierB_ExpressionType = null;
this.Res_ENUM_OtherSalaryMultiplierB_Empty = null;
this.Res_ENUM_ExternalSalaryTypeSystem_APD = null;
this.Res_ENUM_ExternalSalaryTypeSystem_AADE = null;
this.Res_ENUM_ExternalSalaryTypeSystem_AADE_BUSINESS = null;
this.Res_ENUM_ExternalSalaryTypeSystem_AADE_DIVIDENT = null;
this.PayrollCalculatedExpressionBO_Res_ASSOC_PayrollCalculatedExpressionVersion_PayrollCalculatedExpression_Data = null;
this.PayrollCalculatedExpressionBO_Res_ASSOC_PayrollVariable_PayrollCalculatedExpression_lstPayrollVariable = null;
this.Res_ENUM_PayrollCalculationFormulaModule_Leaves = null;
this.PayrollCalculatedExpressionBO_MASS_IMPORT_COMPLETE = null;
this.ContributionRulesBO_Res_ASSOC_ContributionRuleCalculation_ContributionRule_EmployeeData = null;
this.ContributionRulesBO_Res_ASSOC_ContributionRuleCalculation_ContributionRule_EmployerData = null;
this.ContributionRulesBO_Res_ASSOC_ContributionRuleCalculationSubsidy_ContributionRuleCalculation_SubsidyRules = null;
this.ContributionRulesBO_Res_ASSOC_SalaryPeriod_ContributionRule_SalaryPeriods = null;
this.ContributionRulesBO_Res_ASSOC_PayrollCalculatedExpression_ContributionRuleCalculationSubsidy_CalculatedExpression = null;
this.ContributionRulesBO_Res_ASSOC_AccountingSystemEntityConfig_ContributionRule_AccountingConfig = null;
this.ContributionRulesBO_Res_ASSOC_PayrollVariable_ContributionRuleCalculation_Variable = null;
this.Res_ENUM_InsuranceOfficeType_EFKA = null;
this.Res_ENUM_InsuranceOfficeType_TEKA = null;
this.Res_ENUM_InsuranceOfficeType_TEA = null;
this.Res_ENUM_InsuranceOfficeType_Private = null;
this.Res_ENUM_ContributionRuleValueUpdateType_CoveragePackage = null;
this.Res_ENUM_ContributionRuleValueUpdateType_Fixed = null;
this.Res_ENUM_ContributionRuleValueUpdateType_Parameter = null;
this.Res_ENUM_ContributionRuleValueUpdateType_Expression = null;
this.Res_ENUM_ContributionRuleCalculationBase_AllSalaries = null;
this.Res_ENUM_ContributionRuleCalculationBase_SpecificSalaries = null;
this.Res_ENUM_ContributionRuleCalculationBase_Imputed = null;
this.SalaryDeductionRuleBO_Res_ASSOC_AccountingSystemEntityConfig_SalaryDeductionRule_AccountingConfig = null;
this.SalaryDeductionRuleBO_Res_ASSOC_PayrollVariable_SalaryDeductionRuleCalculation_PayrollVariable = null;
this.Res_ENUM_ApplyRuleFor_Employee = null;
this.Res_ENUM_ApplyRuleFor_Employer = null;
this.Res_ENUM_ApplyRuleFor_Both = null;
this.SalaryLoanRulesBO_Res_ASSOC_PayrollVariable_SalaryLoanType_PayrollVariable = null;
this.SalaryLoanRulesBO_Res_ASSOC_EmployeeContract_EmployeeSalaryLoan_Contract = null;
this.SalaryLoanRulesBO_Res_ASSOC_SalaryLoanType_EmployeeSalaryLoan_Type = null;
this.SalaryLoanRulesBO_Res_ASSOC_SalaryPeriod_EmployeeSalaryLoanInstalment_SalaryPeriod = null;
this.Res_ENUM_EmployeeSalaryLoanStatus_Pending = null;
this.Res_ENUM_EmployeeSalaryLoanStatus_Approved = null;
this.Res_ENUM_EmployeeSalaryLoanStatus_Canceled = null;
this.SalaryLoanRulesBO_RES_ERROR_AMOUNT_NO_MATCH = null;
this.SalaryLoanRulesBO_RES_ERROR_CANNOT_MODIFY = null;
this.SalaryLoanRulesBO_MASS_IMPORT_COMPLETE = null;
this.SalaryLoanRulesBO_MASS_IMPORT_EMPLOYEE_NO = null;
this.SalaryLoanRulesBO_MASS_IMPORT_TYPE_NO = null;
this.SalaryLoanRulesBO_MASS_IMPORT_AMOUNT_NO = null;
this.SalaryLoanRulesBO_MASS_IMPORT_INSTALLMENTS_NO = null;
this.SalaryLoanRulesBO_MASS_IMPORT_STARTDATE_NO = null;
this.SalaryLoanRulesBO_MASS_IMPORT_EMPLOYEE = null;
this.SalaryLoanRulesBO_MASS_IMPORT_TYPE = null;
this.SalaryLoanRulesBO_MASS_IMPORT_START_DATE = null;
this.SalaryLoanRulesBO_MASS_IMPORT_EMPLOYEE_CONTRACT = null;
this.ViewmodelHelperBO_Res_ASSOC_AssetCategory_CreateGoodDTO_AssetCategory = null;
this.ViewmodelHelperBO_Res_ASSOC_VatCategoryValueObject_CreateGoodDTO_VATRate = null;
this.ViewmodelHelperBO_Res_ASSOC_GoodCategory_CreateGoodDTO_GoodCat = null;
this.Res_ENUM_CreateGoodType_Asset = null;
this.Res_ENUM_CreateGoodType_Good = null;
this.LeaveRuleBO_Res_ASSOC_ErganiLeaveType_LeaveRule_ErganiLeaveType = null;
this.LeaveRuleBO_Res_ASSOC_LeaveRuleType_LeaveRule_LeaveType = null;
this.LeaveRuleBO_Res_ASSOC_LeaveRule_LeaveRule_InheritEntitlementFrom = null;
this.LeaveRuleBO_Res_ASSOC_ApprovalFlow_LeaveRule_ApprovalFlow = null;
this.LeaveRuleBO_Res_ASSOC_DynamicReport_LeaveRule_AcceptanceDocumentTemplate = null;
this.Res_ENUM_LeaveTimeUnit_Days = null;
this.Res_ENUM_LeaveTimeUnit_Hours = null;
this.Res_ENUM_LeaveBalanceCalendar_None = null;
this.Res_ENUM_LeaveBalanceCalendar_Anniversary = null;
this.Res_ENUM_LeaveBalanceCalendar_Calendar = null;
this.Res_ENUM_LeaveSubsidyProvider_EFKA = null;
this.Res_ENUM_LeaveSubsidyProvider_DYPA = null;
this.Res_ENUM_LeaveEntitlementOverbalanceHandling_NotAllowed = null;
this.Res_ENUM_LeaveEntitlementOverbalanceHandling_Warning = null;
this.Res_ENUM_RuleEntitlementMethod_User = null;
this.Res_ENUM_RuleEntitlementMethod_NormalLeave = null;
this.Res_ENUM_RuleEntitlementMethod_Illness = null;
this.LeaveRuleBO_MASS_IMPORT_COMPLETE = null;
this.EmployeeLeaveBO_Res_ASSOC_UserAccount_EmployeeLeaveRequest_RequestedBy = null;
this.EmployeeLeaveBO_Res_ASSOC_LeaveRule_EmployeeLeave_LeaveTypes = null;
this.EmployeeLeaveBO_Res_ASSOC_EmployeeContract_LeaveTypes_EmployeeLeave_EmployeeContract = null;
this.EmployeeLeaveBO_Res_ASSOC_EmployeeLeave_EmployeeLeaveRequest_EmployeeLeave = null;
this.EmployeeLeaveBO_Res_ASSOC_PendingTask_EmployeeLeaveRequest_ActiveTask = null;
this.EmployeeLeaveBO_Res_ASSOC_UserAccount_OvertimeRequest_RequestedBy = null;
this.EmployeeLeaveBO_Res_ASSOC_UserAccount_OvertimeRequest_Assignee = null;
this.EmployeeLeaveBO_Res_ASSOC_UserAccount_OvertimeRequest_HandledBy = null;
this.EmployeeLeaveBO_Res_ASSOC_EmployeeContract_OvertimeRequest_EmployeeContract = null;
this.EmployeeLeaveBO_Res_ASSOC_EmployeeContract_EmployeeWorkingCalendar_Employee = null;
this.EmployeeLeaveBO_Res_ASSOC_LeaveRule_EmployeeLeaveRequest_LeaveRule = null;
this.EmployeeLeaveBO_Res_ASSOC_ApprovalFlowScenario_EmployeeLeaveRequest_ApprovalFlowScenario = null;
this.EmployeeLeaveBO_Res_ASSOC_PayrollVariable_OvertimeRequestType_PayrollVariable = null;
this.EmployeeLeaveBO_Res_ASSOC_OvertimeRequestType_OvertimeRequest_OvertimeType = null;
this.EmployeeLeaveBO_Res_ASSOC_OvertimeErganiType_OvertimeRequest_ErganiType = null;
this.Res_ENUM_LeaveRequestStatus_Temporary = null;
this.Res_ENUM_LeaveRequestStatus_Pending = null;
this.Res_ENUM_LeaveRequestStatus_Validating = null;
this.Res_ENUM_LeaveRequestStatus_Approved = null;
this.Res_ENUM_LeaveRequestStatus_Rejected = null;
this.Res_ENUM_LeaveRequestStatus_Cancelled = null;
this.Res_ENUM_OvertimeType_Overtime = null;
this.Res_ENUM_OvertimeType_Overwork = null;
this.EmployeeLeaveBO_RES_CUSTOM_INVALID_STATUS_TRANSITION = null;
this.EmployeeLeaveBO_RES_CUSTOM_VALIDATION_OVERLAPING_DAYS = null;
this.EmployeeLeaveBO_RES_NOTIFY_LEAVE_APPROVAL = null;
this.EmployeeLeaveBO_RES_NOTIFY_LEAVE_INFORM = null;
this.EmployeeLeaveBO_RES_NOTIFY_LEAVE_ACCEPTED = null;
this.EmployeeLeaveBO_RES_NOTIFY_LEAVE_REJECTED = null;
this.EmployeeLeaveBO_MASS_IMPORT_EMPLOYEE_CONTRACT_NO = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TYPE_CODE_NO = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_DATE_REQUIRED = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_REQUESTED_DATE_NO = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_HOURS_FROM_TO_REQUIRED = null;
this.EmployeeLeaveBO_MASS_IMPORT_COMPLETE = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_EMPLOYEE_CODE_NO = null;
this.EmployeeLeaveBO_RES_WRONG_EMPLOEE_CODE = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TYPE_CODE_REQUIRED = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_HOURS_WRONG = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_FROM_HOURS_WRONG = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TO_HOURS_WRONG = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_FROM_MIN_WRONG = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TO__WRONG = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TIME_WRONG = null;
this.EmployeeLeaveBO_MASS_IMPORT_OVERTIME_ERGANIS_TYPE_WRONG = null;
this.BudgetingReports_Res_ASSOC_MainBudgetingReportLine_MainBudgetingReport_ExpenseTotals = null;
this.BudgetingReports_Res_ASSOC_MainBudgetingReportLine_MainBudgetingReport_IncomeTotals = null;
this.BudgetingReports_Res_ASSOC_MainBudgetingReportLine_MainBudgetingReport_CategoriesTotals = null;
this.AssetDepreciationBO_Res_ASSOC_AssetDepreciationRate_AssetDepreciationCategory_DepreciationRate = null;
this.Res_ENUM_AssetDepreciationType_AccountingBase = null;
this.Res_ENUM_AssetDepreciationType_TaxBase = null;
this.Res_ENUM_AssetDepreciationMethod_Constant = null;
this.Res_ENUM_AssetDepreciationMethod_Decreasing = null;
this.Res_ENUM_AssetDepreciationMethod_Total = null;
this.Res_ENUM_AssetDepreciationPeriodType_Months = null;
this.Res_ENUM_AssetDepreciationPeriodType_Days = null;
this.Res_ENUM_DepreciationStartType_NextMonth = null;
this.Res_ENUM_DepreciationStartType_PurchaseDate = null;
this.Res_ENUM_AssetDepreciationMonthsCalculationType_MonthIsCounted = null;
this.Res_ENUM_AssetDepreciationMonthsCalculationType_MonthIsAlwaysCounted = null;
this.Res_ENUM_AssetDepreciationMonthsCalculationType_MonthIsNeverCounted = null;
this.Res_ENUM_MonthStartType_NextMonth = null;
this.Res_ENUM_MonthStartType_PurchaseDate = null;
this.EntityCodeStructrureBO_Res_ASSOC_BusinessEntity_CodeAssignmentConfiguration_Entity = null;
this.EntityCodeStructrureBO_Res_ASSOC_BusinessEntity_UniqueNumberStorage_Entity = null;
this.EntityCodeStructrureBO_Res_ASSOC_AccountingSystemEntity_CodeAssignmentConfiguration_BO = null;
this.EntityCodeStructrureBO_Res_ASSOC_ERPFiscalYear_UniqueNumberStorage_FiscalYear = null;
this.Res_ENUM_CodeAssignmentSegmentType_AutoIncrement = null;
this.Res_ENUM_CodeAssignmentSegmentType_Manual = null;
this.Res_ENUM_CodeAssignmentSegmentType_Options = null;
this.Res_ENUM_CodeAssignmentSegmentType_HardCoded = null;
this.LongRunningTaskBO_Res_ASSOC_UserAccount_LongRunningTask_StartedBy = null;
this.Res_ENUM_HolidayType_ByLaw = null;
this.Res_ENUM_HolidayType_Company = null;
this.Res_ENUM_HolidayType_Speciality = null;
this.AssetImprovementBO_Res_ASSOC_Asset_AssetImprovement_Asset = null;
this.AssetImprovementBO_Res_ASSOC_Asset_AssetImprovementDetail_SubAsset = null;
this.AssetImprovementBO_Res_ASSOC_ERPFiscalYear_AssetImprovement_ERPFiscalYear = null;
this.GeneralJournalDocumentTemplate_Res_ASSOC_Ledger_GeneralJournalDocumentTemplateLine_Ledger = null;
this.GeneralJournalDocumentTemplate_Res_ASSOC_FiscalPeriod_GeneralJournalDocumentTemplate_FiscalPeriod = null;
this.GeneralJournalDocumentTemplate_Res_ASSOC_AccountingBusinessEntity_GeneralJournalDocumentTemplate_Entity = null;
this.GeneralJournalDocumentTemplate_Res_ASSOC_GeneralJournalTemplateInputGroup_GeneralJournalDocumentTemplateEntry_Group = null;
this.GeneralJournalDocumentTemplate_Res_ASSOC_GeneralJournalTemplateInputGroup_Lines_GeneralJournalTemplateGroupLine_GeneralJournalTemplateInputGroup = null;
this.GeneralJournalDocumentTemplate_Res_ASSOC_GeneralJournalDocumentTemplateEntry_GeneralJournalTemplateFillLine_Definition = null;
this.GeneralJournalDocumentTemplate_Res_ASSOC_Account_GeneralJournalTemplateFillLine_ActualAccount = null;
this.LedgerJournalRuleBO_Res_ASSOC_AccountingBusinessEntity_LedgerJournalRule_Entity = null;
this.LedgerJournalRuleBO_Res_ASSOC_Ledger_LedgerJournalRule_Ledger = null;
this.LedgerJournalRuleBO_Res_ASSOC_AccountingJournal_LedgerJournalRule_SourceJournal = null;
this.LedgerJournalRuleBO_Res_ASSOC_AccountingJournal_LedgerJournalRule_TargetJournal = null;
this.LedgerJournalRuleBO_Res_ASSOC_FiscalPeriod_LedgerJournalRule_FiscalPeriod = null;
this.Res_ENUM_EmailStatus_Initialized = null;
this.Res_ENUM_EmailStatus_Queued = null;
this.Res_ENUM_EmailStatus_Sent = null;
this.Res_ENUM_EmailStatus_Failed = null;
this.UtilitiesBO_RES_EMAIL_ALREADY_QUEUED = null;
this.UtilitiesBO_RES_EMAIL_ALREADY_SENT = null;
this.UtilitiesBO_AMKA_Length = null;
this.UtilitiesBO_AMKA_Date = null;
this.UtilitiesBO_AFM_Invalid = null;
this.UtilitiesBO_AFM_Length = null;
this.UtilitiesBO_RES_AT_LEAST_ONE_DEPENDENCY_CANNOT_BE_DELETED = null;
this.UtilitiesBO_RES_DELETE_DEPENDENCY_NOT_IMPLEMENTED = null;
this.UtilitiesBO_PERSONALNUMBER_Length = null;
this.UtilitiesBO_PERSONALNUMBER_AFMNULL = null;
this.UtilitiesBO_PERSONALNUMBER_WRONG = null;
this.UtilitiesBO_AMKA_Masked = null;
this.AccountingPrintingTemplateBO_Res_ASSOC_AccountingBusinessEntity_AccountingPrintingTemplate_Entity = null;
this.AccountingPrintingTemplateBO_Res_ASSOC_FiscalPeriod_AccountingPrintingTemplate_FiscalPeriod = null;
this.AccountingAllocationRelationBO_Res_ASSOC_AccountingBusinessEntity_AccountingAllocationRelation_Entity = null;
this.AccountingAllocationRelationBO_Res_ASSOC_FiscalPeriod_AccountingAllocationRelation_FiscalPeriod = null;
this.AccountingAllocationRelationBO_Res_ASSOC_Ledger_AccountingAllocationRelation_SourceLedger = null;
this.AccountingAllocationRelationBO_Res_ASSOC_Ledger_AccountingAllocationRelation_TargetLedger = null;
this.AccountingAllocationRelationBO_Res_ASSOC_AccountingJournal_AccountingAllocationRelation_TargetJournal = null;
this.AccountingAllocationRelationBO_Res_ASSOC_TAccount_AccountingAllocationRelationDetail_Account = null;
this.AccountingAllocationRelationBO_Res_ASSOC_TAccount_AccountingAllocationRelation_TAccount = null;
this.TaskManagementBO_Res_ASSOC_UserAccount_PendingTask_AssignedTo = null;
this.TaskManagementBO_Res_ASSOC_BusinessEntity_PendingTask_Entity = null;
this.TaskManagementBO_Res_ASSOC_UserAccount_PendingTask_HandledBy = null;
this.Res_ENUM_PendingTaskType_ApproveLeave = null;
this.Res_ENUM_PendingTaskType_CheckLeaveData = null;
this.Res_ENUM_PendingTaskType_Information = null;
this.Res_ENUM_PendingTaskType_BackoffceSyncFailed = null;
this.Res_ENUM_TaskResultMessageSeverity_Info = null;
this.Res_ENUM_TaskResultMessageSeverity_Warning = null;
this.Res_ENUM_TaskResultMessageSeverity_Error = null;
this.Res_ENUM_PendingTaskType_ApproveResignation = null;
this.AssetTransactionBO_Res_ASSOC_ERPFiscalYear_AssetTransaction_ERPFiscalYear = null;
this.AssetTransactionBO_Res_ASSOC_TransactionEntity_AssetTransaction_Customer = null;
this.AssetTransactionBO_Res_ASSOC_InvoiceRowType_AssetTransactionItem_TransactionDocumentDetail = null;
this.AssetTransactionBO_Res_ASSOC_AssetTransaction_ParentAsset_Asset_AssetTransaction_1 = null;
this.AssetTransactionBO_Res_ASSOC_BusinessEntity_AcquisitionSubsidyEntities_Entity = null;
this.Res_ENUM_AssetTransactionType_Acquisition = null;
this.Res_ENUM_AssetTransactionType_Improvement = null;
this.Res_ENUM_AssetTransactionType_Sale = null;
this.Res_ENUM_AssetTransactionType_Destruction = null;
this.Res_ENUM_AssetTransactionType_Transfer = null;
this.Res_ENUM_AssetTransactionType_Trading = null;
this.Res_ENUM_AssetTransactionType_Settlement = null;
this.Res_ENUM_AssetTransactionType_Adjustment = null;
this.Res_ENUM_AssetTransactionType_Depreciation = null;
this.Res_ENUM_AssetAcquisionType_PurchaseInvoice = null;
this.Res_ENUM_AssetAcquisionType_Donation = null;
this.Res_ENUM_AssetAcquisionType_Expropriation = null;
this.Res_ENUM_AssetAcquisionType_Subsidy = null;
this.Res_ENUM_AssetDestructionType_Destructed = null;
this.Res_ENUM_AssetDestructionType_Lost = null;
this.Res_ENUM_AssetDestructionType_Stolen = null;
this.AssetTransactionBO_RES_SUBSIDY_SUM = null;
this.AssetTransactionBO_RES_ACQUISITION_QUANTITY_POSITIVE = null;
this.AssetTransactionBO_RES_FINALIZED_TRANSACTION = null;
this.AssetTransactionBO_RES_PARTIAL_MUST_BE_INTEGER = null;
this.AssetTransactionBO_RES_PARTIAL_EXCEEDS_QUANTITY = null;
this.AssetTransactionBO_RES_ASSET_NOT_FOUND_IN_INVOICE = null;
this.AssetTransactionBO_RES_QUANTITY_MUST_BE_INT = null;
this.AssetTransactionBO_RES_QUANTITY_MUST_BE_GREATER_THAN_ONE = null;
this.AssetTransactionBO_RES_PARENT_NOT_ALLOWED = null;
this.AssetTransactionBO_RES_SERIALS_CANNOT_HAVE_TWO = null;
this.AssetTransactionBO_RES_SERIALS_MUST_BE_QUANTITY = null;
this.Res_ENUM_SourceType_AADE = null;
this.Res_ENUM_SourceType_ERP = null;
this.Res_ENUM_SourceType_LOCAL = null;
this.Res_ENUM_FCParamValueType_DateTime = null;
this.Res_ENUM_FCParamValueType_Numeric = null;
this.Res_ENUM_FCParamValueType_String = null;
this.ClassificationTypeBO_Res_ASSOC_ExpensesClassificationCategoryValueObject_ExpensesClassificationType_ClassificationCategory = null;
this.ClassificationTypeBO_Res_ASSOC_IncomeClassificationCategoryValueObject_IncomeClassificationType_ClassificationCategory = null;
this.Res_ENUM_ClassificationType_Income = null;
this.Res_ENUM_ClassificationType_Expenses = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_1 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_2 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_3 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_4 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_5 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_6 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_7 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_8 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_9 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_10 = null;
this.Res_ENUM_IncomeClassificationCategoryType_category1_95 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_1 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_2 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_3 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_4 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_5 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_6 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_7 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_8 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_9 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_10 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_11 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_12 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_13 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_14 = null;
this.Res_ENUM_ExpensesClassificationCategoryType_category2_95 = null;
this.ValueList_Res_ASSOC_BudgetItem_TaxCategoryValueObject_IncomeAccount = null;
this.ValueList_Res_ASSOC_BudgetItem_TaxCategoryValueObject_ExpenseAccount = null;
this.ValueList_Res_ASSOC_InvoiceTransactionConfiguration_InvoiceTypeValueObject_IncomeConfiguration = null;
this.ValueList_Res_ASSOC_InvoiceTransactionConfiguration_InvoiceTypeValueObject_ExpensesConfiguration = null;
this.ValueList_Res_ASSOC_InvoiceTransactionConfiguration_InvoiceTypeValueObject_AccountingConfiguration = null;
this.ValueList_Res_ASSOC_AccountingSystemEntityConfig_VatCategoryValueObject_AccountingConfig = null;
this.ValueList_Res_ASSOC_AccountingSystemEntityConfig_TaxCategoryValueObject_AccountingConfig = null;
this.ValueList_Res_ASSOC_TransactionEntity_TaxCategoryValueObject_Treasury = null;
this.ValueList_Res_ASSOC_PaymentMethodDetailTypeValueObject_InvoiceTypeValueObject_DefaultPaymentMethod = null;
this.ValueList_Res_ASSOC_BudgetItem_VatCategoryValueObject_ExpenseBudgetItem = null;
this.Res_ENUM_TaxType_Empty = null;
this.Res_ENUM_TaxType_WithHeld = null;
this.Res_ENUM_TaxType_Fees = null;
this.Res_ENUM_TaxType_OtherTax = null;
this.Res_ENUM_TaxType_StampDuty = null;
this.Res_ENUM_TaxType_Deduction = null;
this.Res_ENUM_CurrencyType_AED = null;
this.Res_ENUM_CurrencyType_AFN = null;
this.Res_ENUM_CurrencyType_ALL = null;
this.Res_ENUM_CurrencyType_AMD = null;
this.Res_ENUM_CurrencyType_ANG = null;
this.Res_ENUM_CurrencyType_AOA = null;
this.Res_ENUM_CurrencyType_ARS = null;
this.Res_ENUM_CurrencyType_AUD = null;
this.Res_ENUM_CurrencyType_AWG = null;
this.Res_ENUM_CurrencyType_AZN = null;
this.Res_ENUM_CurrencyType_BAM = null;
this.Res_ENUM_CurrencyType_BBD = null;
this.Res_ENUM_CurrencyType_BDT = null;
this.Res_ENUM_CurrencyType_BGN = null;
this.Res_ENUM_CurrencyType_BHD = null;
this.Res_ENUM_CurrencyType_BIF = null;
this.Res_ENUM_CurrencyType_BMD = null;
this.Res_ENUM_CurrencyType_BND = null;
this.Res_ENUM_CurrencyType_BOB = null;
this.Res_ENUM_CurrencyType_BOV = null;
this.Res_ENUM_CurrencyType_BRL = null;
this.Res_ENUM_CurrencyType_BSD = null;
this.Res_ENUM_CurrencyType_BTN = null;
this.Res_ENUM_CurrencyType_BWP = null;
this.Res_ENUM_CurrencyType_BYR = null;
this.Res_ENUM_CurrencyType_BZD = null;
this.Res_ENUM_CurrencyType_CAD = null;
this.Res_ENUM_CurrencyType_CDF = null;
this.Res_ENUM_CurrencyType_CHF = null;
this.Res_ENUM_CurrencyType_CLF = null;
this.Res_ENUM_CurrencyType_CLP = null;
this.Res_ENUM_CurrencyType_CNY = null;
this.Res_ENUM_CurrencyType_COP = null;
this.Res_ENUM_CurrencyType_COU = null;
this.Res_ENUM_CurrencyType_CRC = null;
this.Res_ENUM_CurrencyType_CUC = null;
this.Res_ENUM_CurrencyType_CUP = null;
this.Res_ENUM_CurrencyType_CVE = null;
this.Res_ENUM_CurrencyType_CZK = null;
this.Res_ENUM_CurrencyType_DJF = null;
this.Res_ENUM_CurrencyType_DKK = null;
this.Res_ENUM_CurrencyType_DOP = null;
this.Res_ENUM_CurrencyType_DZD = null;
this.Res_ENUM_CurrencyType_EEK = null;
this.Res_ENUM_CurrencyType_EGP = null;
this.Res_ENUM_CurrencyType_ERN = null;
this.Res_ENUM_CurrencyType_ETB = null;
this.Res_ENUM_CurrencyType_EUR = null;
this.Res_ENUM_CurrencyType_FJD = null;
this.Res_ENUM_CurrencyType_FKP = null;
this.Res_ENUM_CurrencyType_GBP = null;
this.Res_ENUM_CurrencyType_GEL = null;
this.Res_ENUM_CurrencyType_GHS = null;
this.Res_ENUM_CurrencyType_GIP = null;
this.Res_ENUM_CurrencyType_GMD = null;
this.Res_ENUM_CurrencyType_GNF = null;
this.Res_ENUM_CurrencyType_GTQ = null;
this.Res_ENUM_CurrencyType_GWP = null;
this.Res_ENUM_CurrencyType_GYD = null;
this.Res_ENUM_CurrencyType_HKD = null;
this.Res_ENUM_CurrencyType_HNL = null;
this.Res_ENUM_CurrencyType_HRK = null;
this.Res_ENUM_CurrencyType_HTG = null;
this.Res_ENUM_CurrencyType_HUF = null;
this.Res_ENUM_CurrencyType_IDR = null;
this.Res_ENUM_CurrencyType_ILS = null;
this.Res_ENUM_CurrencyType_INR = null;
this.Res_ENUM_CurrencyType_IQD = null;
this.Res_ENUM_CurrencyType_IRR = null;
this.Res_ENUM_CurrencyType_ISK = null;
this.Res_ENUM_CurrencyType_JMD = null;
this.Res_ENUM_CurrencyType_JOD = null;
this.Res_ENUM_CurrencyType_JPY = null;
this.Res_ENUM_CurrencyType_KES = null;
this.Res_ENUM_CurrencyType_KGS = null;
this.Res_ENUM_CurrencyType_KHR = null;
this.Res_ENUM_CurrencyType_KMF = null;
this.Res_ENUM_CurrencyType_KPW = null;
this.Res_ENUM_CurrencyType_KRW = null;
this.Res_ENUM_CurrencyType_KWD = null;
this.Res_ENUM_CurrencyType_KYD = null;
this.Res_ENUM_CurrencyType_KZT = null;
this.Res_ENUM_CurrencyType_LAK = null;
this.Res_ENUM_CurrencyType_LBP = null;
this.Res_ENUM_CurrencyType_LKR = null;
this.Res_ENUM_CurrencyType_LRD = null;
this.Res_ENUM_CurrencyType_LSL = null;
this.Res_ENUM_CurrencyType_LTL = null;
this.Res_ENUM_CurrencyType_LVL = null;
this.Res_ENUM_CurrencyType_LYD = null;
this.Res_ENUM_CurrencyType_MAD = null;
this.Res_ENUM_CurrencyType_MDL = null;
this.Res_ENUM_CurrencyType_MGA = null;
this.Res_ENUM_CurrencyType_MKD = null;
this.Res_ENUM_CurrencyType_MMK = null;
this.Res_ENUM_CurrencyType_MNT = null;
this.Res_ENUM_CurrencyType_MOP = null;
this.Res_ENUM_CurrencyType_MRO = null;
this.Res_ENUM_CurrencyType_MUR = null;
this.Res_ENUM_CurrencyType_MVR = null;
this.Res_ENUM_CurrencyType_MWK = null;
this.Res_ENUM_CurrencyType_MXN = null;
this.Res_ENUM_CurrencyType_MYR = null;
this.Res_ENUM_CurrencyType_MZN = null;
this.Res_ENUM_CurrencyType_NAD = null;
this.Res_ENUM_CurrencyType_NGN = null;
this.Res_ENUM_CurrencyType_NIO = null;
this.Res_ENUM_CurrencyType_NOK = null;
this.Res_ENUM_CurrencyType_NPR = null;
this.Res_ENUM_CurrencyType_NZD = null;
this.Res_ENUM_CurrencyType_OMR = null;
this.Res_ENUM_CurrencyType_PAB = null;
this.Res_ENUM_CurrencyType_PEN = null;
this.Res_ENUM_CurrencyType_PGK = null;
this.Res_ENUM_CurrencyType_PHP = null;
this.Res_ENUM_CurrencyType_PKR = null;
this.Res_ENUM_CurrencyType_PLN = null;
this.Res_ENUM_CurrencyType_PYG = null;
this.Res_ENUM_CurrencyType_QAR = null;
this.Res_ENUM_CurrencyType_RON = null;
this.Res_ENUM_CurrencyType_RSD = null;
this.Res_ENUM_CurrencyType_RUB = null;
this.Res_ENUM_CurrencyType_RWF = null;
this.Res_ENUM_CurrencyType_SAR = null;
this.Res_ENUM_CurrencyType_SBD = null;
this.Res_ENUM_CurrencyType_SCR = null;
this.Res_ENUM_CurrencyType_SDG = null;
this.Res_ENUM_CurrencyType_SEK = null;
this.Res_ENUM_CurrencyType_SGD = null;
this.Res_ENUM_CurrencyType_SHP = null;
this.Res_ENUM_CurrencyType_SLL = null;
this.Res_ENUM_CurrencyType_SOS = null;
this.Res_ENUM_CurrencyType_SRD = null;
this.Res_ENUM_CurrencyType_STD = null;
this.Res_ENUM_CurrencyType_SVC = null;
this.Res_ENUM_CurrencyType_SYP = null;
this.Res_ENUM_CurrencyType_SZL = null;
this.Res_ENUM_CurrencyType_THB = null;
this.Res_ENUM_CurrencyType_TJS = null;
this.Res_ENUM_CurrencyType_TMT = null;
this.Res_ENUM_CurrencyType_TND = null;
this.Res_ENUM_CurrencyType_TOP = null;
this.Res_ENUM_CurrencyType_TRY = null;
this.Res_ENUM_CurrencyType_TTD = null;
this.Res_ENUM_CurrencyType_TVD = null;
this.Res_ENUM_CurrencyType_TWD = null;
this.Res_ENUM_CurrencyType_TZS = null;
this.Res_ENUM_CurrencyType_UAH = null;
this.Res_ENUM_CurrencyType_UGX = null;
this.Res_ENUM_CurrencyType_USD = null;
this.Res_ENUM_CurrencyType_UYU = null;
this.Res_ENUM_CurrencyType_UZS = null;
this.Res_ENUM_CurrencyType_VEF = null;
this.Res_ENUM_CurrencyType_VND = null;
this.Res_ENUM_CurrencyType_VUV = null;
this.Res_ENUM_CurrencyType_WST = null;
this.Res_ENUM_CurrencyType_XAF = null;
this.Res_ENUM_CurrencyType_XCD = null;
this.Res_ENUM_CurrencyType_XOF = null;
this.Res_ENUM_CurrencyType_XPD = null;
this.Res_ENUM_CurrencyType_XPF = null;
this.Res_ENUM_CurrencyType_YER = null;
this.Res_ENUM_CurrencyType_ZAR = null;
this.Res_ENUM_CurrencyType_ZMK = null;
this.Res_ENUM_CurrencyType_ZWL = null;
this.AADEBO_Res_ASSOC_InvoiceHeaderType_AadeBookInvoiceType_InvoiceHeader = null;
this.AADEBO_Res_ASSOC_BusinessEntity_AadeBookInvoiceType_Entity = null;
this.AADEBO_Res_ASSOC_TransactionEntity_AadeBookInvoiceType_TransactionEntity = null;
this.AADEBO_Res_ASSOC_TransactionDocumentSeries_InvoiceHeaderType_ERPSeries = null;
this.AADEBO_Res_ASSOC_InvoiceTypeValueObject_InvoiceHeaderType_InvoiceType = null;
this.AADEBO_Res_ASSOC_TaxCategoryValueObject_TaxTotalsType_Tax = null;
this.AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_WithheldPercentCategory = null;
this.AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_StampDutyPercentCategory = null;
this.AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_FeesPercentCategory = null;
this.AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_OtherTaxesPercentCategory = null;
this.AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_DeductionsPercentCategory = null;
this.AADEBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_PaymentMethodDetailType_PaymentMethod = null;
this.AADEBO_Res_ASSOC_Currency_InvoiceHeaderType_Currency = null;
this.AADEBO_Res_ASSOC_VatExemptionCategoryValueObject_InvoiceRowType_VatExemptionCategory = null;
this.AADEBO_Res_ASSOC_VatCategoryValueObject_InvoiceRowType_VatCategory = null;
this.AADEBO_Res_ASSOC_IncomeClassificationCategoryValueObject_InvoiceIncomeClassificationCategory_Category = null;
this.AADEBO_Res_ASSOC_IncomeClassificationTypeValueObject_InvoiceIncomeClassificationCategory_Types = null;
this.AADEBO_Res_ASSOC_ExpensesClassificationCategoryValueObject_InvoiceExpensesClassificationCategory_Category = null;
this.AADEBO_Res_ASSOC_ExpensesClassificationTypeValueObject_InvoiceExpensesClassificationCategory_Types = null;
this.AADEBO_Res_ASSOC_VatCategoryValueObject_InvoiceVATCategoryTotal_VATCategory = null;
this.AADEBO_Res_ASSOC_AadeBookInvoiceType_CorrelatedInvoicesOpposite_AadeBookInvoiceType_CorrelatedInvoices = null;
this.AADEBO_Res_ASSOC_AadeBookInvoiceType_AadeBookInvoiceType_DeliveryNotes = null;
this.AADEBO_Res_ASSOC_Project_AadeBookInvoiceType_Project = null;
this.AADEBO_Res_ASSOC_TaxTotalsType_PaymentOrderDeductionDetail_PaymentOrderDeductionDetail_TaxTotalsType = null;
this.AADEBO_Res_ASSOC_InvoiceRowType_WithheldPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_WithheldInvoiceDetail = null;
this.AADEBO_Res_ASSOC_InvoiceRowType_FeesPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_FeesInvoiceDetail = null;
this.AADEBO_Res_ASSOC_InvoiceRowType_OtherTaxesPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_OtherTaxesInvoiceDetail = null;
this.AADEBO_Res_ASSOC_InvoiceRowType_StampDutyPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_StampDutyInvoiceDetail = null;
this.AADEBO_Res_ASSOC_InvoiceRowType_DeductionsPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_DeductionsInvoiceDetail = null;
this.AADEBO_Res_ASSOC_Cashier_AadeBookInvoiceType_Cashier = null;
this.AADEBO_Res_ASSOC_UserAccount_AadeBookInvoiceType_CanceledBy = null;
this.AADEBO_Res_ASSOC_UserAccount_AadeBookInvoiceType_IssuedBy = null;
this.AADEBO_Res_ASSOC_UserAccount_AadeBookInvoiceType_CreatedBy = null;
this.AADEBO_Res_ASSOC_Cashier_InvoiceCancellation_CancelledBy = null;
this.AADEBO_Res_ASSOC_TransactionDocumentSeries_InvoiceCancellation_Series = null;
this.AADEBO_Res_ASSOC_Note_InvoiceRowType_Note = null;
this.AADEBO_Res_ASSOC_GoodBase_InvoiceRowType_Good = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_101 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_001 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_002 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_003 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_004 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_005 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_006 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_104 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_201 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_001 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_002 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_003 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_004 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_005 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_204 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_207 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_209 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_301 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_001 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_002 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_003 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_004 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_005 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_304 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_307 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_309 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_312 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_001 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_002 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_003 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_004 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_005 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_315 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_581_001 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_581_002 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_581_003 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_582 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_583 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_584 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_001 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_002 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_003 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_004 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_005 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_006 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_007 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_008 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_009 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_010 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_011 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_012 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_013 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_014 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_015 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_016 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_586 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_587 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_588 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_589 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_882_001 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_882_002 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_882_003 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_882_004 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_883_001 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_883_002 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_883_003 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_883_004 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_361 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_362 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_363 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_364 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_365 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_366 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_103 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_203 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_303 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_208 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_308 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_314 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_106 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_205 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_305 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_210 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_310 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_318 = null;
this.Res_ENUM_ExpensesClassificationTypeClassificationType_E3_598_002 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_106 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_205 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_210 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_305 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_310 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_318 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_561_001 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_561_002 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_561_003 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_561_004 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_561_005 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_561_006 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_561_007 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_562 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_563 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_564 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_565 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_566 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_567 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_568 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_570 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_595 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_596 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_597 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_880_001 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_880_002 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_880_003 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_880_004 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_881_001 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_881_002 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_881_003 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_881_004 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_598_001 = null;
this.Res_ENUM_IncomeClassificationValueType_E3_598_003 = null;
this.Res_ENUM_CountryType_AD = null;
this.Res_ENUM_CountryType_AE = null;
this.Res_ENUM_CountryType_AF = null;
this.Res_ENUM_CountryType_AG = null;
this.Res_ENUM_CountryType_AI = null;
this.Res_ENUM_CountryType_AL = null;
this.Res_ENUM_CountryType_AM = null;
this.Res_ENUM_CountryType_AN = null;
this.Res_ENUM_CountryType_AO = null;
this.Res_ENUM_CountryType_AQ = null;
this.Res_ENUM_CountryType_AR = null;
this.Res_ENUM_CountryType_AS = null;
this.Res_ENUM_CountryType_AT = null;
this.Res_ENUM_CountryType_AU = null;
this.Res_ENUM_CountryType_AW = null;
this.Res_ENUM_CountryType_AX = null;
this.Res_ENUM_CountryType_AZ = null;
this.Res_ENUM_CountryType_BA = null;
this.Res_ENUM_CountryType_BB = null;
this.Res_ENUM_CountryType_BD = null;
this.Res_ENUM_CountryType_BE = null;
this.Res_ENUM_CountryType_BF = null;
this.Res_ENUM_CountryType_BG = null;
this.Res_ENUM_CountryType_BH = null;
this.Res_ENUM_CountryType_BI = null;
this.Res_ENUM_CountryType_BJ = null;
this.Res_ENUM_CountryType_BL = null;
this.Res_ENUM_CountryType_BM = null;
this.Res_ENUM_CountryType_BN = null;
this.Res_ENUM_CountryType_BO = null;
this.Res_ENUM_CountryType_BR = null;
this.Res_ENUM_CountryType_BS = null;
this.Res_ENUM_CountryType_BT = null;
this.Res_ENUM_CountryType_BV = null;
this.Res_ENUM_CountryType_BW = null;
this.Res_ENUM_CountryType_BY = null;
this.Res_ENUM_CountryType_BZ = null;
this.Res_ENUM_CountryType_CA = null;
this.Res_ENUM_CountryType_CC = null;
this.Res_ENUM_CountryType_CD = null;
this.Res_ENUM_CountryType_CF = null;
this.Res_ENUM_CountryType_CG = null;
this.Res_ENUM_CountryType_CH = null;
this.Res_ENUM_CountryType_CI = null;
this.Res_ENUM_CountryType_CK = null;
this.Res_ENUM_CountryType_CL = null;
this.Res_ENUM_CountryType_CM = null;
this.Res_ENUM_CountryType_CN = null;
this.Res_ENUM_CountryType_CO = null;
this.Res_ENUM_CountryType_CR = null;
this.Res_ENUM_CountryType_CU = null;
this.Res_ENUM_CountryType_CV = null;
this.Res_ENUM_CountryType_CX = null;
this.Res_ENUM_CountryType_CY = null;
this.Res_ENUM_CountryType_CZ = null;
this.Res_ENUM_CountryType_DE = null;
this.Res_ENUM_CountryType_DJ = null;
this.Res_ENUM_CountryType_DK = null;
this.Res_ENUM_CountryType_DM = null;
this.Res_ENUM_CountryType_DO = null;
this.Res_ENUM_CountryType_DZ = null;
this.Res_ENUM_CountryType_EC = null;
this.Res_ENUM_CountryType_EE = null;
this.Res_ENUM_CountryType_EG = null;
this.Res_ENUM_CountryType_EH = null;
this.Res_ENUM_CountryType_ER = null;
this.Res_ENUM_CountryType_ES = null;
this.Res_ENUM_CountryType_ET = null;
this.Res_ENUM_CountryType_FI = null;
this.Res_ENUM_CountryType_FJ = null;
this.Res_ENUM_CountryType_FK = null;
this.Res_ENUM_CountryType_FM = null;
this.Res_ENUM_CountryType_FO = null;
this.Res_ENUM_CountryType_FR = null;
this.Res_ENUM_CountryType_GA = null;
this.Res_ENUM_CountryType_GB = null;
this.Res_ENUM_CountryType_GD = null;
this.Res_ENUM_CountryType_GE = null;
this.Res_ENUM_CountryType_GF = null;
this.Res_ENUM_CountryType_GG = null;
this.Res_ENUM_CountryType_GH = null;
this.Res_ENUM_CountryType_GI = null;
this.Res_ENUM_CountryType_GL = null;
this.Res_ENUM_CountryType_GM = null;
this.Res_ENUM_CountryType_GN = null;
this.Res_ENUM_CountryType_GP = null;
this.Res_ENUM_CountryType_GQ = null;
this.Res_ENUM_CountryType_GR = null;
this.Res_ENUM_CountryType_GS = null;
this.Res_ENUM_CountryType_GT = null;
this.Res_ENUM_CountryType_GU = null;
this.Res_ENUM_CountryType_GW = null;
this.Res_ENUM_CountryType_GY = null;
this.Res_ENUM_CountryType_HK = null;
this.Res_ENUM_CountryType_HM = null;
this.Res_ENUM_CountryType_HN = null;
this.Res_ENUM_CountryType_HR = null;
this.Res_ENUM_CountryType_HT = null;
this.Res_ENUM_CountryType_HU = null;
this.Res_ENUM_CountryType_ID = null;
this.Res_ENUM_CountryType_IE = null;
this.Res_ENUM_CountryType_IL = null;
this.Res_ENUM_CountryType_IM = null;
this.Res_ENUM_CountryType_IN = null;
this.Res_ENUM_CountryType_IO = null;
this.Res_ENUM_CountryType_IQ = null;
this.Res_ENUM_CountryType_IR = null;
this.Res_ENUM_CountryType_IS = null;
this.Res_ENUM_CountryType_IT = null;
this.Res_ENUM_CountryType_JE = null;
this.Res_ENUM_CountryType_JM = null;
this.Res_ENUM_CountryType_JO = null;
this.Res_ENUM_CountryType_JP = null;
this.Res_ENUM_CountryType_KE = null;
this.Res_ENUM_CountryType_KG = null;
this.Res_ENUM_CountryType_KH = null;
this.Res_ENUM_CountryType_KI = null;
this.Res_ENUM_CountryType_KM = null;
this.Res_ENUM_CountryType_KN = null;
this.Res_ENUM_CountryType_KP = null;
this.Res_ENUM_CountryType_KR = null;
this.Res_ENUM_CountryType_KW = null;
this.Res_ENUM_CountryType_KY = null;
this.Res_ENUM_CountryType_KZ = null;
this.Res_ENUM_CountryType_LA = null;
this.Res_ENUM_CountryType_LB = null;
this.Res_ENUM_CountryType_LC = null;
this.Res_ENUM_CountryType_LI = null;
this.Res_ENUM_CountryType_LK = null;
this.Res_ENUM_CountryType_LR = null;
this.Res_ENUM_CountryType_LS = null;
this.Res_ENUM_CountryType_LT = null;
this.Res_ENUM_CountryType_LU = null;
this.Res_ENUM_CountryType_LV = null;
this.Res_ENUM_CountryType_LY = null;
this.Res_ENUM_CountryType_MA = null;
this.Res_ENUM_CountryType_MC = null;
this.Res_ENUM_CountryType_MD = null;
this.Res_ENUM_CountryType_ME = null;
this.Res_ENUM_CountryType_MF = null;
this.Res_ENUM_CountryType_MG = null;
this.Res_ENUM_CountryType_MH = null;
this.Res_ENUM_CountryType_MK = null;
this.Res_ENUM_CountryType_ML = null;
this.Res_ENUM_CountryType_MM = null;
this.Res_ENUM_CountryType_MN = null;
this.Res_ENUM_CountryType_MO = null;
this.Res_ENUM_CountryType_MP = null;
this.Res_ENUM_CountryType_MQ = null;
this.Res_ENUM_CountryType_MR = null;
this.Res_ENUM_CountryType_MS = null;
this.Res_ENUM_CountryType_MT = null;
this.Res_ENUM_CountryType_MU = null;
this.Res_ENUM_CountryType_MV = null;
this.Res_ENUM_CountryType_MW = null;
this.Res_ENUM_CountryType_MX = null;
this.Res_ENUM_CountryType_MY = null;
this.Res_ENUM_CountryType_MZ = null;
this.Res_ENUM_CountryType_NA = null;
this.Res_ENUM_CountryType_NC = null;
this.Res_ENUM_CountryType_NE = null;
this.Res_ENUM_CountryType_NF = null;
this.Res_ENUM_CountryType_NG = null;
this.Res_ENUM_CountryType_NI = null;
this.Res_ENUM_CountryType_NL = null;
this.Res_ENUM_CountryType_NO = null;
this.Res_ENUM_CountryType_NP = null;
this.Res_ENUM_CountryType_NR = null;
this.Res_ENUM_CountryType_NU = null;
this.Res_ENUM_CountryType_NZ = null;
this.Res_ENUM_CountryType_OM = null;
this.Res_ENUM_CountryType_PA = null;
this.Res_ENUM_CountryType_PE = null;
this.Res_ENUM_CountryType_PF = null;
this.Res_ENUM_CountryType_PG = null;
this.Res_ENUM_CountryType_PH = null;
this.Res_ENUM_CountryType_PK = null;
this.Res_ENUM_CountryType_PL = null;
this.Res_ENUM_CountryType_PM = null;
this.Res_ENUM_CountryType_PN = null;
this.Res_ENUM_CountryType_PR = null;
this.Res_ENUM_CountryType_PS = null;
this.Res_ENUM_CountryType_PT = null;
this.Res_ENUM_CountryType_PW = null;
this.Res_ENUM_CountryType_PY = null;
this.Res_ENUM_CountryType_QA = null;
this.Res_ENUM_CountryType_RE = null;
this.Res_ENUM_CountryType_RO = null;
this.Res_ENUM_CountryType_RS = null;
this.Res_ENUM_CountryType_RU = null;
this.Res_ENUM_CountryType_RW = null;
this.Res_ENUM_CountryType_SA = null;
this.Res_ENUM_CountryType_SB = null;
this.Res_ENUM_CountryType_SC = null;
this.Res_ENUM_CountryType_SD = null;
this.Res_ENUM_CountryType_SE = null;
this.Res_ENUM_CountryType_SG = null;
this.Res_ENUM_CountryType_SH = null;
this.Res_ENUM_CountryType_SI = null;
this.Res_ENUM_CountryType_SJ = null;
this.Res_ENUM_CountryType_SK = null;
this.Res_ENUM_CountryType_SL = null;
this.Res_ENUM_CountryType_SM = null;
this.Res_ENUM_CountryType_SN = null;
this.Res_ENUM_CountryType_SO = null;
this.Res_ENUM_CountryType_SR = null;
this.Res_ENUM_CountryType_ST = null;
this.Res_ENUM_CountryType_SV = null;
this.Res_ENUM_CountryType_SY = null;
this.Res_ENUM_CountryType_SZ = null;
this.Res_ENUM_CountryType_TC = null;
this.Res_ENUM_CountryType_TD = null;
this.Res_ENUM_CountryType_TF = null;
this.Res_ENUM_CountryType_TG = null;
this.Res_ENUM_CountryType_TH = null;
this.Res_ENUM_CountryType_TJ = null;
this.Res_ENUM_CountryType_TK = null;
this.Res_ENUM_CountryType_TL = null;
this.Res_ENUM_CountryType_TM = null;
this.Res_ENUM_CountryType_TN = null;
this.Res_ENUM_CountryType_TO = null;
this.Res_ENUM_CountryType_TR = null;
this.Res_ENUM_CountryType_TT = null;
this.Res_ENUM_CountryType_TV = null;
this.Res_ENUM_CountryType_TW = null;
this.Res_ENUM_CountryType_TZ = null;
this.Res_ENUM_CountryType_UA = null;
this.Res_ENUM_CountryType_UG = null;
this.Res_ENUM_CountryType_UM = null;
this.Res_ENUM_CountryType_US = null;
this.Res_ENUM_CountryType_UY = null;
this.Res_ENUM_CountryType_UZ = null;
this.Res_ENUM_CountryType_VA = null;
this.Res_ENUM_CountryType_VC = null;
this.Res_ENUM_CountryType_VE = null;
this.Res_ENUM_CountryType_VG = null;
this.Res_ENUM_CountryType_VI = null;
this.Res_ENUM_CountryType_VN = null;
this.Res_ENUM_CountryType_VU = null;
this.Res_ENUM_CountryType_WF = null;
this.Res_ENUM_CountryType_WS = null;
this.Res_ENUM_CountryType_YE = null;
this.Res_ENUM_CountryType_YT = null;
this.Res_ENUM_CountryType_ZA = null;
this.Res_ENUM_CountryType_ZM = null;
this.Res_ENUM_CountryType_ZW = null;
this.Res_ENUM_InvoiceType_Item11 = null;
this.Res_ENUM_InvoiceType_Item12 = null;
this.Res_ENUM_InvoiceType_Item13 = null;
this.Res_ENUM_InvoiceType_Item14 = null;
this.Res_ENUM_InvoiceType_Item15 = null;
this.Res_ENUM_InvoiceType_Item16 = null;
this.Res_ENUM_InvoiceType_Item21 = null;
this.Res_ENUM_InvoiceType_Item22 = null;
this.Res_ENUM_InvoiceType_Item23 = null;
this.Res_ENUM_InvoiceType_Item24 = null;
this.Res_ENUM_InvoiceType_Item31 = null;
this.Res_ENUM_InvoiceType_Item32 = null;
this.Res_ENUM_InvoiceType_Item4 = null;
this.Res_ENUM_InvoiceType_Item51 = null;
this.Res_ENUM_InvoiceType_Item52 = null;
this.Res_ENUM_InvoiceType_Item61 = null;
this.Res_ENUM_InvoiceType_Item62 = null;
this.Res_ENUM_InvoiceType_Item71 = null;
this.Res_ENUM_InvoiceType_Item81 = null;
this.Res_ENUM_InvoiceType_Item82 = null;
this.Res_ENUM_InvoiceType_Item84 = null;
this.Res_ENUM_InvoiceType_Item85 = null;
this.Res_ENUM_InvoiceType_Item86 = null;
this.Res_ENUM_InvoiceType_Item111 = null;
this.Res_ENUM_InvoiceType_Item112 = null;
this.Res_ENUM_InvoiceType_Item113 = null;
this.Res_ENUM_InvoiceType_Item114 = null;
this.Res_ENUM_InvoiceType_Item115 = null;
this.Res_ENUM_InvoiceType_Item121 = null;
this.Res_ENUM_InvoiceType_Item131 = null;
this.Res_ENUM_InvoiceType_Item132 = null;
this.Res_ENUM_InvoiceType_Item133 = null;
this.Res_ENUM_InvoiceType_Item134 = null;
this.Res_ENUM_InvoiceType_Item1330 = null;
this.Res_ENUM_InvoiceType_Item1331 = null;
this.Res_ENUM_InvoiceType_Item141 = null;
this.Res_ENUM_InvoiceType_Item142 = null;
this.Res_ENUM_InvoiceType_Item143 = null;
this.Res_ENUM_InvoiceType_Item144 = null;
this.Res_ENUM_InvoiceType_Item145 = null;
this.Res_ENUM_InvoiceType_Item1430 = null;
this.Res_ENUM_InvoiceType_Item1431 = null;
this.Res_ENUM_InvoiceType_Item151 = null;
this.Res_ENUM_InvoiceType_Item161 = null;
this.Res_ENUM_InvoiceType_Item171 = null;
this.Res_ENUM_InvoiceType_Item172 = null;
this.Res_ENUM_InvoiceType_Item173 = null;
this.Res_ENUM_InvoiceType_Item174 = null;
this.Res_ENUM_InvoiceType_Item175 = null;
this.Res_ENUM_InvoiceType_Item176 = null;
this.Res_ENUM_InvoiceType_Item93 = null;
this.Res_ENUM_Status_Imported = null;
this.Res_ENUM_Status_Sucess = null;
this.Res_ENUM_Status_Failed = null;
this.Res_ENUM_Status_Cancelled = null;
this.Res_ENUM_AadeInvoiceClassificationStatus_NotClassified = null;
this.Res_ENUM_AadeInvoiceClassificationStatus_PartiallyClassified = null;
this.Res_ENUM_AadeInvoiceClassificationStatus_Classified = null;
this.Res_ENUM_BookInvoiceERPStatus_Draft = null;
this.Res_ENUM_BookInvoiceERPStatus_Issued = null;
this.Res_ENUM_BookInvoiceERPStatus_ToBeIssued = null;
this.Res_ENUM_TransactionType_Income = null;
this.Res_ENUM_TransactionType_Expense = null;
this.Res_ENUM_TransactionType_Accounting = null;
this.Res_ENUM_InvoiceValidationErrorType_NoIncomeClassificationProvided = null;
this.Res_ENUM_InvoiceValidationErrorType_IncomeClassificationAmountDoesNotMatch = null;
this.Res_ENUM_InvoiceValidationErrorType_NoExpensesClassificationProvided = null;
this.Res_ENUM_InvoiceValidationErrorType_ExpensesClassificationAmountDoesNotMatch = null;
this.Res_ENUM_InvoiceValidationErrorType_NoExpensesVATClassificationProvided = null;
this.Res_ENUM_InvoiceValidationErrorType_ExpensesVATClassificationAmountDoesNotMatch = null;
this.Res_ENUM_InvoiceValidationErrorType_AccountingClassificationAmountDoesNotMatch = null;
this.Res_ENUM_InvoiceValidationErrorType_NoPaymentMethod = null;
this.Res_ENUM_InvoiceValidationErrorType_PaymentsTotalAmountDoesNotMatch = null;
this.Res_ENUM_InvoiceValidationErrorType_NoCurrency = null;
this.Res_ENUM_InvoiceValidationErrorType_NoIssuer = null;
this.Res_ENUM_InvoiceValidationErrorType_NoCounterpart = null;
this.Res_ENUM_InvoiceValidationErrorType_NoSpendingRequestWarning = null;
this.Res_ENUM_InvoiceValidationErrorType_NoSpendingRequestError = null;
this.Res_ENUM_InvoiceValidationErrorType_NoSeries = null;
this.Res_ENUM_InvoiceValidationErrorType_NoInvoiceType = null;
this.Res_ENUM_InvoiceValidationErrorType_NoInvoiceLines = null;
this.Res_ENUM_MyDataSyncStatus_None = null;
this.Res_ENUM_MyDataSyncStatus_SubmitInvoice = null;
this.Res_ENUM_MyDataSyncStatus_SubmitClassifications = null;
this.Res_ENUM_MyDataSyncStatus_FillClassifications = null;
this.Res_ENUM_MyDataSyncStatus_CompleteInvoice = null;
this.Res_ENUM_MatchingInvoiceActionType_Skip = null;
this.Res_ENUM_MatchingInvoiceActionType_Overwrite = null;
this.Res_ENUM_MatchingInvoiceActionType_Duplicate = null;
this.AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_SEND_INVOICE = null;
this.AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_SEND_CLASSIFICATIONS = null;
this.AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_FILL_CLASSIFICATIONS = null;
this.AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_COMPLETE_INVOICE = null;
this.AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_NONE = null;
this.AADEBO_RES_CUSTOM_MYDATA_MARK_NOT_NULL = null;
this.AADEBO_RES_CUSTOM_WRONG_INVOICE_MYDATA_STATUS = null;
this.AADEBO_RES_CUSTOM_SPENDING_REQUESTS_EXIST = null;
this.AADEBO_RES_CUSTOM_PAYMENT_ORDERS_EXIST = null;
this.AADEBO_RES_CUSTOM_INCOME_RECEIPTS_EXIST = null;
this.AADEBO_RES_PAYMENT_ORDER = null;
this.AADEBO_RES_CUSTOM_INCOME_RECEIPT = null;
this.AADEBO_RES_CUSTOM_NO_GJ_CREATED = null;
this.AADEBO_RES_CUSTOM_VALIDATION_NO_SPENDING_REQ = null;
this.AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_CANCELED = null;
this.AADEBO_RES_CUSTOM_INVOICE_WRONG_STATUS = null;
this.AADEBO_RES_CUSTOM_CANCELLATION_INVOICE_TYPE_IS_NOT_CONFIGURED = null;
this.AADEBO_RES_CUSTOM_INVOICE_NO_AA = null;
this.AADEBO_RES_INVOICE = null;
this.AADEBO_RES_TRANSACTION_ENTITY_NOT_FOUND_AND_CREATED = null;
this.PaymentOrderListBO_Res_ASSOC_PaymentOrder_PaymentOrderList_PaymentOrderList_PaymentOrders = null;
this.PaymentOrderListBO_Res_ASSOC_UserAccount_PaymentOrderList_Owner = null;
this.PaymentOrderListBO_Res_ASSOC_Budget_PaymentOrderList_Budget = null;
this.PaymentOrderListBO_Res_ASSOC_BusinessEntity_PaymentOrderList_Entity = null;
this.PaymentOrderListBO_Res_ASSOC_UserAccount_PaymentOrderList_ApprovedBy = null;
this.DynamicWorkflowBO_Res_ASSOC_UserAccount_DynamicWorkflowStep_Owner = null;
this.DynamicWorkflowBO_Res_ASSOC_Department_DynamicWorkflowStep_Department = null;
this.DynamicWorkflowBO_Res_ASSOC_UserAccount_DynamicWorkflowStep_Creator = null;
this.PayrollIntegrationsBO_Res_ASSOC_EmployeePayroll_APDEmployeeGroup_EmployeePayroll = null;
this.PayrollIntegrationsBO_Res_ASSOC_Address_APDHeader_Address = null;
this.PayrollIntegrationsBO_Res_ASSOC_APDHeader_PayrollIntegration_APDHeader = null;
this.PaymentOrderPaymentBO_Res_ASSOC_BankAccount_PaymentOrderPaymentLine_PaymentLine_BankAccountFrom = null;
this.PaymentOrderPaymentBO_Res_ASSOC_CashAccount_PaymentLine_CashAccount = null;
this.PaymentOrderPaymentBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_PaymentLine_PaymentMethod = null;
this.PaymentOrderPaymentBO_Res_ASSOC_BusinessEntity_Payment_Entity = null;
this.PaymentOrderPaymentBO_Res_ASSOC_BankAccount_PaymentLine_BankAccountTo = null;
this.PaymentOrderPaymentBO_Res_ASSOC_Check_Payment_PaymentLine_Check = null;
this.PaymentOrderPaymentBO_Res_ASSOC_Checkbook_PaymentLine_Checkbook = null;
this.PaymentOrderPaymentBO_Res_ASSOC_MoneyTransaction_PaymentLine_CancelMoneyTransaction = null;
this.PaymentOrderPaymentBO_Res_ASSOC_Cashier_PaymentLine_Cashier = null;
this.PaymentOrderPaymentBO_Res_ASSOC_UserAccount_Payment_CreatedBy = null;
this.Res_ENUM_PaymentStatus_None = null;
this.Res_ENUM_PaymentStatus_Pending = null;
this.Res_ENUM_PaymentStatus_Dropped = null;
this.Res_ENUM_PaymentStatus_Completed = null;
this.PaymentOrderPaymentBO_RES_MONEY_TRANSACTION = null;
this.PaymentOrderPaymentBO_RES_PAYMENT_ORDER = null;
this.PaymentOrderPaymentBO_RES_SETTLEMENT_PAYMENT_ORDER = null;
this.InvoiceTemplateBO_Res_ASSOC_TransactionEntity_InvoiceTemplate_TransactionEntity = null;
this.InvoiceTemplateBO_Res_ASSOC_GoodBase_InvoiceTemplateLine_TransactionItem = null;
this.InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_WithheldTaxCategory = null;
this.InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_StampDutyTaxCategory = null;
this.InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_FeesTaxCategory = null;
this.InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_OtherTaxCategory = null;
this.InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_DeductionTaxCategory = null;
this.InvoiceTemplateBO_Res_ASSOC_InvoiceTypeValueObject_InvoiceTemplate_InvoiceType = null;
this.InvoiceTemplateBO_Res_ASSOC_AccountingSystemEntity_InvoiceTemplate_BO = null;
this.InvoiceTemplateBO_Res_ASSOC_VatCategoryValueObject_InvoiceTemplateLine_VatCategory = null;
this.InvoiceTemplateBO_Res_ASSOC_AccountingEvent_InvoiceTemplate_AccountingEvent = null;
this.InvoiceTemplateBO_Res_ASSOC_BudgetItem_SpendingRequestInvoiceTemplate_BudgetItem = null;
this.InvoiceTemplateBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_InvoiceTemplate_PaymentMethod = null;
this.InvoiceTemplateBO_Res_ASSOC_TransactionDocumentSeries_InvoiceTemplate_Series = null;
this.InvoiceTemplateBO_RES_ISSUE_DATE_VARIABLE = null;
this.InvoiceTemplateBO_RES_INVOICE_LINE_AMOUNT_VARIABLE = null;
this.InvoiceTemplateBO_RES_INVOICE_LINE_GOOD_VARIABLE = null;
this.PaidPaymentOrdersListBO_Res_ASSOC_PaymentOrder_PaymentOrderPaymentList_PaidPaymentOrdersList_PaymentOrders = null;
this.PaidPaymentOrdersListBO_Res_ASSOC_BusinessEntity_PaidPaymentOrdersList_Entity = null;
this.TransactionDocumentSeriesBO_Res_ASSOC_BusinessEntity_TransactionDocumentSeries_Entity = null;
this.TransactionDocumentSeriesBO_Res_ASSOC_InvoiceTypeValueObject_TransactionDocumentSeries_InvoiceTypeValueObject = null;
this.SHRChangeRequestBO_Res_ASSOC_Employee_EmployeeDataChangeRequest_Employee = null;
this.Res_ENUM_EmployeeDataChangeRequestStatus_Pending = null;
this.Res_ENUM_EmployeeDataChangeRequestStatus_Accepted = null;
this.Res_ENUM_EmployeeDataChangeRequestStatus_Rejected = null;
this.BudgetTargetingBO_Res_ASSOC_BudgetItem_BudgetTargetingCategory_BudgetItems = null;
this.BudgetTargetingBO_Res_ASSOC_BudgetTargetingCategory_BudgetTargetingCategoryMonth_Category = null;
this.BudgetTargetingBO_Res_ASSOC_ERPFiscalYear_BudgetTargetingTable_FiscalYear = null;
this.BudgetTargetingBO_Res_ASSOC_BusinessEntity_BudgetTargetingTable_Entity = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_1 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_2 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_3 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_4 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_5 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_6 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_7 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_8 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_9 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_10 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_11 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_12 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_13 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_14 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_15 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_16 = null;
this.BudgetTargetingBO_RES_CUSTOM_MONTH_17 = null;
this.AmountAggregatorBO_Res_ASSOC_AccountingSystemEntity_AmountAggregator_BO = null;
this.AmountAggregatorBO_Res_ASSOC_AmountAggregator_AmountAggregatorPart_AggregatorRef = null;
this.AmountAggregatorBO_Res_ASSOC_AmountAggregator_AmountAggregatorInstance_AmountAggregator = null;
this.AmountAggregatorBO_Res_ASSOC_ERPFiscalYear_AmountAggregatorInstance_FiscalYear = null;
this.Res_ENUM_AmountAggregatorPartType_Aggregator = null;
this.Res_ENUM_AmountAggregatorPartType_Field = null;
this.Res_ENUM_AmountAggregatorType_Amount = null;
this.Res_ENUM_AmountAggregatorType_Hours = null;
this.Res_ENUM_AmountAggregatorType_Days = null;
this.Res_ENUM_AmountAggregatorUpdateFrequency_PerFiscalYear = null;
this.Res_ENUM_AmountAggregatorUpdateFrequency_Manually = null;
this.Res_ENUM_AmountAggregatorOperatorType_Addition = null;
this.Res_ENUM_AmountAggregatorOperatorType_Subtraction = null;
this.InventoryValuationBO_Res_ASSOC_BusinessEntity_InventoryValuation_Entity = null;
this.InventoryValuationBO_Res_ASSOC_ERPFiscalYear_FiscalInventoryValuation_FiscalYear = null;
this.InventoryValuationBO_Res_ASSOC_Good_GoodInventoryValuation_Good = null;
this.InventoryValuationBO_Res_ASSOC_ERPFiscalYear_FiscalYearDTO_FiscalYear = null;
this.InventoryValuationBO_Res_ASSOC_Good_GoodValuationDTO_Good = null;
this.Res_ENUM_ValuationMethod_FIFO = null;
this.Res_ENUM_ValuationMethod_LIFO = null;
this.Res_ENUM_ValuationMethod_Average = null;
this.InventoryValuationBO_RES_CURRENT_FISCAL_YEAR = null;
this.Res_ENUM_ExcelConverterEntity_PaySlip = null;
this.Res_ENUM_ExcelConverterEntity_PaymentOrder = null;
this.Res_ENUM_ExcelConverterEntity_SpendingRequest = null;
this.Res_ENUM_ExcelConverterEntity_Payroll = null;
this.Res_ENUM_ExcelConverterEntity_PayrollSummary = null;
this.Res_ENUM_ExcelConverterEntity_BudgetAdjustment = null;
this.Res_ENUM_ExcelConverterEntity_TransactionEntity = null;
this.Res_ENUM_ExcelConverterEntity_CheckNotary = null;
this.Res_ENUM_ExcelConverterEntity_BankAccountList = null;
this.Res_ENUM_ExcelConverterEntity_BankAccountTransactions = null;
this.Res_ENUM_ExcelConverterEntity_Budget = null;
this.Res_ENUM_ExcelConverterEntity_AssetDepreciations = null;
this.Res_ENUM_ExcelConverterEntity_LeaveRequest = null;
this.Res_ENUM_ExcelConverterEntity_CVEmployee = null;
this.Res_ENUM_ExcelConverterEntity_EmployeeOvertime = null;
this.Res_ENUM_ExcelConverterEntity_PeriodOvertime = null;
this.Res_ENUM_ExcelConverterEntity_PaymentOrderPayment = null;
this.Res_ENUM_ExcelConverterEntity_PayrollAdvance = null;
this.Res_ENUM_ExcelConverterEntity_PayrollReport = null;
this.Res_ENUM_ExcelConverterEntity_AdhocAdvancePayment = null;
this.Res_ENUM_ExcelConverterEntity_EmployeeSalaryLoanInstalment = null;
this.Res_ENUM_ExcelConverterEntity_DetailedPayrollReport = null;
this.Res_ENUM_ExcelConverterEntity_APD = null;
this.Res_ENUM_ExcelExporterVariableType_Generic = null;
this.Res_ENUM_ExcelExporterVariableType_Currency = null;
this.Res_ENUM_ExcelExporterVariableType_Days = null;
this.Res_ENUM_ExcelExporterVariableType_Hours = null;
this.Res_ENUM_ExcelExporterVariableType_Rate = null;
this.AssetDepreciationTransactionBO_Res_ASSOC_DepreciationPreview_DepreciationTransaction_TaxPreview = null;
this.AssetDepreciationTransactionBO_Res_ASSOC_DepreciationPreview_DepreciationTransaction_AccountingPreview = null;
this.AssetDepreciationTransactionBO_Res_ASSOC_AssetCategory_DepreciationTransaction_Categories = null;
this.AssetDepreciationTransactionBO_RES_NO_ASSETS_SELECTED = null;
this.BankingBO_Res_ASSOC_Bank_BankAccount_Bank = null;
this.BankingBO_Res_ASSOC_Currency_BankAccount_Currency = null;
this.BankingBO_Res_ASSOC_Currency_CashAccount_Currency = null;
this.BankingBO_Res_ASSOC_Check_MoneyTransaction_MoneyTransaction_Check = null;
this.BankingBO_Res_ASSOC_Cashier_MoneyTransaction_Cashier = null;
this.BankingBO_Res_ASSOC_BusinessEntity_CashAccountInventoryInvoice_Entity = null;
this.BankingBO_Res_ASSOC_CashAccount_CashAccountInventoryInvoiceDetail_CashAccount = null;
this.BankingBO_Res_ASSOC_CashAccount_CashAccountViewDetailDTO_CashAccount = null;
this.BankingBO_Res_ASSOC_CashAccount_CashAccountViewTotalDTO_CashAccount = null;
this.Res_ENUM_BankAccountType_Current = null;
this.Res_ENUM_BankAccountType_Savings = null;
this.Res_ENUM_MoneyTransactionType_Transfer = null;
this.Res_ENUM_MoneyTransactionType_Withdraw = null;
this.Res_ENUM_MoneyTransactionType_Deposit = null;
this.Res_ENUM_MoneyTransactionType_Collection = null;
this.Res_ENUM_MoneyTransactionType_Payment = null;
this.Res_ENUM_MoneyTransactionType_Other = null;
this.Res_ENUM_MoneyAccountType_Bank = null;
this.Res_ENUM_MoneyAccountType_Cash = null;
this.Res_ENUM_MoneyAccountType_Other = null;
this.BankingBO_RES_TRANSACTION_IS_FINALIZED = null;
this.BankingBO_RES_FROM_BANK_MISSING = null;
this.BankingBO_RES_FROM_CASH_MISSING = null;
this.BankingBO_RES_TO_BANK_MISSING = null;
this.BankingBO_RES_TO_CASH_MISSING = null;
this.BankingBO_RES_AMOUNT_MUST_BE_POSITIVE = null;
this.BankingBO_RES_ACCOUNTS_MUST_BE_DIFFERENT = null;
this.BankingBO_RES_BOTH_OTHER = null;
this.BankingBO_RES_SAME_CURRENCY = null;
this.BankingBO_RES_INSUFFICIENT_CASH_BALANCE = null;
this.BankingBO_RES_MISSING_CURRENCY = null;
this.BankingBO_RES_CASH_ACCOUNT_SERIES_NAME_EMPTY = null;
this.BankingBO_RES_MONEY_TRANSACTION_SERIES_NAME_EMPTY = null;
this.BankingBO_RES_MONEY_TRANSACTION_CANT_MODIFY = null;
this.BankingBO_RES_CASH_ACCOUNT_CODE_EXISTS = null;
this.BankingBO_RES_CASH_ACOUNT_CODE_WITHOUT_SERIES = null;
this.BankingBO_RES_MONEY_TRANSACTION_NOT_FINALIZED = null;
this.BankingBO_RES_CASH_ACOUNT_CANNOT_BE_DELETED = null;
this.BankingBO_RES_INSUFFICIENT_BANK_BALANCE = null;
this.BankingBO_RES_STATEMENTS_DUPLICATE_KEYS = null;
this.BankingBO_Bank_MASS_IMPORT_COMPLETE = null;
this.CheckIntegrationsBO_Res_ASSOC_CheckNotaryFilters_Currency_Currency_CheckLixiografaFilters = null;
this.BankingIntegrationsBO_Res_ASSOC_BankAccount_BankAccountTransactionFilter_BankAccount = null;
this.InventoryReports_Res_ASSOC_InventoryListRangeReport_Goods_InventoryListRangeGoodReport_InventoryListRangeReport = null;
this.InventoryReports_Res_ASSOC_InventoryListReport_Goods_InventoryListGoodReport_InventoryListReport = null;
this.InventoryReports_Res_ASSOC_InventoryTransactionsReport_Transactions_InventoryTransactionsSingleReport_InventoryTransactionsReport = null;
this.InventoryReports_Res_ASSOC_InventoryTransactionsReport_PeriodSum_InventoryTransactionsPeriodSum_InventoryTransactionsReport = null;
this.InventoryReports_Res_ASSOC_InventoryTransactionsReport_GlobalSum_InventoryTransactionsGlobalSum_InventoryTransactionsReport = null;
this.TransactionEntityReportsBO_Res_ASSOC_TransactionEntityTransactionsReport_TransactionEntity_TransactionEntity_TransactionEntityTransactionsReport = null;
this.TransactionEntityReportsBO_Res_ASSOC_TransactionEntityTransactionsReport_Transactions_TransactionEntityTransactionsSingleReport_TransactionEntityTransactionsReport = null;
this.TransactionEntityReportsBO_Res_ASSOC_TransactionEntityTransactionsSingleReport_TransactionEntityTransactionsReport_PreviousReport = null;
this.TransactionEntityReportsBO_Res_ASSOC_TransactionEntityTransactionsSingleReport_TransactionEntityTransactionsReport_TotalReport = null;
this.TransactionEntityReportsBO_Res_ASSOC_TransactionEntity_TransactionEntityListSingleReport_TransactionEntity = null;
this.TransactionEntityReportsBO_Res_ASSOC_TransactionEntityListReport_TransactionEntities_TransactionEntityListSingleReport_TransactionEntityListReport = null;
this.TransactionEntityReportsBO_Res_ASSOC_TransactionEntityListSingleReport_TransactionEntityListReport_TotalReport = null;
this.AssetLocationBO_Res_ASSOC_BusinessEntity_AssetLocation_Entity = null;
this.AssetLocationBO_Res_ASSOC_AssetLocation_AssetLocation_ParentLocation = null;
this.AssetLocationBO_RES_SAME_CODE_EXISTS = null;
this.Res_ENUM_VatStatementStatus_Draft = null;
this.Res_ENUM_VatStatementStatus_Submitted = null;
this.Res_ENUM_VatStatementStatus_Cancelled = null;
this.DynamicReportBO_Res_ASSOC_FileData_DynamicReportImage_Image = null;
this.DynamicReportBO_RES_CUSTOM_FILE_DATA_NOT_FOUND = null;
this.AccountingEntityCategoryBO_Res_ASSOC_AccountingSystemEntity_AccountingEntityCategory_SystemEntity = null;
this.AccountingEntityCategoryBO_Res_ASSOC_SystemEntityParameter_AccountingEntityCategory_AvailableFor = null;
this.Res_ENUM_HRPartyStatus_Active = null;
this.Res_ENUM_HRPartyStatus_Paused = null;
this.Res_ENUM_HRPartyStatus_Stopped = null;
this.Res_ENUM_HRPartyStatus_Completed = null;
this.Res_ENUM_HRPartyPayingPolicy_PerCommittee = null;
this.Res_ENUM_HRPartyPayingPolicy_PerSession = null;
this.Res_ENUM_MeetingStatus_New = null;
this.Res_ENUM_MeetingStatus_Cancelled = null;
this.Res_ENUM_MeetingStatus_Completed = null;
this.ProjectBO_Res_ASSOC_Employee_Project_EmployeeProjectManager = null;
this.ProjectBO_Res_ASSOC_TransactionEntity_Projects_Project_TransactionEntityClient = null;
this.ProjectBO_MASS_IMPORT_COMPLETE = null;
this.ProjectBO_MASS_IMPORT_PROJECT_STARTDATE = null;
this.ProjectBO_MASS_IMPORT_PROJECT_ENDDATE = null;
this.Res_ENUM_RewardsProgramImpementation_Internal = null;
this.Res_ENUM_RewardsProgramImpementation_External = null;
this.AccountLocatorRuleBO_Res_ASSOC_Ledger_AccountLocatorRule_Ledger = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountLocatorRule_AccountLocatorRuleInvocation_Rule = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountingSystemEntity_AccountLocatorRule_MainEntity = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountingEvent_AccountLocatorPartSelectionCondition_Condition = null;
this.AccountLocatorRuleBO_Res_ASSOC_Account_AccountLocatorPart_Accounts = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountingSystemEntity_AccountLocatorRuleContextItem_Entity = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountingSystemEntity_AccountLocatorRuleInvocationInput_Entity = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountingEntityCategory_AccountLocatorConditionLine_Category = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountingEntityCategoryValue_AccountLocatorConditionLine_Value = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountingEntityCategory_AccountLocatorPartConditionLine_Category = null;
this.AccountLocatorRuleBO_Res_ASSOC_AccountingEntityCategoryValue_AccountLocatorPartConditionLine_Values = null;
this.Res_ENUM_AccountLocatorType_HardCoded = null;
this.Res_ENUM_AccountLocatorType_Expression = null;
this.Res_ENUM_AccountLocatorType_Conditions = null;
this.Res_ENUM_AccountLocatorType_DynamicGroup = null;
this.Res_ENUM_AccountLocatorType_SpecificAccount = null;
this.Res_ENUM_AccountLocatorType_ChildAccounts = null;
this.Res_ENUM_AccountLocatorRuleType_Normal = null;
this.Res_ENUM_AccountLocatorRuleType_Composite = null;
this.Res_ENUM_AccountingDatatype_Number = null;
this.Res_ENUM_AccountingDatatype_String = null;
this.Res_ENUM_AccountingDatatype_Boolean = null;
this.Res_ENUM_AccountingDatatype_DateTime = null;
this.Res_ENUM_AccountingDatatype_Collection = null;
this.Res_ENUM_AccountingDatatype_ObjectInstance = null;
this.Res_ENUM_AccountLocatorAccountNameMethod_Property = null;
this.Res_ENUM_AccountLocatorAccountNameMethod_HardCoded = null;
this.BackOfficeBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_BackofficePaymentMethodMapping_ERPPaymentMethod = null;
this.BackOfficeBO_Res_ASSOC_BusinessEntity_BackOfficeGeneralConfiguration_Entity = null;
this.BackOfficeBO_Res_ASSOC_TransactionEntity_BackOfficeInvoiceConfig_MainTransactionEntity = null;
this.BackOfficeBO_Res_ASSOC_InvoiceTypeValueObject_BackOfficeInvoiceConfig_InvoiceType = null;
this.BackOfficeBO_Res_ASSOC_TransactionDocumentSeries_BackOfficeInvoiceConfig_Series = null;
this.BackOfficeBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_BackOfficeDividendPaymentTypesMapping_ERPPaymentMethod = null;
this.BackOfficeBO_Res_ASSOC_BackofficePaymentMethodMapping_IssueInvoicePaymentType_PaymentMethodMapping = null;
this.Res_ENUM_BackOfficeDocumentType_Proeispraxi = null;
this.Res_ENUM_BackOfficeDocumentType_Eispraxi = null;
this.Res_ENUM_BackOfficeDocumentType_Stamp = null;
this.Res_ENUM_BackOfficeDocumentType_Contract = null;
this.Res_ENUM_BackOfficeDocumentType_Dividend = null;
this.Res_ENUM_BackOfficeDocumentType_DailyRegister = null;
this.Res_ENUM_BackOfficeDocumentType_Payment = null;
this.Res_ENUM_BackOfficeDocumentType_TrialBankruptcy = null;
this.Res_ENUM_BackOfficeDocumentType_Confiscation = null;
this.Res_ENUM_BackOfficeDocumentType_Invoice = null;
this.Res_ENUM_BackOfficeDocumentType_Receipt = null;
this.Res_ENUM_BackOfficeDocumentType_Expropriation = null;
this.Res_ENUM_ExternalSystemSyncResult_Success = null;
this.Res_ENUM_ExternalSystemSyncResult_PartialSuccess = null;
this.Res_ENUM_ExternalSystemSyncResult_Failed = null;
this.Res_ENUM_ExternalSystemSyncResult_InProgress = null;
this.Res_ENUM_ExternalSystemSyncLogSeverity_Info = null;
this.Res_ENUM_ExternalSystemSyncLogSeverity_Warning = null;
this.Res_ENUM_ExternalSystemSyncLogSeverity_Error = null;
this.Res_ENUM_ExternalSystemItemMappingType_Tax = null;
this.Res_ENUM_ExternalSystemItemMappingType_Product = null;
this.BackOfficeBO_RES_CUSTOM_DocumentTypeNotImplemented = null;
this.BackOfficeBO_RES_CUSTOM_TAX_NOT_MAPPED = null;
this.BackOfficeBO_RES_CUSTOM_DEPARTMENT_NOT_FOUND = null;
this.BackOfficeBO_RES_CUSTOM_UKNOWN_PROEISPRAKSI_CASE = null;
this.BackOfficeBO_RES_CUSTOM_PAYMENTMETHOD_NOT_FOUND = null;
this.BackOfficeBO_RES_CUSTOM_SYNC_FAILED = null;
this.BackOfficeBO_RES_CUSTOM_DOCUMENT_TAX_NOT_FOUND = null;
this.BackOfficeBO_RES_CASHIER_NOT_FOUND = null;
this.BackOfficeBO_RES_MODE_NOT_DECIDED = null;
this.BackOfficeBO_RES_CUSTOM_INV_ISSUE_ERROR = null;
this.BackOfficeBO_RES_CUSTOM_IR_ISSUE_ERROR = null;
this.BackOfficeBO_RES_CUSTOM_CANNOT_CANCEL_MANY_DOCS = null;
this.BackOfficeBO_RES_CUSTOM_UNHANDLED_SYNC_ERROR = null;
this.SeriesCodeGenerator_RES_DUPLICATE_GENERATOR = null;
this.SeriesCodeGenerator_RES_SERIES_INVALID = null;
this.SeriesCodeGenerator_RES_CONTEXT_INVALID = null;
this.SeriesCodeGenerator_Res_ASSOC_ERPFiscalYear_SeriesCode_FiscalYear = null;
this.SEPE_BO_Res_ASSOC_SepeSpecialization_ProfessionSpecialization_SepeSpecialization = null;
this.CashierBO_Res_ASSOC_CashAccount_Cashier_CashAccount = null;
this.CashierBO_Res_ASSOC_BusinessEntity_Cashier_Entity = null;
this.BackOfficeEispraksiBO_Res_ASSOC_BankAccount_BackofficeEispraxiConfig_BankAccount = null;
this.BackOfficeEispraksiBO_RES_CUSTOM_CLIENTID_NOTFOUND = null;
this.BackOfficeEispraksiBO_RES_CUSTOM_CLIENTID_ERROR = null;
this.BackofficeUtilitiesBO_RES_CASHIER_NOT_FOUND = null;
this.BackofficeUtilitiesBO_RES_CUSTOM_REMAINING_AMOUNT = null;
this.BackofficeUtilitiesBO_RES_CUSTOM_AMOUNT_NOT_MAPED = null;
this.BackofficeUtilitiesBO_RES_GENERIC_SYNC_ERROR = null;
this.BackOfficeContractBO_Res_ASSOC_CashAccount_BackOfficeContractConfig_TaxesCashAccount = null;
this.BackOfficeContractBO_Res_ASSOC_CashAccount_BackOfficeContractConfig_CashAccount = null;
this.BackOfficeStampBO_Res_ASSOC_BankAccount_BackOfficeStampConfig_BankAccount = null;
this.BackOfficeDividendBO_Res_ASSOC_CashAccount_BackOfficeDividendConfig_CashAccount = null;
this.BackOfficeDividendBO_RES_DIVIDENT_TYPE_NOT_MAPED = null;
this.BackOfficeDailyRegisterBO_Res_ASSOC_AccountingEvent_BackOfficeDailyRegisterConfig_AccountingEvent = null;
this.BackOfficePaymentBO_Res_ASSOC_BankAccount_BackOfficePaymentConfig_BankAccount = null;
this.BackOfficePaymentBO_Res_ASSOC_CashAccount_BackOfficePaymentConfig_CashAccount = null;
this.Res_ENUM_PayrollExportItemType_Salary = null;
this.Res_ENUM_PayrollExportItemType_Contribution = null;
this.Res_ENUM_PayrollExportItemType_Deduction = null;
this.PayrollVariableBO_Res_ASSOC_PayrollVariable_PayrollVariableInstance_Variable = null;
this.PayrollVariableBO_Res_ASSOC_PayrollVariable_PayrollVariableAssigment_Variable = null;
this.PayrollVariableBO_Res_ASSOC_PayrollCalculatedExpression_PayrollVariableAssigment_Formula = null;
this.PayrollVariableBO_Res_ASSOC_PayrollVariable_PayrollVariableHistoryEntry_PayrollVariable = null;
this.PayrollVariableBO_Res_ASSOC_PayrollVariableHistoryEntry_PayrollVariableInstanceValue_HistoryEntry = null;
this.Res_ENUM_PayrollVariableType_Days = null;
this.Res_ENUM_PayrollVariableType_Hours = null;
this.Res_ENUM_PayrollVariableType_Value = null;
this.Res_ENUM_PayrollVariableType_Year = null;
this.Res_ENUM_EntityDefinitionLevel_UserDefined = null;
this.Res_ENUM_EntityDefinitionLevel_Library = null;
this.Res_ENUM_EntityDefinitionLevel_Systemic = null;
this.PayrollVariableBO_MASS_IMPORT_COMPLETE = null;
this.PayrollVariableBO_MASS_IMPORT_NAME = null;
this.PayrollVariableBO_MASS_IMPORT_CODE = null;
this.PayrollVariableBO_MASS_IMPORT_DATASOURCE = null;
this.PayrollVariableBO_MASS_IMPORT_FIELDNAME = null;
this.PayrollVariableBO_MASS_IMPORT_WRONGFILL = null;
this.PayrollDTOs_Res_ASSOC_PayrollGroupData_PayrollGroup_data = null;
this.EStatementsBO_Res_ASSOC_InvoiceTemplate_StatementsConfiguration_InvoiceTemplate = null;
this.EStatementsBO_Res_ASSOC_BankAccount_BankStatementImportSection_BankAccount = null;
this.EStatementsBO_Res_ASSOC_AadeBookInvoiceType_BankStatementImportRow_Invoice = null;
this.EStatementsBO_RES_NO_BANK_FOUND = null;
this.EStatementsBO_RES_MULTIPLE_BANKS_FOUND = null;
this.EStatementsBO_RES_FROM_DATE_NOT_FOUND = null;
this.EStatementsBO_RES_TO_DATE_NOT_FOUND = null;
this.EStatementsBO_RES_ACCOUNT_NUMBER_NOT_FOUND = null;
this.EStatementsBO_RES_CURRENCY_NOT_FOUND = null;
this.EStatementsBO_RES_OPENING_BALANCE_NOT_FOUND = null;
this.EStatementsBO_RES_IBAN_NOT_FOUND = null;
this.EStatementsBO_RES_BIC_NOT_FOUND = null;
this.EStatementsBO_RES_NUMBER_OF_RECORDS_NOT_FOUND = null;
this.EStatementsBO_RES_SUM_AMOUNT_NOT_FOUND = null;
this.EStatementsBO_RES_CLOSING_BALANCE_NOT_FOUND = null;
this.EStatementsBO_RES_CURRENCY_MISMATCH = null;
this.EStatementsBO_RES_ACCOUNT_NUMBER_MISMATCH = null;
this.EStatementsBO_RES_NUMBER_OF_RECORDS_MISMATCH = null;
this.EStatementsBO_RES_SUM_AMOUNT_MISMATCH = null;
this.EStatementsBO_RES_CLOSING_BALANCE_MISMATCH = null;
this.EStatementsBO_RES_STATEMENT_IMPORT_FINALIZED = null;
this.EStatementsBO_RES_CUSTOM_SAME_DATE_RANGE_IMPORT = null;
this.EStatementsBO_RES_STATEMENT_ROW_NO_TEMPLATE = null;
this.EStatementsBO_RES_DUPLICATE_CHECK_NUMBER = null;
this.ApprovalFlowBO_Res_ASSOC_UserAccount_ApprovalFlowStep_User = null;
this.ApprovalFlowBO_Res_ASSOC_Department_ApprovalFlowStep_Department = null;
this.ApprovalFlowBO_Res_ASSOC_Department_ApprovalFlowScenario_Department = null;
this.ApprovalFlowBO_Res_ASSOC_DepartmentCategory_ApprovalFlowScenario_DepartmentCategory = null;
this.Res_ENUM_ApprovalFlowAction_Approve = null;
this.Res_ENUM_ApprovalFlowAction_Check = null;
this.Res_ENUM_ApprovalFlowAction_Notice = null;
this.Res_ENUM_ApprovalFlowSubsystem_Leaves = null;
this.Res_ENUM_ApprovalFlowStepActorType_SpecificRole = null;
this.Res_ENUM_ApprovalFlowStepActorType_DepartmentManager = null;
this.Res_ENUM_ApprovalFlowStepActorType_SpecificUser = null;
this.Res_ENUM_ApprovalFlowStepActorType_Department = null;
this.Res_ENUM_ApprovalFlowSubsystem_Resignations = null;
this.BackOfficeReceiptBO_RES_CUSTOM_SERIES_NOT_FOUND = null;
this.BackOfficeReceiptBO_RES_CUSTOM_INVOICE_NOT_FOUND = null;
this.BackOfficeReceiptBO_RES_CUSTOM_ISSUE_IR_ERROR = null;
this.BackOfficeInvoiceBO_RES_CUSTOM_PAYMENT_REASON_ERROR = null;
this.CostCenterBO_MASS_IMPORT_COMPLETE = null;
this.CostCenterBO_MASS_IMPORT_COSTCENTER_NO = null;
this.Res_ENUM_WorkProgramType_Work = null;
this.Res_ENUM_WorkProgramType_RemoteWork = null;
this.Res_ENUM_WorkProgramType_OverHours = null;
this.Res_ENUM_WorkProgramType_Rest = null;
this.Res_ENUM_WorkProgramType_NoWork = null;
this.Res_ENUM_WeekDay_Monday = null;
this.Res_ENUM_WeekDay_Tuesday = null;
this.Res_ENUM_WeekDay_Wendesday = null;
this.Res_ENUM_WeekDay_Thursday = null;
this.Res_ENUM_WeekDay_Friday = null;
this.Res_ENUM_WeekDay_Saturday = null;
this.Res_ENUM_WeekDay_Sunday = null;
this.Res_ENUM_Week_First = null;
this.Res_ENUM_Week_Second = null;
this.Res_ENUM_Week_Third = null;
this.Res_ENUM_Week_Fourth = null;
this.WorkCalendarBO_MASS_IMPORT_DAY_FROM1 = null;
this.WorkCalendarBO_MASS_IMPORT_DAY_TO1 = null;
this.WorkCalendarBO_MASS_IMPORT_COMPLETE = null;
this.WorkCalendarBO_MASS_IMPORT_MONDAY_CODE = null;
this.WorkCalendarBO_MASS_IMPORT_TUESDAY_CODE = null;
this.WorkCalendarBO_MASS_IMPORT_WENDESDAY_CODE = null;
this.WorkCalendarBO_MASS_IMPORT_THURSDAY_CODE = null;
this.WorkCalendarBO_MASS_IMPORT_FRIDAY_CODE = null;
this.WorkCalendarBO_MASS_IMPORT_SATURDAY_CODE = null;
this.WorkCalendarBO_MASS_IMPORT_SUNDAY_CODE = null;
this.Res_ENUM_Type_Employee = null;
this.Res_ENUM_Type_Party = null;
this.RoleBO_MASS_IMPORT_NAME = null;
this.RoleBO_MASS_IMPORT_COMPLETE = null;
this.CharacterizationBO_MASS_IMPORT_COMPLETE = null;
this.Res_ENUM_BenefitCategory_Money = null;
this.Res_ENUM_BenefitCategory_Object = null;
this.Res_ENUM_BenefitCategory_Service = null;
this.Res_ENUM_BenefitStatus_Active = null;
this.Res_ENUM_BenefitStatus_Inactive = null;
this.Res_ENUM_HistoricityType_Daily = null;
this.Res_ENUM_HistoricityType_Dimentional = null;
this.Res_ENUM_HistoricityType_Fixed = null;
this.Res_ENUM_DefinitionLevel_System = null;
this.Res_ENUM_DefinitionLevel_Library = null;
this.Res_ENUM_DefinitionLevel_Installation = null;
this.Res_ENUM_DataType_Integer = null;
this.Res_ENUM_DataType_Numeric = null;
this.Res_ENUM_DataType_String = null;
this.Res_ENUM_DataType_Logic = null;
this.Res_ENUM_DataType_DateTime = null;
this.Res_ENUM_DataType_Date = null;
this.Res_ENUM_DataType_Time = null;
this.Res_ENUM_DataType_Money = null;
this.Res_ENUM_DataType_ListValue = null;
this.Res_ENUM_DataType_Entity = null;
this.Res_ENUM_DataType_Duration = null;
this.Res_ENUM_DefinitionLevelEntityType_System = null;
this.Res_ENUM_DefinitionLevelEntityType_User = null;
this.Res_ENUM_AttributeSystemEntity_Employee = null;
this.Res_ENUM_AttributeSystemEntity_EmployeeContract = null;
this.Res_ENUM_AttributeSystemEntity_BusinessEntity = null;
this.Res_ENUM_AttributeSystemEntity_Department = null;
this.Res_ENUM_LinkEntity_Benefit = null;
this.Res_ENUM_LinkEntity_Questionnaire = null;
this.Res_ENUM_LinkEntity_EntityHistory = null;
this.Res_ENUM_LinkEntity_Modification = null;
this.Res_ENUM_LinkOperation_View = null;
this.Res_ENUM_LinkOperation_Stapled = null;
this.AdhocAdvancePaymentBO_Res_ASSOC_EmployeeContract_AdhocAdvancePayment_EmployeeContract = null;
this.AdhocAdvancePaymentBO_Res_ASSOC_PayrollVariable_AdhocAdvancePaymentType_PayrollVariable = null;
this.AdhocAdvancePaymentBO_Res_ASSOC_AdhocAdvancePaymentType_AdhocAdvancePayment_Type = null;
this.AdhocAdvancePaymentBO_Res_ASSOC_SalaryPeriod_AdhocAdvancePayment_SalaryPeriod = null;
this.AdhocAdvancePaymentBO_Res_ASSOC_PayrollPeriod_AdhocAdvancePayment_PayrollPeriod = null;
this.Res_ENUM_AdhocAdvancePaymentStatus_Pending = null;
this.Res_ENUM_AdhocAdvancePaymentStatus_Payment = null;
this.Res_ENUM_AdhocAdvancePaymentStatus_Clearance = null;
this.Res_ENUM_AdhocAdvancePaymentStatus_Canceled = null;
this.BackOfficeExpropriationBO_Res_ASSOC_CashAccount_BackOfficeExpropriationConfig_CashAccount = null;
this.Res_ENUM_SurveyEmployeeStatus_Active = null;
this.Res_ENUM_SurveyEmployeeStatus_InActive = null;
this.EntityHistoryBO_EntityFieldDTO_Initialization_Failed = null;
this.Res_ENUM_WorkPlace_CompanyDepartment = null;
this.Res_ENUM_WorkPlace_Other = null;
this.ErganiBO_MASS_IMPORT_COMPLETE = null;
this.Res_ENUM_CertificationStatus_Active = null;
this.Res_ENUM_CertificationStatus_Inactive = null;
this.CertificationBO_MASS_IMPORT_COMPLETE = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_NAME = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_VALIDATION_FROM = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_VALIDATION_TO = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_CATEGORY_EMLPOYEE = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_TYPE = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_DOMAIN = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_CATEGORY = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_SUITE = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_INSTITUTION = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_LEVEL = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_NAME_SPACE = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATION_DOCUMENT_TYPE = null;
this.CertificationBO_MASS_IMPORT_CERTIFICATIONLEVEL_DESCRIPTION_NO = null;
this.ForeignLanguangeBO_Res_ASSOC_Institution_ForeignLanguange_Institution = null;
this.VocationalEducationBO_Res_ASSOC_FileData_VocationalEducation_Diploma = null;
this.VocationalEducationBO_Res_ASSOC_EmployeeCategory_VocationalEducation_EmployeeCategory = null;
this.VocationalEducationBO_Res_ASSOC_KnowledgeDomain_VocationalEducation_KnowledgeDomain = null;
this.VocationalEducationBO_Res_ASSOC_Institution_VocationalEducation_Institution = null;
this.Res_ENUM_DepMemberFMY_Full = null;
this.Res_ENUM_DepMemberFMY_None = null;
this.Res_ENUM_PeriodType_Item1 = null;
this.Res_ENUM_PeriodType_Item3 = null;
this.Res_ENUM_PeriodType_Item4 = null;
this.Res_ENUM_PeriodType_Item5 = null;
this.Res_ENUM_PeriodType_Item11 = null;
this.Res_ENUM_PeriodType_Item12 = null;
this.Res_ENUM_PeriodType_Item13 = null;
this.Res_ENUM_PeriodType_Item14 = null;
this.Res_ENUM_PeriodType_Item15 = null;
this.Res_ENUM_PeriodType_Item16 = null;
this.Res_ENUM_AdvancePayments_Status_Normal = null;
this.Res_ENUM_AdvancePayments_Status_Canceled = null;
this.ResignationRuleBO_Res_ASSOC_ApprovalFlow_ResignationRule_ApprovalFlow = null;
this.EmployeeResignationBO_Res_ASSOC_UserAccount_EmployeeResignationRequest_RequestedBy = null;
this.EmployeeResignationBO_Res_ASSOC_PendingTask_EmployeeResignationRequest_ActiveTask = null;
this.EmployeeResignationBO_Res_ASSOC_ApprovalFlowScenario_EmployeeResignationRequest_ApprovalFlowScenario = null;
this.EmployeeResignationBO_Res_ASSOC_Employee_EmployeeResignationRequest_Employee = null;
this.EmployeeResignationBO_Res_ASSOC_ResignationRule_EmployeeResignationRequest_ResignationRule = null;
this.EmployeeResignationBO_Res_ASSOC_EmployeeContract_EmployeeResignationRequest_EmployeeContract = null;
this.Res_ENUM_ResignationRequestStatus_Temporary = null;
this.Res_ENUM_ResignationRequestStatus_Pending = null;
this.Res_ENUM_ResignationRequestStatus_Validating = null;
this.Res_ENUM_ResignationRequestStatus_Approved = null;
this.Res_ENUM_ResignationRequestStatus_Rejected = null;
this.EmployeeResignationBO_EmployeeLeaveBO_RES_CUSTOM_INVALID_STATUS_TRANSITION = null;
this.EmployeeResignationBO_EmployeeLeaveBO_RES_CUSTOM_VALIDATION_OVERLAPING_DAYS = null;
this.EmployeeResignationBO_RES_NOTIFY_RESIGNATION_APPROVAL = null;
this.EmployeeResignationBO_RES_NOTIFY_RESIGNATION_INFORM = null;
this.EmployeeResignationBO_RES_NOTIFY_RESIGNATION_ACCEPTED = null;
this.EmployeeResignationBO_RES_NOTIFY_RESIGNATION_REJECTED = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_EMPLOYEE_CONTRACT_NO = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TYPE_CODE_NO = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_DATE_REQUIRED = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_REQUESTED_DATE_NO = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_HOURS_FROM_TO_REQUIRED = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_COMPLETE = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_EMPLOYEE_CODE_NO = null;
this.EmployeeResignationBO_EmployeeLeaveBO_RES_WRONG_EMPLOEE_CODE = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TYPE_CODE_REQUIRED = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_HOURS_WRONG = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_FROM_HOURS_WRONG = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TO_HOURS_WRONG = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_FROM_MIN_WRONG = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TO__WRONG = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TIME_WRONG = null;
this.EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_ERGANIS_TYPE_WRONG = null;
this.Res_ENUM_MovementType_Entry = null;
this.Res_ENUM_MovementType_Exit = null;
this.Res_ENUM_MovementType_Unknown = null;
this.Res_ENUM_CardStatus_Active = null;
this.Res_ENUM_CardStatus_Lost = null;
this.Res_ENUM_CardStatus_Damaged = null;
this.Res_ENUM_CardStatus_Expired = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_DateTime = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_MovementType = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_EmployeeContract = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_CardID = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_Location = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_Inserted = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_Updated = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_Skipped = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_NotFound = null;
this.AttendanceBO_MASS_IMPORT_MOVEMENT_NotInserted = null;
this.Res_ENUM_ModificationEmployeeState_IsPending = null;
this.Res_ENUM_ModificationEmployeeState_Accepted = null;
this.Res_ENUM_ModificationEmployeeState_Cancelled = null;
this.Res_ENUM_ModificationTypeStatus_Active = null;
this.Res_ENUM_ModificationTypeStatus_InActive = null;
this.PowerBIBO_Res_ASSOC_EmbedConfigFilters_EmbedConfigPanes_filters = null;
this.PowerBIBO_Res_ASSOC_EmbedConfigPanes_EmbedConfigSettings_panes = null;
this.PowerBIBO_Res_ASSOC_EmbedConfigSettings_EmbedConfig_settings = null;
this.PayrollScaleDTOs_Res_ASSOC_PayrollCategoryDTO_PayrollScaleItemDTO_PayrollCategory = null;
this.PayrollScaleDTOs_Res_ASSOC_PayrollVariable_DTO_PayrollScaleDataDTO_PayrollVariable = null;
}

static translate: TranslateService;
_key: any;
InventoryManagementBO_Res_ASSOC_Address_Warehouse_Address:any;
InventoryManagementBO_Res_ASSOC_Warehouse_ParentWarehouse_Warehouse_Warehouses:any;
InventoryManagementBO_Res_ASSOC_Warehouse_GoodStock_Warehouse:any;
InventoryManagementBO_Res_ASSOC_GoodStock_Transfers_GoodTransfer_Stock:any;
InventoryManagementBO_Res_ASSOC_Employee_Warehouse_Responsible:any;
InventoryManagementBO_Res_ASSOC_BusinessEntity_GoodBase_Entity:any;
InventoryManagementBO_Res_ASSOC_BusinessEntity_Warehouse_Entity:any;
InventoryManagementBO_Res_ASSOC_ERPFiscalYear_GoodTransferTransaction_FiscalYear:any;
InventoryManagementBO_Res_ASSOC_BusinessEntity_GoodTransferTransaction_Entity:any;
InventoryManagementBO_Res_ASSOC_GoodBase_GoodTransfer_Good:any;
InventoryManagementBO_Res_ASSOC_ExpensesClassificationCategoryValueObject_TransactionItemClassification_ExpensesClassificationCategory:any;
InventoryManagementBO_Res_ASSOC_IncomeClassificationCategoryValueObject_TransactionItemClassification_IncomeClassificationCategory:any;
InventoryManagementBO_Res_ASSOC_ExpensesClassificationTypeValueObject_TransactionItemClassification_ExpensesClassificationTypes:any;
InventoryManagementBO_Res_ASSOC_IncomeClassificationTypeValueObject_TransactionItemClassification_IncomeClassificationTypes:any;
InventoryManagementBO_Res_ASSOC_InvoiceTypeValueObject_TransactionItemClassification_InvoiceType:any;
InventoryManagementBO_Res_ASSOC_TaxCategoryValueObject_GoodBase_WithheldPercentCategory:any;
InventoryManagementBO_Res_ASSOC_VatCategoryValueObject_GoodBase_VATCategory:any;
InventoryManagementBO_Res_ASSOC_VatExemptionCategoryValueObject_GoodBase_VATExemptionCategory:any;
InventoryManagementBO_Res_ASSOC_BudgetItem_GoodBase_IncomeBudgetItems:any;
InventoryManagementBO_Res_ASSOC_MeasurementUnitValueObject_Good_MeasurementUnitValueObject:any;
InventoryManagementBO_Res_ASSOC_BusinessEntity_GoodCategory_Entity:any;
InventoryManagementBO_Res_ASSOC_GoodCategory_Good_GoodCat:any;
InventoryManagementBO_Res_ASSOC_GoodCategory_Children_GoodCategory_Parent:any;
InventoryManagementBO_Res_ASSOC_AadeBookInvoiceType_GoodTransferTransaction_Invoice:any;
InventoryManagementBO_Res_ASSOC_Warehouse_GoodPlacementDTO_Warehouse:any;
InventoryManagementBO_Res_ASSOC_Good_TransactionPlacementDTO_Good:any;
InventoryManagementBO_Res_ASSOC_TransactionPlacementDTO_GoodPlacements_GoodPlacementDTO_TransactionPlacementDTO:any;
InventoryManagementBO_Res_ASSOC_BusinessEntity_GoodPhysicalInventory_Entity:any;
InventoryManagementBO_Res_ASSOC_Good_GoodPhysicalInventoryGood_Good:any;
InventoryManagementBO_Res_ASSOC_Warehouse_GoodPhysicalInventoryWarehouse_Warehouse:any;
InventoryManagementBO_Res_ASSOC_PackagingUnitValueObject_Good_PackagingUnitValueObject:any;
InventoryManagementBO_Res_ASSOC_BudgetItem_GoodBase_ExpenseBudgetItems:any;
InventoryManagementBO_Res_ASSOC_GoodCategory_Good_GoodSubCat:any;
Res_ENUM_GoodTransactionType_Purchase:any;
Res_ENUM_GoodTransactionType_Sale:any;
Res_ENUM_GoodTransactionType_Internal:any;
Res_ENUM_GoodTransactionType_PhysicalInventory:any;
Res_ENUM_GoodStockType_Available:any;
Res_ENUM_GoodStockType_Reserved:any;
Res_ENUM_GoodStockType_AtSupplier:any;
Res_ENUM_TransactionItemType_Good:any;
Res_ENUM_TransactionItemType_Service:any;
Res_ENUM_TransactionItemType_Other:any;
Res_ENUM_TransactionItemType_Asset:any;
InventoryManagementBO_RES_NEGATIVE_STOCK:any;
InventoryManagementBO_RES_NO_TRANSFERS:any;
InventoryManagementBO_RES_STOCK_EXCEEDS_INVOICE:any;
InventoryManagementBO_RES_DUPLICATE_TRANSFERS:any;
InventoryManagementBO_RES_NULL_WAREHOUSE:any;
InventoryManagementBO_RES_NULL_GOOD:any;
InventoryManagementBO_RES_GOOD_NO_TRACK_STOCK:any;
InventoryManagementBO_RES_DUPLICATE_WAREHOUSES:any;
InventoryManagementBO_RES_NULL_COST:any;
InventoryManagementBO_RES_NULL_REFERENCE_DATE:any;
InventoryManagementBO_RES_DUPLICATE_GOODS:any;
InventoryManagementBO_QUANTITY_SUM_UNEQUAL:any;
InventoryManagementBO_RES_NEGATIVE_QUANTITY:any;
InventoryManagementBO_RES_INVENTORY_NAME:any;
InventoryManagementBO_RES_PACKAGING_UNIT_NAME_EMPTY:any;
InventoryManagementBO_RES_PACKAGING_UNIT_MULTIPLIER_NEGATIVE:any;
InventoryManagementBO_RES_PACKAGING_UNIT_UNIT_OR_PARENT:any;
InventoryManagementBO_RES_GOOD_CATEGORY_EMPTY_CODE:any;
InventoryManagementBO_RES_GOOD_CATEGORY_NAME_EMPTY:any;
CommonBO_Res_ASSOC_Country_Address_Country:any;
CommonBO_Res_ASSOC_Region_Address_Region:any;
CommonBO_Res_ASSOC_FileData_FileUpload_File:any;
CommonBO_Res_ASSOC_City_Address_City_:any;
Res_ENUM_PaymentMethodType_Cash:any;
Res_ENUM_PaymentMethodType_Check:any;
Res_ENUM_PaymentMethodType_BankTransfer:any;
Res_ENUM_NoteEntity_SpendingRequestDetail:any;
Res_ENUM_NoteEntity_InvoiceDetail:any;
Res_ENUM_RoundingMethod_Closest:any;
Res_ENUM_RoundingMethod_Ceil:any;
Res_ENUM_RoundingMethod_Floor:any;
Res_ENUM_InstitutionType_VocationalEducation:any;
Res_ENUM_InstitutionType_BasicEducation:any;
Res_ENUM_InstitutionType_CertificationOrganization:any;
CommonBO_RES_CUSTOM_BANC_ACCOUNT_TYPE_CURRENT:any;
CommonBO_RES_CUSTOM_BANC_ACCOUNT_TYPE_SAVINGS:any;
CommonBO_RES_CUSTOM_MONEY_TRANSACTION_TYPE_WITHDRAW:any;
CommonBO_RES_CUSTOM_MONEY_TRANSACTION_TYPE_DEPOSIT:any;
CommonBO_MASS_IMPORT_COMPLETE:any;
CommonBO_MASS_IMPORT_PARENT:any;
CommonBO_MASS_IMPORT_COUNTRY_NO:any;
CommonBO_MASS_IMPORT_COUNTRY_ENGLISH_NO:any;
CommonBO_MASS_IMPORT_COUNTRY_CODE_LENGTH:any;
CommonBO_MASS_IMPORT_COUNTRY_CODE_NO:any;
CommonBO_MASS_IMPORT_TAXOFFICE_NAME_NO:any;
CommonBO_MASS_IMPORT_TAXOFFICE_CODE_NO:any;
CommonBO_MASS_IMPORT_TAXOFFICE_NUMERICALCODE_NO:any;
BusinessEntityBO_Res_ASSOC_Department_Children_Department_Parent:any;
BusinessEntityBO_Res_ASSOC_ContactDetails_Department_ContactDetails:any;
BusinessEntityBO_Res_ASSOC_ContactDetails_BusinessEntity_ContactDetails:any;
BusinessEntityBO_Res_ASSOC_TaxOffice_BusinessEntity_TaxOffice:any;
BusinessEntityBO_Res_ASSOC_BusinessEntityType_BusinessEntity_Type:any;
BusinessEntityBO_Res_ASSOC_Country_BusinessEntity_Country:any;
BusinessEntityBO_Res_ASSOC_SIC_BusinessEntitySIC_SIC:any;
BusinessEntityBO_Res_ASSOC_Employee_DepartmentSupervisorReplaceRule_Replacement:any;
BusinessEntityBO_Res_ASSOC_Employee_Department_ReplacementSupervisor:any;
Res_ENUM_BusinessEntityStatus_Active:any;
Res_ENUM_BusinessEntityStatus_UnderLiquidation:any;
Res_ENUM_BusinessEntityStatus_Disabled:any;
Res_ENUM_BusinessEntityStatus_Nothing:any;
Res_ENUM_BusinessEntityKind_Company:any;
Res_ENUM_BusinessEntityKind_Group:any;
Res_ENUM_BusinessEntityKind_Branch:any;
Res_ENUM_BusinessEntityKind_Nothing:any;
Res_ENUM_AccountingBookType_Level1:any;
Res_ENUM_AccountingBookType_Level2:any;
Res_ENUM_AccountingBookType_Level3:any;
Res_ENUM_AccountingBookType_Nothing:any;
Res_ENUM_RepresentativesType_Technitian:any;
Res_ENUM_RepresentativesType_Doctor:any;
BusinessEntityBO_RES_CIRCULAR_DEPARTMENT_REFERENCE:any;
BusinessEntityBO_MASS_IMPORT_WORK_POSITION_START_DATE:any;
BusinessEntityBO_MASS_IMPORT_COMPLETE:any;
BusinessEntityBO_EmployeeBO_MASS_IMPORT_SENIORITY_LEVEL:any;
BusinessEntityBO_MASS_IMPORT_Department_NO:any;
BusinessEntityBO_MASS_IMPORT_Code_NO:any;
BusinessEntityBO_MASS_IMPORT_WorkPosition_NO:any;
BusinessEntityBO_MASS_IMPORT_D_NO:any;
BusinessEntityBO_MASS_IMPORT_From:any;
BusinessEntityBO_MASS_IMPORT_To:any;
BusinessEntityBO_MASS_IMPORT_DepPosType:any;
BusinessEntityBO_MASS_IMPORT_EmployeeCat:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_DEPARTMENT_NO:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_WORK_POSITION_NO:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_TITLE_NO:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_DEPARTMENT:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_WORK_POSITION:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_TITLE:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_FROM:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_TO:any;
BusinessEntityBO_MASS_IMPORT_DEP_POSITION_TYPE:any;
BusinessEntityBO_MASS_IMPORT_IMPORT_DEP_EMPLOYEE_CATEGORY:any;
BusinessEntityBO_MASS_IMPORT_NAME_NO:any;
BusinessEntityBO_MASS_IMPORT_POSITIONS_NO:any;
BusinessEntityBO_MASS_IMPORT_ENTITY_NO:any;
BusinessEntityBO_MASS_IMPORT_ENTITY:any;
BusinessEntityBO_MASS_IMPORT_DEPCAT:any;
BusinessEntityBO_MASS_IMPORT_COSTCENTER:any;
BusinessEntityBO_MASS_IMPORT_SUPERVISOR:any;
BusinessEntityBO_MASS_IMPORT_SUPERVISORREP:any;
BusinessEntityBO_MASS_IMPORT_IMPORT_TECHNOLOGY:any;
BusinessEntityBO_Technology_MASS_IMPORT_COMPLETE:any;
BusinessEntityBO_BusinessEntityType_MASS_IMPORT_COMPLETE:any;
BusinessEntityBO_SeniorityLevel_MASS_IMPORT_COMPLETE:any;
BusinessEntityBO_DUTIESRESPONSIBILITIES_MASS_IMPORT_COMPLETE:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_COMPLETE:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_NAME_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_SHORTNAME_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_KIND_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_COUNTRY_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_STREET_NAME_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_STREET_NUMBER_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_CITY_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_POSTALCODE_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_TAXOFFICE_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_TAXNUMBER_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_BOOKTYPE_NO:any;
BusinessEntityBO_BUSINESS_ENTITY_MASS_IMPORT_AME_NO:any;
BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_COMPANY_TYPE:any;
BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_COUNTRY:any;
BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_START_DATE:any;
BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_ADMIN_START_PERIOD:any;
BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_ADMIN_END_PERIOD:any;
BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_TAX_OFFICE:any;
BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_BOOK_TYPE:any;
BusinessEntityBO_MASS_IMPORT_BUSINESS_ENTITY_PARENT:any;
EmployeeBO_Res_ASSOC_Country_Employee_DocumentIssueCountry:any;
EmployeeBO_Res_ASSOC_Country_Employee_Citizenship:any;
EmployeeBO_Res_ASSOC_Country_Employee_Nationality:any;
EmployeeBO_Res_ASSOC_Bank_Employee_Bank:any;
EmployeeBO_Res_ASSOC_TaxOffice_Employee_TaxOffice:any;
EmployeeBO_Res_ASSOC_Address_Employee_Address:any;
EmployeeBO_Res_ASSOC_UserAccount_Employee_Employee_UserAccount:any;
Res_ENUM_Gender_Male:any;
Res_ENUM_Gender_Female:any;
Res_ENUM_Gender_Other:any;
Res_ENUM_FamilyStatus_Single:any;
Res_ENUM_FamilyStatus_Married:any;
Res_ENUM_FamilyStatus_Divorced:any;
Res_ENUM_FamilyStatus_Widowed:any;
Res_ENUM_DocumentType_IdCard:any;
Res_ENUM_DocumentType_Passport:any;
Res_ENUM_Relationship_Child:any;
Res_ENUM_Relationship_Spouse:any;
Res_ENUM_Relationship_Parent:any;
Res_ENUM_Relationship_Sibling:any;
Res_ENUM_MilitaryObligations_Yes:any;
Res_ENUM_MilitaryObligations_No:any;
Res_ENUM_MilitaryObligations_NotRequired:any;
Res_ENUM_CEFRLevel_A1:any;
Res_ENUM_CEFRLevel_A2:any;
Res_ENUM_CEFRLevel_B1:any;
Res_ENUM_CEFRLevel_B2:any;
Res_ENUM_CEFRLevel_C1:any;
Res_ENUM_CEFRLevel_C2:any;
Res_ENUM_DepMemberEducation_No:any;
Res_ENUM_DepMemberEducation_SecondStep:any;
Res_ENUM_DepMemberEducation_ThirdStep:any;
Res_ENUM_GroupEmployeeStatus_Active:any;
Res_ENUM_GroupEmployeeStatus_InActive:any;
Res_ENUM_RequestStates_Request:any;
Res_ENUM_RequestStates_Approved:any;
Res_ENUM_RequestStates_Rejected:any;
Res_ENUM_RequestStates_Correction:any;
Res_ENUM_HRState_Complete:any;
Res_ENUM_HRState_Uncomplete:any;
Res_ENUM_FMY_Full:any;
Res_ENUM_FMY_Half:any;
Res_ENUM_FMY_None:any;
EmployeeBO_RES_CUSTOM_ID:any;
EmployeeBO_MASS_IMPORT_COMPLETE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_FIRST:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_LAST:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_FATHER:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_MOTHER:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_BIRTHDATE_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_BIRTHDATE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_NATIONALITY:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DEFERRAL_EXPIRES:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_CITIZENSHIP:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DEFERRAL_EXPIRES_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_POSTAL_CODE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_STREETNAME:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_STREETNUM:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_COUNTRY_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_COUNTRY:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_CITY:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_POSTAL_CODE_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_REGION:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_MOBILE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_PHONE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_EMAIL:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_EMAIL_BUSINESS:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_ISSUE_DATE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_ISSUE_COUNTRY:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_TAX_OFFICE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_TAX_NUMBER:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_FIRST_INSURANCE_DATE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_ALLOWANCE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_WORK_PERMIT_FROM:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_WORK_PERMIT_TO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_WORK_PERMIT_COUNTRY:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_RELATIONSHIP:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_GENDER:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_PRIVATE_INSURANCE_START:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_PRIVATE_INSURANCE_EXPIRES:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_EDUCATION_START:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_LANGUAGE_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_LANGUAGE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_INSTITUTION:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_OBTAINING_DATE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_EXPIRE_DATE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DIRECTION:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_LEVEL:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_GRADUATION_DATE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_VOCATIONAL_EDUCATION_FROM:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_VOCATIONAL_EDUCATION_TO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DOMAIN:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_PASTWORK_DATEFROM:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_PASTWORK_DATETO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_PASTWORK_PROJECT_DATETO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_PASTWORK_PROJECT_DATEFROM:any;
EmployeeBO_MASS_IMPORT_PASTWORK_COMPANY_NO:any;
EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_EMPLOYEE:any;
EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_COMPANY:any;
EmployeeBO_MASS_IMPORT_PASTWORK_CODE_NO:any;
EmployeeBO_MASS_IMPORT_CONTRACTNAME:any;
EmployeeBO_MASS_IMPORT_CONTRACT:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_MOBILE_BUSINESS:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_INTERNAL_PHONE:any;
EmployeeBO_MASS_IMPORT_WORK_FULLNAME_NO:any;
EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_FULLNAME:any;
EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_MEMBERROLE:any;
EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_PROJECT:any;
EmployeeBO_MASS_IMPORT_WORK_EXPERIENCE_CHARACTERIAZATION:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DATEFROM:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DATETO:any;
EmployeeBO_RES_CIRCULAR_PROJECTWORKEXPERIENCE_REFERENCE:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DEPMEMBER_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_VOCATIONALEDUCATION_NO:any;
EmployeeBO_MASS_IMPORT_DEPMEMBER_NAME:any;
EmployeeBO_MASS_IMPORT_LANGUAGE_NAME:any;
EmployeeBO_MASS_IMPORT_DIPLOMATITLE_NAME:any;
EmployeeBO_MASS_IMPORT_FOREIGNLANGUAGE:any;
EmployeeBO_MASS_IMPORT_CERTIFICATION_DOCUMENT_TYPE:any;
EmployeeBO_MASS_IMPORT_VOCATIONALEDU_DOC_PATH_NO:any;
EmployeeBO_MASS_IMPORT2_VOCATIONALEDUCATION_VOCEDU:any;
EmployeeBO_MASS_IMPORT_VOCEDUCATION_NAME_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_TITLENAME_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_TITLENAME:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_DOC_PATH_NO:any;
EmployeeBO_MASS_IMPORT_EMPLOYEE_CITY_:any;
BudgetBO_Res_ASSOC_BudgetItem_BudgetDetail_BudgetItem:any;
BudgetBO_Res_ASSOC_BudgetDetail_Adjustments_BudgetAdjustmentDetail_BudgetDetail:any;
BudgetBO_Res_ASSOC_Budget_Modifications_BudgetAdjustment_Budget:any;
BudgetBO_Res_ASSOC_BusinessEntity_Budget_Entity:any;
BudgetBO_Res_ASSOC_ERPFiscalYear_Budget_FiscalYear:any;
BudgetBO_Res_ASSOC_BusinessEntity_BudgetItemCategory_Entity:any;
BudgetBO_Res_ASSOC_BusinessEntity_BudgetAdjustment_BusinessEntity:any;
BudgetBO_Res_ASSOC_BudgetDetail_BudgetDetailTransaction_BudgetDetail:any;
BudgetBO_Res_ASSOC_Budget_BudgetTransaction_Budget:any;
BudgetBO_Res_ASSOC_BudgetItem_BudgetAdjustmentDetail_BudgetItem:any;
BudgetBO_Res_ASSOC_TransactionEntity_BudgetTransaction_TransactionEntity:any;
Res_ENUM_BudgetStatus_Draft:any;
Res_ENUM_BudgetStatus_Approved:any;
Res_ENUM_BudgetStatus_Rejected:any;
Res_ENUM_BudgetStatus_Submited:any;
Res_ENUM_BudgetStatus_Canceled:any;
Res_ENUM_BudgetDetailTransactionType_Approval:any;
Res_ENUM_BudgetDetailTransactionType_Adjustment:any;
Res_ENUM_BudgetDetailTransactionType_Request:any;
Res_ENUM_BudgetDetailTransactionType_Invoicing:any;
Res_ENUM_BudgetDetailTransactionType_ReleaseRemainingAmount:any;
Res_ENUM_BudgetDetailTransactionType_Cancelation:any;
Res_ENUM_BudgetDetailTransactionType_Order:any;
Res_ENUM_BudgetDetailTransactionType_Payment:any;
Res_ENUM_BudgetDetailTransactionType_Issue:any;
Res_ENUM_BudgetEntity_Budget:any;
Res_ENUM_BudgetEntity_BudgetAdjustment:any;
Res_ENUM_BudgetEntity_SpendingRequest:any;
Res_ENUM_BudgetEntity_Invoice:any;
Res_ENUM_BudgetEntity_PaymentOrder:any;
Res_ENUM_BudgetEntity_Payment:any;
Res_ENUM_BudgetEntity_IncomeReceipt:any;
Res_ENUM_BudgetEntity_SettlementPaymentOrder:any;
BudgetBO_RES_EXCEPTION_BUDGET_CANNOT_SUBMIT:any;
BudgetBO_RES_EXCEPTION_BUDGET_CANNOT_APPROVE:any;
BudgetBO_RES_EXCEPTION_BUDGET_ALREADY_SUBMITTED:any;
BudgetBO_RES_EXCEPTION_BUDGET_CANNOT_SUBMIT_APPROVED_BUDGET_EXISTS:any;
BudgetBO_RES_EXCEPTION_BUDGET_CANNOT_DRAFT:any;
AssetManagementBO_Res_ASSOC_AssetCategory_Asset_Category:any;
AssetManagementBO_Res_ASSOC_Department_Asset_Department:any;
AssetManagementBO_Res_ASSOC_Department_Asset_Direction:any;
AssetManagementBO_Res_ASSOC_AssetDepreciationCategory_Asset_AccountingDepreciationCategory:any;
AssetManagementBO_Res_ASSOC_AssetDepreciationCategory_Asset_TaxDepreciationCategory:any;
AssetManagementBO_Res_ASSOC_TransactionEntity_Asset_Supplier:any;
AssetManagementBO_Res_ASSOC_AssetDepreciationRate_Asset_DepreciationRate:any;
AssetManagementBO_Res_ASSOC_AssetDepreciationRate_AssetCategory_DepreciationRate:any;
AssetManagementBO_Res_ASSOC_VatCategoryValueObject_Asset_VATRate:any;
AssetManagementBO_Res_ASSOC_AssetGroup_Asset_AssetGroup:any;
AssetManagementBO_Res_ASSOC_AssetResponsible_Asset_AssetResponsible:any;
AssetManagementBO_Res_ASSOC_BusinessEntity_AssetGroup_Entity:any;
AssetManagementBO_Res_ASSOC_BusinessEntity_AssetResponsible_Entity:any;
Res_ENUM_AssetType_Fixed:any;
Res_ENUM_AssetType_RealEstateBuilding:any;
Res_ENUM_AssetType_Intangible:any;
Res_ENUM_AssetType_RealEstateLand:any;
Res_ENUM_AssetType_UnderConstruction:any;
Res_ENUM_AssetStatus_Initialized:any;
Res_ENUM_AssetStatus_Acquired:any;
Res_ENUM_AssetStatus_Destructed:any;
Res_ENUM_AssetStatus_Sold:any;
Res_ENUM_AssetStatus_Depreciated:any;
Res_ENUM_UnitOfMeasurement_Piece:any;
Res_ENUM_UnitOfMeasurement_Meter:any;
Res_ENUM_UnitOfMeasurement_SquareMeter:any;
AssetManagementBO_ASSET_ALREADY_ACQUIRED:any;
AssetManagementBO_RES_ASSET_DEPRECIATED:any;
AssetManagementBO_DEPRECIATION_NEWER_DATE:any;
AssetManagementBO_ASSET_NON_DEPRECIABLE:any;
AssetManagementBO_RES_ASSET_DELETE_HAS_TRANSACTIONS:any;
AssetManagementBO_RES_ASSET_DELETE_HAS_SUBASSETS:any;
PayrollDataBO_Res_ASSOC_EmployeeContract_EmployeePayroll_Contract:any;
PayrollDataBO_Res_ASSOC_SalaryRule_PayrollSalaryDetail_Salary:any;
PayrollDataBO_Res_ASSOC_ContributionRule_PayrollContributionDetail_Rule:any;
PayrollDataBO_Res_ASSOC_ExternalSalaryType_PayrollContributionDetail_SalaryType:any;
PayrollDataBO_Res_ASSOC_Employee_Payments_EmployeePayroll_Employee:any;
PayrollDataBO_Res_ASSOC_BusinessEntity_Payroll_Entity:any;
PayrollDataBO_Res_ASSOC_AadeBookInvoiceType_Payroll_AdvanceInvoice:any;
PayrollDataBO_Res_ASSOC_PaymentOrder_Payroll_AdvancePaymentOrder:any;
PayrollDataBO_Res_ASSOC_PaymentOrder_Payroll_PaymentOrder:any;
PayrollDataBO_Res_ASSOC_BankAccount_Payroll_BankAccount:any;
PayrollDataBO_Res_ASSOC_PayrollCalculatedExpressionVersion_PayrollSalaryDetail_ExpressionVersion:any;
PayrollDataBO_Res_ASSOC_PayrollScaleData_PayrollSalaryDetail_ScaleVersion:any;
PayrollDataBO_Res_ASSOC_SalaryDeductionRule_PayrollDeductionDetail_Rule:any;
PayrollDataBO_Res_ASSOC_SalaryPeriod_PayrollPeriod_Type:any;
PayrollDataBO_Res_ASSOC_SalaryPeriod_PayrollCalculation_Type:any;
PayrollDataBO_Res_ASSOC_PayrollPeriod_Calculations_PayrollCalculation_Period:any;
PayrollDataBO_Res_ASSOC_PayrollIntegration_PayrollAPDFileExportDetail_PayrollIntegration:any;
Res_ENUM_PayrollStatus_Draft:any;
Res_ENUM_PayrollStatus_Calculating:any;
Res_ENUM_PayrollStatus_Completed:any;
Res_ENUM_PayrollStatus_Cancelled:any;
Res_ENUM_PayrollStatus_Deleted:any;
Res_ENUM_ContractTerminationReasonSystem_None:any;
Res_ENUM_ContractTerminationReasonSystem_VoluntaryResignation:any;
Res_ENUM_EapPeriods_Item1:any;
Res_ENUM_EapPeriods_Item2:any;
Res_ENUM_EapPeriods_Item3:any;
Res_ENUM_EapPeriods_Item4:any;
Res_ENUM_EapPeriods_Item5:any;
Res_ENUM_EapPeriods_Item6:any;
Res_ENUM_EapPeriods_Item7:any;
Res_ENUM_EapPeriods_Item8:any;
Res_ENUM_EapPeriods_Item9:any;
Res_ENUM_EapPeriods_Item10:any;
Res_ENUM_EapPeriods_Item11:any;
Res_ENUM_EapPeriods_Item12:any;
Res_ENUM_EapPeriods_Item13:any;
Res_ENUM_EapPeriods_Item14:any;
Res_ENUM_EapPeriods_Item15:any;
Res_ENUM_EapIncomeType_Item0:any;
Res_ENUM_EapIncomeType_Item1:any;
Res_ENUM_EapIncomeType_Item2:any;
Res_ENUM_EapIncomeType_Item3:any;
Res_ENUM_EapIncomeType_Item4:any;
Res_ENUM_EapIncomeType_item5:any;
Res_ENUM_EapIncomeType_Item6:any;
Res_ENUM_ApdStatus_Draft:any;
Res_ENUM_ApdStatus_Completed:any;
PayrollDataBO_RES_Payroll_Cannot_Reopen:any;
UserBO_RES_CUSTOM_INVALID_CURRENT_PASSWORD:any;
UserBO_RES_CUSTOM_USER_WITH_USERNAME_NOT_FOUND:any;
UserBO_RES_CUSTOM_RESET_PASSWORD:any;
UserBO_RES_CUSTOM_ClickToReset:any;
UserBO_RES_CUSTOM_CopyPaste:any;
UserBO_RES_CUSTOM_NO_VALID_EMAIL_FOUND:any;
UserBO_RES_CUSTOM_InvalidLink:any;
UserBO_RES_CUSTOM_NotFound:any;
Res_ENUM_TrialBalanceReportType_UnAdjusted:any;
Res_ENUM_TrialBalanceReportType_Adjusted:any;
Res_ENUM_TrialBalanceReportType_PostClosing:any;
Res_ENUM_TrialBalanceAdjustringHandling_ShowColumn:any;
Res_ENUM_TrialBalanceAdjustringHandling_HideColumn:any;
Res_ENUM_TrialBalanceAdjustringHandling_HideAndIncludeInPrevBalance:any;
Res_ENUM_TrialBalanceColumnTitles_Text:any;
Res_ENUM_TrialBalanceColumnTitles_Period:any;
Res_ENUM_TrialBalanceColumnTitles_TextAndPeriod:any;
Ledger_Res_ASSOC_FiscalPeriod_Ledgers_Ledger_FiscalPeriod:any;
Ledger_Res_ASSOC_AccountCategory_ChildAccountCategories_AccountCategory_ParentAccountCategory:any;
Ledger_Res_ASSOC_AccountCode_Ledger_AccountCodeRule:any;
Ledger_Res_ASSOC_Ledger_SubLedgers_Ledger_ParentLedger:any;
Ledger_Res_ASSOC_AccountingBusinessEntity_Ledger_Entity:any;
Ledger_Res_ASSOC_Account_Ledger_ParentAccount:any;
Res_ENUM_LedgerType_Main:any;
Res_ENUM_LedgerType_SubLedger:any;
Res_ENUM_AccountCategoryType_None:any;
Res_ENUM_AccountCategoryType_Asset:any;
Res_ENUM_AccountCategoryType_Liability:any;
Res_ENUM_AccountCategoryType_Equity:any;
Res_ENUM_AccountCategoryType_LiabilityEquity:any;
Res_ENUM_AccountCategoryType_Revenue:any;
Res_ENUM_AccountCategoryType_Expense:any;
Res_ENUM_AccountCategoryType_IncomeStatement:any;
Res_ENUM_AccountCategoryType_CostOfSales:any;
Res_ENUM_AccountCategoryType_MemorandumAccounts:any;
Ledger_RES_CUSTOM_DEFAULT_LEDGER_EXISTS:any;
GeneralJournalTemplate_Res_ASSOC_Ledger_GeneralJournalTemplate_Ledger:any;
GeneralJournalTemplate_Res_ASSOC_Account_GeneralJournalTemplateDetail_ParentAccount:any;
GeneralJournalTemplate_Res_ASSOC_Account_GeneralJournalTemplateDetail_Account:any;
GeneralJournalTemplate_Res_ASSOC_AccountingBusinessEntity_GeneralJournalTemplate_Entity:any;
GeneralJournalTemplate_Res_ASSOC_FiscalPeriod_GeneralJournalTemplate_FiscalPeriod:any;
GeneralJournalTemplate_Res_ASSOC_AccountingJournal_GeneralJournalTemplate_AccountingJournal:any;
GeneralJournalRule_Res_ASSOC_FiscalPeriod_GeneralJournalRule_FiscalPeriod:any;
GeneralJournalRule_Res_ASSOC_AccountingEvent_GeneralJournalRule_AccountingEvents:any;
GeneralJournalRule_Res_ASSOC_AccountCategory_GeneralJournalRuleDetail_ChartOfAccount_Category:any;
GeneralJournalRule_Res_ASSOC_AccountingBusinessEntity_GeneralJournalRule_Entity:any;
GeneralJournalRule_Res_ASSOC_AccountingSystemEntity_GeneralJournalRule_BO:any;
GeneralJournalRule_Res_ASSOC_Ledger_GeneralJournalRuleEntry_Ledger:any;
GeneralJournalRule_Res_ASSOC_AccountingJournal_GeneralJournalRuleEntry_Journal:any;
GeneralJournalRule_Res_ASSOC_GeneralJournalRuleField_GeneralJournalRuleConditionLine_Operand1:any;
Res_ENUM_GeneralJournalRuleFieldType_Account:any;
Res_ENUM_GeneralJournalRuleFieldType_Collection:any;
Res_ENUM_GeneralJournalRuleFieldType_Amount:any;
Res_ENUM_GeneralJournalRuleFieldType_Text:any;
Res_ENUM_GeneralJournalRuleFieldType_Date:any;
Res_ENUM_GeneralJournalRuleFieldType_Currency:any;
Res_ENUM_GeneralJournalRuleFieldType_Boolean:any;
Res_ENUM_AccountingEqualityOperators_Equals:any;
Res_ENUM_AccountingEqualityOperators_NotEquals:any;
Res_ENUM_AccountingEqualityOperators_HasValue:any;
Res_ENUM_AccountingConditionJoinOperator_AND:any;
Res_ENUM_AccountingConditionJoinOperator_OR:any;
GeneralJournalRule_FOUND_ENTRY_FINALIZED:any;
GeneralJournal_Res_ASSOC_TAccount_GeneralJournalDetail_Account:any;
GeneralJournal_Res_ASSOC_FiscalPeriod_GeneralJournal_FiscalPeriod:any;
GeneralJournal_Res_ASSOC_AccountingCurrency_GeneralJournal_Currency:any;
GeneralJournal_Res_ASSOC_Ledger_GeneralJournal_Ledger:any;
GeneralJournal_Res_ASSOC_AccountingEvent_GeneralJournal_AccountingEvent:any;
GeneralJournal_Res_ASSOC_AccountingJournal_GeneralJournal_Journal:any;
GeneralJournal_Res_ASSOC_AccountingPeriod_GeneralJournal_AccountingPeriod:any;
GeneralJournal_Res_ASSOC_AccountingBusinessEntity_GeneralJournal_Entity:any;
GeneralJournal_Res_ASSOC_TAccount_SubLedgerEntryDetail_TAccount:any;
GeneralJournal_Res_ASSOC_Ledger_SubLedgerEntryDetail_SubLedger:any;
Res_ENUM_GeneralJournalType_Transaction:any;
Res_ENUM_GeneralJournalType_Opening:any;
Res_ENUM_GeneralJournalType_Adjusting:any;
Res_ENUM_GeneralJournalType_Closing:any;
FiscalPeriod_Res_ASSOC_AccountingBusinessEntity_FiscalPeriod_Entity:any;
FiscalPeriod_RES_MULTIPLE_FISCAL_PERIODS_PER_DAY:any;
FiscalPeriod_RES_START_DATE_BEFORE_END_DATE:any;
FiscalPeriod_RES_OVERLAP_EXISTS:any;
FiscalPeriod_RES_NAME_EXISTS:any;
FinalizeAccEntries_Res_ASSOC_AccountingBusinessEntity_FinalizeAccEntries_Entity:any;
FinalizeAccEntries_Res_ASSOC_UserAccount_FinalizeAccEntries_ExecutedBy:any;
AccountRelation_Res_ASSOC_AccountingEvent_AccountRelationDetail_AccountingEvent:any;
AccountRelation_Res_ASSOC_TAccount_AccountRelationDetail_DetailAccount:any;
AccountRelation_Res_ASSOC_TAccount_AccountRelation_Account:any;
AccountRelation_Res_ASSOC_AccountRelationType_AccountRelation_AccountRelationType:any;
AccountRelation_Res_ASSOC_Ledger_AccountRelation_Ledger:any;
AccountRelation_Res_ASSOC_AccountingJournal_AccountRelation_Journal:any;
AccountRelation_Res_ASSOC_AccountingEvent_AccountRelation_AccountingEvent:any;
AccountingRule_Res_ASSOC_Account_EntityToAccountItem_Account:any;
AccountingRule_Res_ASSOC_AccountingEntityCategoryValue_AccountingCategorySelectedValues_FirstSelectedValue:any;
Res_ENUM_AccountSelectionType_SelectSpecific:any;
Res_ENUM_AccountSelectionType_SelectParent:any;
Res_ENUM_AccountSelectionType_DynamicMappings:any;
AccountingEventEntriesTemplate_Res_ASSOC_AccountingEvent_AccountingEventEntriesTemplate_Event:any;
AccountingEventEntriesTemplate_Res_ASSOC_FiscalPeriod_AccountingEventEntriesTemplate_FiscalPeriod:any;
AccountingEventEntriesTemplate_Res_ASSOC_AccountingCurrency_AccountingEventEntriesTemplate_Currency:any;
AccountingEventEntriesTemplate_Res_ASSOC_AccountCategory_AccountingEventAmount_AccountCategory:any;
AccountingEventEntriesTemplate_Res_ASSOC_Ledger_AccountingEventAmountGroup_Ledger:any;
AccountingEventEntriesTemplate_Res_ASSOC_AccountingJournal_AccountingEventAmountGroup_Journal:any;
AccountingEvent_Res_ASSOC_AccountingSystemEntity_AccountingEvent_Entity:any;
Res_ENUM_AccountingEventSystemType_NonSystemic:any;
Res_ENUM_AccountingEventSystemType_PaymentOrderPayment:any;
Res_ENUM_AccountingEventSystemType_PayrollIssue:any;
Res_ENUM_AccountingEventSystemType_PayrollAdvance:any;
Res_ENUM_AccountingEventSystemType_AssetAcquisition:any;
Res_ENUM_AccountingEventSystemType_AssetSale:any;
Res_ENUM_AccountingEventSystemType_AssetDestruction:any;
Res_ENUM_AccountingEventSystemType_AssetDepreciation:any;
Res_ENUM_AccountingEventSystemType_AssetImprovment:any;
Res_ENUM_AccountingEventSystemType_AssetLoss:any;
Res_ENUM_AccountingEventSystemType_AssetProfit:any;
Res_ENUM_AccountingEventSystemType_AssetDepreciationInvoice:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionDepositToAcount:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionWithdrawFromAcount:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionTransferBetweenAccounts:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionPaymentWithCheck:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionPaymentWithBank:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionPaymentWithCash:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionReceiptWithCheck:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionReceiptWithBank:any;
Res_ENUM_AccountingEventSystemType_MoneyTransactionReceiptWithCash:any;
Res_ENUM_AccountingEventSystemType_SettlementPaymentOrderPayment:any;
Res_ENUM_AccountingEventSystemType_CheckIssue:any;
Res_ENUM_AccountingEventSystemType_CheckCollect:any;
Res_ENUM_AccountingEventSystemType_CheckDeliver:any;
Res_ENUM_AccountingEventSystemType_BudgetApproval:any;
Res_ENUM_AccountingEventSystemType_IncomeReceiptPayment:any;
AccountConsolidationRel_Res_ASSOC_Ledger_AccountConsolidationRelation_SourceLedger:any;
AccountConsolidationRel_Res_ASSOC_Ledger_AccountConsolidationRelation_TargetLedger:any;
AccountConsolidationRel_Res_ASSOC_FiscalPeriod_AccountConsolidationRelation_FiscalPeriod:any;
AccountConsolidationRel_Res_ASSOC_TAccount_AccountConsolidationRelation_TargetAccount:any;
AccountConsolidationRel_Res_ASSOC_AccountCategory_AccountConsolidationRelation_SourceAccountCategory:any;
Account_Res_ASSOC_Ledger_ChartOfAccounts_Account_Ledger:any;
Account_Res_ASSOC_FiscalPeriod_Account_FiscalPeriod:any;
Account_Res_ASSOC_Account_ChildChartOfAccounts_Account_ParentChartOfAccount:any;
Account_Res_ASSOC_AccountCategory_Account_AccountCategory:any;
Account_Res_ASSOC_AccountingEntityCategory_AccountTag_Category:any;
Account_Res_ASSOC_AccountingEntityCategoryValue_AccountTag_Value:any;
Res_ENUM_AccountSign_Debit:any;
Res_ENUM_AccountSign_Credit:any;
Res_ENUM_AccountSign_DebitAndCredit:any;
Res_ENUM_AccountSign_NoTransactions:any;
Account_RES_CUSTOM_SAME_CODE_VALIDATION:any;
Account_RES_CUSTOM_LEGER_CODE_VALIDATION:any;
ErpBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_PaymentOrderApprovalCondition_PaymentMethod:any;
ErpBO_Res_ASSOC_InvoiceTypeValueObject_ERPConfiguration_CancellationInvoiceType:any;
ErpBO_Res_ASSOC_DynamicReport_ERPConfiguration_PaymentOrderWithCheckDynamicReport:any;
Res_ENUM_ERPMessageType_None:any;
Res_ENUM_ERPMessageType_Information:any;
Res_ENUM_ERPMessageType_Warning:any;
Res_ENUM_ERPMessageType_Error:any;
TransactionEntity_Res_ASSOC_Address_TransactionEntity_InvoiceAddress:any;
TransactionEntity_Res_ASSOC_BusinessType_TransactionEntity_BusinessType:any;
TransactionEntity_Res_ASSOC_ContactDetails_TransactionEntity_MainContactDetails:any;
TransactionEntity_Res_ASSOC_BusinessEntity_TransactionEntity_Entity:any;
TransactionEntity_Res_ASSOC_AccountingSystemEntityConfig_TransactionEntity_AccountingConfig:any;
TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_CustomerCategory:any;
TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_SupplierCategory:any;
TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_EmployeeCategory:any;
TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_CreditorCategory:any;
TransactionEntity_Res_ASSOC_TransactionEntityCategory_TransactionEntity_DebtorCategory:any;
TransactionEntity_Res_ASSOC_BusinessEntity_TransactionEntityInventoryInvoice_Entity:any;
TransactionEntity_Res_ASSOC_TransactionEntity_TransactionEntityInventoryInvoiceDetail_TransactionEntity:any;
Res_ENUM_VATStatus_Normal:any;
Res_ENUM_VATStatus_Exemption:any;
Res_ENUM_VATStatus_Deduction:any;
Res_ENUM_VATStatus_WithinEU:any;
Res_ENUM_VATStatus_OutEU:any;
Res_ENUM_AFMType_Greek:any;
Res_ENUM_AFMType_EU:any;
Res_ENUM_AFMType_Individual:any;
Res_ENUM_AFMType_OutEU:any;
Res_ENUM_DocumentStatus_Draft:any;
Res_ENUM_DocumentStatus_Issued:any;
Res_ENUM_DocumentStatus_Cancelled:any;
Res_ENUM_TransactionEntityType_Customer:any;
Res_ENUM_TransactionEntityType_Supplier:any;
Res_ENUM_TransactionEntityType_Employee:any;
Res_ENUM_TransactionEntityType_Creditor:any;
Res_ENUM_TransactionEntityType_Debtor:any;
Res_ENUM_TransactionEntityType_Treasury:any;
TransactionEntity_RES_CODE_EXISTS:any;
SpendingRequestBO_Res_ASSOC_BusinessEntity_SpendingRequest_Entity:any;
SpendingRequestBO_Res_ASSOC_Budget_SpendingRequest_Budget:any;
SpendingRequestBO_Res_ASSOC_BudgetDetail_SpendingRequests_SpendingRequestDetail_Item:any;
SpendingRequestBO_Res_ASSOC_ERPFiscalYear_SpendingRequest_FiscalYear:any;
SpendingRequestBO_Res_ASSOC_UserAccount_SpendingRequest_ReleasedBy:any;
SpendingRequestBO_Res_ASSOC_GoodBase_SpendingRequestDetail_Good:any;
SpendingRequestBO_Res_ASSOC_SpendingRequestCategory_SpendingRequest_Category:any;
SpendingRequestBO_Res_ASSOC_SpendingRequestSubCategory_SpendingRequest_SubCategory:any;
SpendingRequestBO_Res_ASSOC_Department_SpendingRequest_Department:any;
SpendingRequestBO_Res_ASSOC_TransactionEntity_SpendingRequest_TransactionEntity:any;
SpendingRequestBO_Res_ASSOC_InvoiceRowType_SpendingRequestInvoicing_SpendingRequestInvoicing_InvoiceRow:any;
SpendingRequestBO_Res_ASSOC_SpendingRequestDetail_InvoicingInfo_SpendingRequestInvoicing_SpendingRequestDetail:any;
SpendingRequestBO_Res_ASSOC_UserAccount_SpendingRequest_Owner:any;
SpendingRequestBO_Res_ASSOC_SpendingRequestDetail_NonDeductibleVATInvoicingInfo_SpendingRequestInvoicing_NonDeductibleVATSpendingRequestDetail:any;
SpendingRequestBO_Res_ASSOC_Note_SpendingRequestDetail_Note:any;
SpendingRequestBO_RES_CUSTOM_CANNOT_RELEASE:any;
SpendingRequestBO_RES_CUSTOM_CANNOT_CANCEL:any;
SpendingRequestBO_RES_INVOICE:any;
SIC_BO_Res_ASSOC_SIC_SICProfessionPackage_SIC:any;
SIC_BO_Res_ASSOC_InsuranceProfession_Packages_SICProfessionPackage_InsuranceProfession:any;
SIC_BO_Res_ASSOC_InsuranceCoveragePackage_Professions_SICProfessionPackage_InsuranceCoveragePackage:any;
SIC_BO_Res_ASSOC_InsuranceCoveragePackage_SpecialInsuranceCaseVersion_FromConveragePackage:any;
SIC_BO_Res_ASSOC_InsuranceCoveragePackage_SpecialInsuranceCaseVersion_ToCoveragePackage:any;
SIC_BO_Res_ASSOC_SpecialInsuranceCase_MappingCodeConfig_SpecialInsuranceCase:any;
Res_ENUM_SIC_System_EFKA:any;
Res_ENUM_SIC_System_OAED:any;
Res_ENUM_SIC_System_EFORIA:any;
Res_ENUM_SIC_System_OSYK:any;
Res_ENUM_SIC_PackageType_PublicSector:any;
Res_ENUM_SIC_PackageType_PrivateSector:any;
Res_ENUM_SIC_PackageType_TEKA:any;
PaymentOrderBO_Res_ASSOC_BusinessEntity_PaymentOrder_Entity:any;
PaymentOrderBO_Res_ASSOC_TransactionEntity_PaymentOrder_TransactionEntity:any;
PaymentOrderBO_Res_ASSOC_ERPFiscalYear_PaymentOrder_FiscalYear:any;
PaymentOrderBO_Res_ASSOC_SpendingRequestDetail_PaymentOrderDetails_PaymentOrderDetail_SpendingRequestDetail:any;
PaymentOrderBO_Res_ASSOC_TaxCategoryValueObject_PaymentOrderDeductionDetail_TaxCategory:any;
PaymentOrderBO_Res_ASSOC_Budget_PaymentOrder_Budget:any;
PaymentOrderBO_Res_ASSOC_AadeBookInvoiceType_PaymentOrderInvoices_PaymentOrderInvoice_Invoice:any;
PaymentOrderBO_Res_ASSOC_PaymentOrderSeries_PaymentOrder_Series:any;
PaymentOrderBO_Res_ASSOC_AadeBookInvoiceType_PaymentOrderDeductionDetail_Invoice:any;
Res_ENUM_PaymentOrderType_Normal:any;
Res_ENUM_PaymentOrderType_Deductions:any;
Res_ENUM_PaymentOrderType_Prepayment:any;
PaymentOrderBO_WITHHELD_TAX_WITHOUT_TREASURY:any;
PaymentOrderBO_RES_CANNOT_MODIFY_PAYMENT_ORDER_SERIES:any;
PaymentOrderBO_RES_PAYMENT_ORDER_SERIES_NAME_EMPTY:any;
PaymentOrderBO_RES_PAYMENT_ORDER_MISSING_SERIES:any;
PaymentOrderBO_RES_PAYMENT:any;
PaymentOrderBO_RES_GENERAL_JOURNAL:any;
PaymentOrderBO_RES_VALIDATION_ERRORS:any;
PaymentOrderBO_RES_CUSTOM_CANNOT_APPROVE:any;
PaymentOrderBO_RES_MONEY_TRANSACTION_IS_MISSING:any;
PaymentOrderBO_RES_PAYABLE_AMOUNT_DOES_NOT_MATCH:any;
PaymentOrderBO_RES_CUSTOM_PAYMENT_ORDER_WRONG_STATUS:any;
PaymentOrderBO_RES_PAYMENT_ORDER:any;
CheckBO_Res_ASSOC_BankAccount_Check_BankAccount:any;
CheckBO_Res_ASSOC_TransactionEntity_Check_Beneficiary:any;
CheckBO_Res_ASSOC_BusinessEntity_Check_Entity:any;
CheckBO_Res_ASSOC_Currency_Check_Currency:any;
CheckBO_Res_ASSOC_BusinessEntity_Checkbook_Entity:any;
CheckBO_Res_ASSOC_BankAccount_Checkbook_BankAccount:any;
CheckBO_Res_ASSOC_Checkbook_Checks_Check_Checkbook:any;
CheckBO_Res_ASSOC_CheckStatus_Check_Status:any;
CheckBO_Res_ASSOC_CheckStatus_CheckTransactionType_SupportedStatusesFrom:any;
CheckBO_Res_ASSOC_CheckStatus_CheckTransactionType_StatusAfterTransaction:any;
CheckBO_Res_ASSOC_CheckTransactionType_CheckTransaction_Type:any;
CheckBO_Res_ASSOC_Check_CheckTransaction_Check:any;
CheckBO_Res_ASSOC_Check_ChecksList_ChecksList_Checks:any;
CheckBO_Res_ASSOC_CheckStatus_ChecksList_CurrentChecksStatus:any;
CheckBO_Res_ASSOC_BusinessEntity_ChecksList_Entity:any;
CheckBO_Res_ASSOC_ChecksList_ChecksListTransaction_ChecksList:any;
CheckBO_Res_ASSOC_AccountingEvent_CheckTransactionType_AccountingEvent:any;
Res_ENUM_CheckType_Income:any;
Res_ENUM_CheckType_Expense:any;
Res_ENUM_CheckEntityType_Checkbook:any;
Res_ENUM_CheckEntityType_SupplierCustomer:any;
Res_ENUM_CheckEntityType_Bank:any;
Res_ENUM_CheckDigitAlgorithm_None:any;
Res_ENUM_CheckDigitAlgorithm_Piraeus1:any;
CheckBO_RES_INSUFFICIENT_BANK_ACCOUNT_BALANCE:any;
CheckBO_RES_CHECKBOOK_IS_COMPLETED:any;
CheckBO_RES_CHECKBOOK_NUMBER_EMPTY:any;
CheckBO_RES_CHECKBOOK_NUMBER_ORDER_EMPTY:any;
CheckBO_RES_CHECKBOOK_NUMBER_ORDER_DUPLICATE:any;
CheckBO_RES_CHECKBOOK_NUMBER_IS_TOP:any;
CheckBO_RES_CHECKBOOK_NUMBER_IS_BOTTOM:any;
CheckBO_RES_CHECK_TRANSACTION_ALREADY_FINALIZED:any;
CheckBO_RES_CHECK_DELIVERY_TYPE_NOT_SPECIFIED:any;
CheckBO_RES_CHECK_ISSUE_TYPE_NOT_SPECIFIED:any;
CheckBO_RES_CHECK_IS_CASHED:any;
CheckBO_RES_CHECK_TRANSACTION_NOT_VALID_FOR_INCOME:any;
CheckBO_RES_CHECK_TRANSACTION_NOT_VALID_FOR_EXPENSE:any;
CheckBO_RES_CHECK_TRANSACTION_STATUS_INVALID:any;
CheckBO_RES_CUSTOM_CHECK_TRANSACTION_TYPE_STATUS_UNSPECIFIED:any;
CheckBO_RES_CHECK_CASHING_TYPE_NOT_SPECIFIED:any;
CheckBO_RES_CUSTOM_CHECK_SETTING_DELIVERY_THRESHOLD_NULL:any;
CheckBO_RES_CUSTOM_CHECK_SETTING_DELIVERY_THRESHOLD_NEGATIVE:any;
CheckBO_RES_NO_ACCOUNTING_EVENT:any;
CheckBO_RES_CUSTOM_CHECK_TRANSACTION:any;
CheckBO_RES_CHECK_IS_USED:any;
CheckBO_RES_CHECKDIGIT_ALGORITHM_NOT_FOUND:any;
CheckBO_RES_PIRAEUS_CHECK_DIGIT_INVALID_DIGITS:any;
EmployeeContractBO_Res_ASSOC_ContractTerminationReason_EmployeeContract_TerminationReason:any;
EmployeeContractBO_Res_ASSOC_BusinessEntity_EmployeeContract_Entity:any;
EmployeeContractBO_Res_ASSOC_EmploymentContractTemplate_EmployeeContract_Template:any;
EmployeeContractBO_Res_ASSOC_PayrollCalculatedExpression_EmployeeContract_CompensationCalculatedExpression:any;
EmployeeContractBO_Res_ASSOC_MainSalary_EmployeeContractMainSalary_Rule:any;
EmployeeContractBO_Res_ASSOC_BasicSalary_EmployeeContractBasicSalary_Rule:any;
EmployeeContractBO_Res_ASSOC_OtherSalary_EmployeeContractOtherSalary_Rule:any;
EmployeeContractBO_Res_ASSOC_ContributionRule_EmployeeContractContribution_Rule:any;
EmployeeContractBO_Res_ASSOC_SalaryDeductionRule_EmployeeContractDeduction_Rule:any;
EmployeeContractBO_Res_ASSOC_SpecialInsuranceCase_EmployeeContractContribution_SpecialInsuranceCase:any;
EmployeeContractBO_Res_ASSOC_Department_EmployeeContract_Department:any;
EmployeeContractBO_Res_ASSOC_Employee_EmployeeContract_Supervisor:any;
EmployeeContractBO_Res_ASSOC_BusinessEntity_EmployeeContract_Branch:any;
EmployeeContractBO_Res_ASSOC_PayrollCategory_EmployeeContract_PayrollCategory:any;
EmployeeContractBO_Res_ASSOC_PayrollCategoryLevel_EmployeeContract_PayrollCategoryLevel:any;
EmployeeContractBO_Res_ASSOC_PayrollCategory_PayrollCategoryHistoryEntry_PayrollCategory:any;
EmployeeContractBO_Res_ASSOC_EmployeeContractContribution_SICProfessionPackage_SICProfessionPackage_EmployeeContractContribution:any;
EmployeeContractBO_Res_ASSOC_SalaryPeriod_EmployeeContractSalaryPeriod_SalaryPeriod:any;
EmployeeContractBO_Res_ASSOC_CivilServantBranch_PayRollCategory_PayrollCategory_Branch:any;
Res_ENUM_Placement_Organic:any;
Res_ENUM_Placement_Temporary:any;
Res_ENUM_Placement_AdPersonam:any;
Res_ENUM_InterviewState_Active:any;
Res_ENUM_InterviewState_Complete:any;
Res_ENUM_EmploymentProperty_Worker:any;
Res_ENUM_EmploymentProperty_Employee:any;
Res_ENUM_EmployementSpecialCase_Internship:any;
Res_ENUM_EmployementSpecialCase_PrivateAndClosedPublic:any;
Res_ENUM_EmployementSpecialCase_PrivateAndWidePublic:any;
Res_ENUM_EmploymentResponsiblePosition_None:any;
Res_ENUM_EmploymentResponsiblePosition_Executive:any;
Res_ENUM_EmploymentResponsiblePosition_SalarySixTimesTheBasic:any;
Res_ENUM_EmploymentResponsiblePosition_SalaryEightTimesTheBasic:any;
Res_ENUM_ResidencePermitGroup_PermitWithAccessToJobMarket:any;
Res_ENUM_ResidencePermitGroup_PermitRequiringApproval:any;
Res_ENUM_ResidencePermitGroup_SeasonalWork:any;
Res_ENUM_EapContractType_Item1:any;
Res_ENUM_EapContractType_Item2:any;
Res_ENUM_EapContractType_Item3:any;
Res_ENUM_EapContractType_Item4:any;
Res_ENUM_EapContractType_Item5:any;
Res_ENUM_EapContractType_Item6:any;
Res_ENUM_EapContractType_Item7:any;
Res_ENUM_EapContractType_Item8:any;
Res_ENUM_EapContractType_Item9:any;
Res_ENUM_EapContractType_Item10:any;
Res_ENUM_EapContractType_Item11:any;
Res_ENUM_EapContractType_Item12:any;
Res_ENUM_EapContractType_Item13:any;
Res_ENUM_EapContractType_Item14:any;
Res_ENUM_EapContractType_Item15:any;
Res_ENUM_EapContractType_Item16:any;
Res_ENUM_EapContractType_Item18:any;
Res_ENUM_EapContractType_Item19:any;
Res_ENUM_EapContractType_Item20:any;
Res_ENUM_EapContractType_Item21:any;
Res_ENUM_EapContractType_Item22:any;
Res_ENUM_EapContractType_Item23:any;
Res_ENUM_EapContractType_Item24:any;
Res_ENUM_EapContractType_Item25:any;
Res_ENUM_EapContractType_Item26:any;
Res_ENUM_EapContractType_Item27:any;
Res_ENUM_EapContractType_Item28:any;
Res_ENUM_EapContractType_Item29:any;
Res_ENUM_EapContractType_Item30:any;
Res_ENUM_EapContractType_Item31:any;
EmployeeContractBO_MASS_IMPORT_COMPLETE:any;
EmployeeContractBO_MASS_IMPORT_EMPLOYEE_CODE_NO:any;
EmployeeContractBO_MASS_IMPORT_TEMPLATE_NO:any;
EmployeeContractBO_MASS_IMPORT_ENTITY_NO:any;
EmployeeContractBO_MASS_IMPORT_DEPARTMENT_NO:any;
EmployeeContractBO_MASS_IMPORT_EMPLOYEE_CODE:any;
EmployeeContractBO_MASS_IMPORT_TEMPLATE:any;
EmployeeContractBO_MASS_IMPORT_ENTITY:any;
EmployeeContractBO_MASS_IMPORT_DEPARTMENT:any;
EmployeeContractBO_MASS_IMPORT_BRANCH:any;
EmployeeContractBO_MASS_IMPORT_POSITION:any;
EmployeeContractBO_MASS_IMPORT_EMPLOYEE_SUPERVISOR:any;
EmployeeContractBO_MASS_IMPORT_INSITUTION:any;
EmployeeContractBO_MASS_IMPORT_STARTDATE:any;
EmployeeContractBO_MASS_IMPORT_ENDDATE:any;
EmployeeContractBO_MASS_IMPORT_TERMINATION_REASON:any;
EmployeeContractBO_MASS_IMPORT_TERMINATION_DATE:any;
EmployeeContractBO_MASS_IMPORT_PROFESSION_SPECIALIZATION:any;
EmployeeContractBO_MASS_IMPORT_START_DATE_NO:any;
EmployeeContractBO_MASS_IMPORT_COST_CENTER:any;
EmployeeContractBO_MASS_COST_CENTER_FROM:any;
EmployeeContractBO_MASS_COST_CENTER_TO:any;
EmployeeContractBO_MASS_IMPORT_FLOOR:any;
EmployeeContractBO_MASS_IMPORT_LOCATION:any;
EmployeeContractBO_MASS_IMPORT_EMPLOYEE_POSTION:any;
EmployeeContractBO_MASS_IMPORT_LOCATION_NO:any;
EmployeeContractBO_MASS_IMPORT_FLOOR_NO:any;
EmployeeContractBO_MASS_IMPORT_DEPFLOOR_NO:any;
EmployeeContractBO_MASS_IMPORT_HAZARD_FROM:any;
EmployeeContractBO_MASS_IMPORT_HAZARD_TO:any;
EmployeeContractBO_MASS_IMPORT_ELIGIBILITY_FROM:any;
EmployeeContractBO_MASS_IMPORT_ELIGIBILITY_TO:any;
EmployeeContractBO_MASS_IMPORT_HAZARD_ID:any;
EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_PROJECT:any;
EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_STARTDATE:any;
EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_ENDDATE:any;
EmployeeContractBO_MASS_IMPORT_WORK_PROGRAM:any;
EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_EMPLOYEE_CODE:any;
EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_COMPLETE:any;
EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_CUSTOMER_CODE:any;
EmployeeContractBO_MASS_IMPORT_CUSTOMER_PROJECT_LOCATION_CODE:any;
EmployeeContractBO_MASS_IMPORT_DEPARTMENT_FLOOR:any;
EmployeeContractBO_MASS_IMPORT_DEPARTMENT_NO_POSITIONS:any;
EmployeeContractBO_NonPermanentOver3Years:any;
EmployeeContractBO_NonPermanentOver3:any;
IncomeReceiptBO_Res_ASSOC_TransactionEntity_IncomeReceipt_TransactionEntity:any;
IncomeReceiptBO_Res_ASSOC_BusinessEntity_IncomeReceipt_Entity:any;
IncomeReceiptBO_Res_ASSOC_Budget_IncomeReceipt_Budget:any;
IncomeReceiptBO_Res_ASSOC_BudgetDetail_IncomeReceiptDetail_IncomeBudgetDetail:any;
IncomeReceiptBO_Res_ASSOC_BudgetDetail_IncomeReceiptDetail_ExpenseBudgetDetail:any;
IncomeReceiptBO_Res_ASSOC_ERPFiscalYear_IncomeReceipt_FiscalYear:any;
IncomeReceiptBO_Res_ASSOC_UserAccount_IncomeReceipt_IncomeReceipt_CreatedBy:any;
IncomeReceiptBO_Res_ASSOC_AadeBookInvoiceType_IncomeReceipt_IncomeReceipt_Documents:any;
IncomeReceiptBO_Res_ASSOC_InvoiceRowType_IncomeReceiptDetail_DocumentLine:any;
IncomeReceiptBO_RES_SERIES_NAME_EMPTY:any;
IncomeReceiptBO_RES_CANNOT_MODIFY_SERIES:any;
IncomeReceiptBO_RES_INCOME_RECEIPT:any;
SalariesBO_Res_ASSOC_BasicSalary_RelatedBasicSalary_BasicSalary:any;
SalariesBO_Res_ASSOC_ExternalSalaryType_SalaryRule_AADECode:any;
SalariesBO_Res_ASSOC_ExternalSalaryType_SalaryRule_APDCode:any;
SalariesBO_Res_ASSOC_PayrollCalculatedExpression_SalaryRule_TaxTypeCalculatedExpression:any;
SalariesBO_Res_ASSOC_PayrollVariable_SalaryRule_ParameterVariable:any;
SalariesBO_Res_ASSOC_PayrollVariable_SalaryRule_OutputVariable:any;
Res_ENUM_ParameterCalculationMethod_Fixed:any;
Res_ENUM_ParameterCalculationMethod_Parameter:any;
Res_ENUM_ParameterCalculationMethod_Expression:any;
Res_ENUM_ParameterCalculationMethod_Scale:any;
Res_ENUM_ParameterCalculationMethod_AutoCalculated:any;
Res_ENUM_SystemSalaryPeriod_Basic:any;
Res_ENUM_SystemSalaryPeriod_Leave:any;
Res_ENUM_SystemSalaryPeriod_Sickness:any;
Res_ENUM_SystemSalaryPeriod_EasterBonus:any;
Res_ENUM_SystemSalaryPeriod_ChristmassBonus:any;
Res_ENUM_SystemSalaryPeriod_Recursive:any;
Res_ENUM_SystemSalaryPeriod_Overtime:any;
Res_ENUM_SystemSalaryPeriod_BalanceBonus:any;
Res_ENUM_SystemSalaryPeriod_LeaveBonus:any;
Res_ENUM_SystemSalaryPeriod_LeaveRefund:any;
Res_ENUM_SystemSalaryPeriod_DismissalRefund:any;
Res_ENUM_SystemSalaryPeriod_PlafonRecursive:any;
Res_ENUM_SalaryRuleOpenPeriodHandling_UserValue:any;
Res_ENUM_SalaryRuleOpenPeriodHandling_DefinitionValue:any;
Res_ENUM_SalaryRuleType_Basic:any;
Res_ENUM_SalaryRuleType_Main:any;
Res_ENUM_SalaryRuleType_Other:any;
Res_ENUM_SalaryHistoricVariableHandlingOption_KeepFirst:any;
Res_ENUM_SalaryHistoricVariableHandlingOption_KeepLast:any;
Res_ENUM_SalaryHistoricVariableHandlingOption_Average:any;
Res_ENUM_SystemSalaryPeriod_DismissalRefundDS:any;
PayrollScaleBO_Res_ASSOC_PayrollCategory_PayrollScaleItem_PayrollCategory:any;
PayrollScaleBO_Res_ASSOC_PayrollVariable_PayrollScaleData_PayrollVariable:any;
Res_ENUM_PayrollScaleValueType_WorkExpirience:any;
Res_ENUM_PayrollScaleValueType_NumberOfChildren:any;
Res_ENUM_PayrollScaleValueType_PayrollCategory:any;
Res_ENUM_PayrollScaleValueType_ManualInput:any;
Res_ENUM_PayrollScaleSystemicType_NoneSystemic:any;
Res_ENUM_PayrollScaleSystemicType_FMY:any;
EmploymentContractBO_Res_ASSOC_EmploymentContractType_EmploymentContractTemplate_ContractType:any;
EmploymentContractBO_Res_ASSOC_BasicSalary_EmploymentContractTemplate_BasicSalaries:any;
EmploymentContractBO_Res_ASSOC_MainSalary_EmploymentContractTemplate_MainSalaries:any;
EmploymentContractBO_Res_ASSOC_OtherSalary_EmploymentContractTemplate_OtherSalaries:any;
EmploymentContractBO_Res_ASSOC_SalaryDeductionRule_EmploymentContractTemplate_Deductions:any;
EmploymentContractBO_Res_ASSOC_ContributionRule_EmploymentContractTemplate_Contributions:any;
EmploymentContractBO_Res_ASSOC_EmployeeContractSalaryPeriod_EmploymentContractTemplate_EmploymentContractTemplate_SalaryPeriodConfig:any;
EmploymentContractBO_Res_ASSOC_PayrollCalculatedExpression_EmploymentContractType_TaxTypeCalculatedExpression:any;
Res_ENUM_EmploymentRelationshipType_Salaried:any;
Res_ENUM_EmploymentRelationshipType_DailySalaried:any;
Res_ENUM_EmploymentRelationshipType_HourlySalaried:any;
Res_ENUM_EmploymentRelationshipType_SelfEmployment:any;
Res_ENUM_EmploymentRelationshipType_ReceiptOfExpense:any;
Res_ENUM_EmploymentRelationshipType_Management:any;
Res_ENUM_EmploymentRelationshipType_Internship:any;
Res_ENUM_EmploymentRelationshipType_Trainee:any;
Res_ENUM_EmploymentType_FullTime:any;
Res_ENUM_EmploymentType_PartTime:any;
Res_ENUM_EmploymentType_Intermitting:any;
Res_ENUM_EmploymentType_ByRotation:any;
Res_ENUM_EmploymentType_Director:any;
Res_ENUM_EmploymentType_Internship:any;
Res_ENUM_EmploymentKind_Permanent:any;
Res_ENUM_EmploymentKind_FixedTerm:any;
Res_ENUM_EmploymentKind_ByProject:any;
Res_ENUM_EmploymentKind_SubContract:any;
Res_ENUM_EmploymentKind_Internship:any;
Res_ENUM_EmploymentKind_Trainee:any;
Res_ENUM_EmploymentKind_IDAX:any;
Res_ENUM_EmploymentKind_IDOX:any;
Res_ENUM_EmploymentKind_Installed:any;
Res_ENUM_EmploymentWorkingSchedule_FixedWeekly:any;
Res_ENUM_EmploymentWorkingSchedule_ChangeDaily:any;
Res_ENUM_EmploymentWorkingSchedule_Free:any;
Res_ENUM_EmploymentOpenPeriodCalculation_StartDate:any;
Res_ENUM_EmploymentOpenPeriodCalculation_EndDate:any;
Res_ENUM_EmploymentOpenPeriodCalculation_Calendar:any;
Res_ENUM_BonusPaymentType_Legal:any;
Res_ENUM_BonusPaymentType_Full:any;
Res_ENUM_CompensationType_Salaried:any;
Res_ENUM_CompensationType_DailySalaried:any;
Res_ENUM_CompensationType_ByContract:any;
Res_ENUM_CompensationType_NoPayment:any;
Res_ENUM_WorkingDaysCalculationMethod_Method1:any;
Res_ENUM_WorkingDaysCalculationMethod_Method2:any;
Res_ENUM_WorkingDaysCalculationMethod_Method3:any;
Res_ENUM_APDDailyWageEarner_FiveDays:any;
Res_ENUM_APDDailyWageEarner_SixDays:any;
Res_ENUM_ParameterType_Days:any;
Res_ENUM_ParameterType_Hours:any;
Res_ENUM_ParameterType_Fixed:any;
Res_ENUM_InsuranceDailySalaryCalculationMethod_Value:any;
Res_ENUM_InsuranceDailySalaryCalculationMethod_ValueMultiplier:any;
Res_ENUM_InsuranceDailySalaryCalculationMethod_Manual:any;
Res_ENUM_InsuranceDailySalaryCalculationMethod_Expression:any;
Res_ENUM_MainSalaryTaxType_FMY:any;
Res_ENUM_MainSalaryTaxType_Multiplier:any;
Res_ENUM_MainSalaryTaxType_Expression:any;
Res_ENUM_MainSalaryTaxType_TaxFree:any;
Res_ENUM_ExpressionTemplate_Bonus:any;
Res_ENUM_ExpressionTemplate_Overtime:any;
Res_ENUM_ExpressionTemplate_NonWorkingDay:any;
Res_ENUM_ExpressionTemplate_PerQuantity:any;
Res_ENUM_ExpressionTemplate_Custom:any;
Res_ENUM_OtherSalaryMultiplierA_Fixed:any;
Res_ENUM_OtherSalaryMultiplierA_Hours:any;
Res_ENUM_OtherSalaryMultiplierA_Days:any;
Res_ENUM_OtherSalaryMultiplierA_Quantity:any;
Res_ENUM_OtherSalaryMultiplierA_ExpressionType:any;
Res_ENUM_OtherSalaryMultiplierB_DailySalary:any;
Res_ENUM_OtherSalaryMultiplierB_HourlyRate:any;
Res_ENUM_OtherSalaryMultiplierB_Fixed:any;
Res_ENUM_OtherSalaryMultiplierB_ExpressionType:any;
Res_ENUM_OtherSalaryMultiplierB_Empty:any;
Res_ENUM_ExternalSalaryTypeSystem_APD:any;
Res_ENUM_ExternalSalaryTypeSystem_AADE:any;
Res_ENUM_ExternalSalaryTypeSystem_AADE_BUSINESS:any;
Res_ENUM_ExternalSalaryTypeSystem_AADE_DIVIDENT:any;
PayrollCalculatedExpressionBO_Res_ASSOC_PayrollCalculatedExpressionVersion_PayrollCalculatedExpression_Data:any;
PayrollCalculatedExpressionBO_Res_ASSOC_PayrollVariable_PayrollCalculatedExpression_lstPayrollVariable:any;
Res_ENUM_PayrollCalculationFormulaModule_Leaves:any;
PayrollCalculatedExpressionBO_MASS_IMPORT_COMPLETE:any;
ContributionRulesBO_Res_ASSOC_ContributionRuleCalculation_ContributionRule_EmployeeData:any;
ContributionRulesBO_Res_ASSOC_ContributionRuleCalculation_ContributionRule_EmployerData:any;
ContributionRulesBO_Res_ASSOC_ContributionRuleCalculationSubsidy_ContributionRuleCalculation_SubsidyRules:any;
ContributionRulesBO_Res_ASSOC_SalaryPeriod_ContributionRule_SalaryPeriods:any;
ContributionRulesBO_Res_ASSOC_PayrollCalculatedExpression_ContributionRuleCalculationSubsidy_CalculatedExpression:any;
ContributionRulesBO_Res_ASSOC_AccountingSystemEntityConfig_ContributionRule_AccountingConfig:any;
ContributionRulesBO_Res_ASSOC_PayrollVariable_ContributionRuleCalculation_Variable:any;
Res_ENUM_InsuranceOfficeType_EFKA:any;
Res_ENUM_InsuranceOfficeType_TEKA:any;
Res_ENUM_InsuranceOfficeType_TEA:any;
Res_ENUM_InsuranceOfficeType_Private:any;
Res_ENUM_ContributionRuleValueUpdateType_CoveragePackage:any;
Res_ENUM_ContributionRuleValueUpdateType_Fixed:any;
Res_ENUM_ContributionRuleValueUpdateType_Parameter:any;
Res_ENUM_ContributionRuleValueUpdateType_Expression:any;
Res_ENUM_ContributionRuleCalculationBase_AllSalaries:any;
Res_ENUM_ContributionRuleCalculationBase_SpecificSalaries:any;
Res_ENUM_ContributionRuleCalculationBase_Imputed:any;
SalaryDeductionRuleBO_Res_ASSOC_AccountingSystemEntityConfig_SalaryDeductionRule_AccountingConfig:any;
SalaryDeductionRuleBO_Res_ASSOC_PayrollVariable_SalaryDeductionRuleCalculation_PayrollVariable:any;
Res_ENUM_ApplyRuleFor_Employee:any;
Res_ENUM_ApplyRuleFor_Employer:any;
Res_ENUM_ApplyRuleFor_Both:any;
SalaryLoanRulesBO_Res_ASSOC_PayrollVariable_SalaryLoanType_PayrollVariable:any;
SalaryLoanRulesBO_Res_ASSOC_EmployeeContract_EmployeeSalaryLoan_Contract:any;
SalaryLoanRulesBO_Res_ASSOC_SalaryLoanType_EmployeeSalaryLoan_Type:any;
SalaryLoanRulesBO_Res_ASSOC_SalaryPeriod_EmployeeSalaryLoanInstalment_SalaryPeriod:any;
Res_ENUM_EmployeeSalaryLoanStatus_Pending:any;
Res_ENUM_EmployeeSalaryLoanStatus_Approved:any;
Res_ENUM_EmployeeSalaryLoanStatus_Canceled:any;
SalaryLoanRulesBO_RES_ERROR_AMOUNT_NO_MATCH:any;
SalaryLoanRulesBO_RES_ERROR_CANNOT_MODIFY:any;
SalaryLoanRulesBO_MASS_IMPORT_COMPLETE:any;
SalaryLoanRulesBO_MASS_IMPORT_EMPLOYEE_NO:any;
SalaryLoanRulesBO_MASS_IMPORT_TYPE_NO:any;
SalaryLoanRulesBO_MASS_IMPORT_AMOUNT_NO:any;
SalaryLoanRulesBO_MASS_IMPORT_INSTALLMENTS_NO:any;
SalaryLoanRulesBO_MASS_IMPORT_STARTDATE_NO:any;
SalaryLoanRulesBO_MASS_IMPORT_EMPLOYEE:any;
SalaryLoanRulesBO_MASS_IMPORT_TYPE:any;
SalaryLoanRulesBO_MASS_IMPORT_START_DATE:any;
SalaryLoanRulesBO_MASS_IMPORT_EMPLOYEE_CONTRACT:any;
ViewmodelHelperBO_Res_ASSOC_AssetCategory_CreateGoodDTO_AssetCategory:any;
ViewmodelHelperBO_Res_ASSOC_VatCategoryValueObject_CreateGoodDTO_VATRate:any;
ViewmodelHelperBO_Res_ASSOC_GoodCategory_CreateGoodDTO_GoodCat:any;
Res_ENUM_CreateGoodType_Asset:any;
Res_ENUM_CreateGoodType_Good:any;
LeaveRuleBO_Res_ASSOC_ErganiLeaveType_LeaveRule_ErganiLeaveType:any;
LeaveRuleBO_Res_ASSOC_LeaveRuleType_LeaveRule_LeaveType:any;
LeaveRuleBO_Res_ASSOC_LeaveRule_LeaveRule_InheritEntitlementFrom:any;
LeaveRuleBO_Res_ASSOC_ApprovalFlow_LeaveRule_ApprovalFlow:any;
LeaveRuleBO_Res_ASSOC_DynamicReport_LeaveRule_AcceptanceDocumentTemplate:any;
Res_ENUM_LeaveTimeUnit_Days:any;
Res_ENUM_LeaveTimeUnit_Hours:any;
Res_ENUM_LeaveBalanceCalendar_None:any;
Res_ENUM_LeaveBalanceCalendar_Anniversary:any;
Res_ENUM_LeaveBalanceCalendar_Calendar:any;
Res_ENUM_LeaveSubsidyProvider_EFKA:any;
Res_ENUM_LeaveSubsidyProvider_DYPA:any;
Res_ENUM_LeaveEntitlementOverbalanceHandling_NotAllowed:any;
Res_ENUM_LeaveEntitlementOverbalanceHandling_Warning:any;
Res_ENUM_RuleEntitlementMethod_User:any;
Res_ENUM_RuleEntitlementMethod_NormalLeave:any;
Res_ENUM_RuleEntitlementMethod_Illness:any;
LeaveRuleBO_MASS_IMPORT_COMPLETE:any;
EmployeeLeaveBO_Res_ASSOC_UserAccount_EmployeeLeaveRequest_RequestedBy:any;
EmployeeLeaveBO_Res_ASSOC_LeaveRule_EmployeeLeave_LeaveTypes:any;
EmployeeLeaveBO_Res_ASSOC_EmployeeContract_LeaveTypes_EmployeeLeave_EmployeeContract:any;
EmployeeLeaveBO_Res_ASSOC_EmployeeLeave_EmployeeLeaveRequest_EmployeeLeave:any;
EmployeeLeaveBO_Res_ASSOC_PendingTask_EmployeeLeaveRequest_ActiveTask:any;
EmployeeLeaveBO_Res_ASSOC_UserAccount_OvertimeRequest_RequestedBy:any;
EmployeeLeaveBO_Res_ASSOC_UserAccount_OvertimeRequest_Assignee:any;
EmployeeLeaveBO_Res_ASSOC_UserAccount_OvertimeRequest_HandledBy:any;
EmployeeLeaveBO_Res_ASSOC_EmployeeContract_OvertimeRequest_EmployeeContract:any;
EmployeeLeaveBO_Res_ASSOC_EmployeeContract_EmployeeWorkingCalendar_Employee:any;
EmployeeLeaveBO_Res_ASSOC_LeaveRule_EmployeeLeaveRequest_LeaveRule:any;
EmployeeLeaveBO_Res_ASSOC_ApprovalFlowScenario_EmployeeLeaveRequest_ApprovalFlowScenario:any;
EmployeeLeaveBO_Res_ASSOC_PayrollVariable_OvertimeRequestType_PayrollVariable:any;
EmployeeLeaveBO_Res_ASSOC_OvertimeRequestType_OvertimeRequest_OvertimeType:any;
EmployeeLeaveBO_Res_ASSOC_OvertimeErganiType_OvertimeRequest_ErganiType:any;
Res_ENUM_LeaveRequestStatus_Temporary:any;
Res_ENUM_LeaveRequestStatus_Pending:any;
Res_ENUM_LeaveRequestStatus_Validating:any;
Res_ENUM_LeaveRequestStatus_Approved:any;
Res_ENUM_LeaveRequestStatus_Rejected:any;
Res_ENUM_LeaveRequestStatus_Cancelled:any;
Res_ENUM_OvertimeType_Overtime:any;
Res_ENUM_OvertimeType_Overwork:any;
EmployeeLeaveBO_RES_CUSTOM_INVALID_STATUS_TRANSITION:any;
EmployeeLeaveBO_RES_CUSTOM_VALIDATION_OVERLAPING_DAYS:any;
EmployeeLeaveBO_RES_NOTIFY_LEAVE_APPROVAL:any;
EmployeeLeaveBO_RES_NOTIFY_LEAVE_INFORM:any;
EmployeeLeaveBO_RES_NOTIFY_LEAVE_ACCEPTED:any;
EmployeeLeaveBO_RES_NOTIFY_LEAVE_REJECTED:any;
EmployeeLeaveBO_MASS_IMPORT_EMPLOYEE_CONTRACT_NO:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TYPE_CODE_NO:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_DATE_REQUIRED:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_REQUESTED_DATE_NO:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_HOURS_FROM_TO_REQUIRED:any;
EmployeeLeaveBO_MASS_IMPORT_COMPLETE:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_EMPLOYEE_CODE_NO:any;
EmployeeLeaveBO_RES_WRONG_EMPLOEE_CODE:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TYPE_CODE_REQUIRED:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_HOURS_WRONG:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_FROM_HOURS_WRONG:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TO_HOURS_WRONG:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_FROM_MIN_WRONG:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TO__WRONG:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TIME_WRONG:any;
EmployeeLeaveBO_MASS_IMPORT_OVERTIME_ERGANIS_TYPE_WRONG:any;
BudgetingReports_Res_ASSOC_MainBudgetingReportLine_MainBudgetingReport_ExpenseTotals:any;
BudgetingReports_Res_ASSOC_MainBudgetingReportLine_MainBudgetingReport_IncomeTotals:any;
BudgetingReports_Res_ASSOC_MainBudgetingReportLine_MainBudgetingReport_CategoriesTotals:any;
AssetDepreciationBO_Res_ASSOC_AssetDepreciationRate_AssetDepreciationCategory_DepreciationRate:any;
Res_ENUM_AssetDepreciationType_AccountingBase:any;
Res_ENUM_AssetDepreciationType_TaxBase:any;
Res_ENUM_AssetDepreciationMethod_Constant:any;
Res_ENUM_AssetDepreciationMethod_Decreasing:any;
Res_ENUM_AssetDepreciationMethod_Total:any;
Res_ENUM_AssetDepreciationPeriodType_Months:any;
Res_ENUM_AssetDepreciationPeriodType_Days:any;
Res_ENUM_DepreciationStartType_NextMonth:any;
Res_ENUM_DepreciationStartType_PurchaseDate:any;
Res_ENUM_AssetDepreciationMonthsCalculationType_MonthIsCounted:any;
Res_ENUM_AssetDepreciationMonthsCalculationType_MonthIsAlwaysCounted:any;
Res_ENUM_AssetDepreciationMonthsCalculationType_MonthIsNeverCounted:any;
Res_ENUM_MonthStartType_NextMonth:any;
Res_ENUM_MonthStartType_PurchaseDate:any;
EntityCodeStructrureBO_Res_ASSOC_BusinessEntity_CodeAssignmentConfiguration_Entity:any;
EntityCodeStructrureBO_Res_ASSOC_BusinessEntity_UniqueNumberStorage_Entity:any;
EntityCodeStructrureBO_Res_ASSOC_AccountingSystemEntity_CodeAssignmentConfiguration_BO:any;
EntityCodeStructrureBO_Res_ASSOC_ERPFiscalYear_UniqueNumberStorage_FiscalYear:any;
Res_ENUM_CodeAssignmentSegmentType_AutoIncrement:any;
Res_ENUM_CodeAssignmentSegmentType_Manual:any;
Res_ENUM_CodeAssignmentSegmentType_Options:any;
Res_ENUM_CodeAssignmentSegmentType_HardCoded:any;
LongRunningTaskBO_Res_ASSOC_UserAccount_LongRunningTask_StartedBy:any;
Res_ENUM_HolidayType_ByLaw:any;
Res_ENUM_HolidayType_Company:any;
Res_ENUM_HolidayType_Speciality:any;
AssetImprovementBO_Res_ASSOC_Asset_AssetImprovement_Asset:any;
AssetImprovementBO_Res_ASSOC_Asset_AssetImprovementDetail_SubAsset:any;
AssetImprovementBO_Res_ASSOC_ERPFiscalYear_AssetImprovement_ERPFiscalYear:any;
GeneralJournalDocumentTemplate_Res_ASSOC_Ledger_GeneralJournalDocumentTemplateLine_Ledger:any;
GeneralJournalDocumentTemplate_Res_ASSOC_FiscalPeriod_GeneralJournalDocumentTemplate_FiscalPeriod:any;
GeneralJournalDocumentTemplate_Res_ASSOC_AccountingBusinessEntity_GeneralJournalDocumentTemplate_Entity:any;
GeneralJournalDocumentTemplate_Res_ASSOC_GeneralJournalTemplateInputGroup_GeneralJournalDocumentTemplateEntry_Group:any;
GeneralJournalDocumentTemplate_Res_ASSOC_GeneralJournalTemplateInputGroup_Lines_GeneralJournalTemplateGroupLine_GeneralJournalTemplateInputGroup:any;
GeneralJournalDocumentTemplate_Res_ASSOC_GeneralJournalDocumentTemplateEntry_GeneralJournalTemplateFillLine_Definition:any;
GeneralJournalDocumentTemplate_Res_ASSOC_Account_GeneralJournalTemplateFillLine_ActualAccount:any;
LedgerJournalRuleBO_Res_ASSOC_AccountingBusinessEntity_LedgerJournalRule_Entity:any;
LedgerJournalRuleBO_Res_ASSOC_Ledger_LedgerJournalRule_Ledger:any;
LedgerJournalRuleBO_Res_ASSOC_AccountingJournal_LedgerJournalRule_SourceJournal:any;
LedgerJournalRuleBO_Res_ASSOC_AccountingJournal_LedgerJournalRule_TargetJournal:any;
LedgerJournalRuleBO_Res_ASSOC_FiscalPeriod_LedgerJournalRule_FiscalPeriod:any;
Res_ENUM_EmailStatus_Initialized:any;
Res_ENUM_EmailStatus_Queued:any;
Res_ENUM_EmailStatus_Sent:any;
Res_ENUM_EmailStatus_Failed:any;
UtilitiesBO_RES_EMAIL_ALREADY_QUEUED:any;
UtilitiesBO_RES_EMAIL_ALREADY_SENT:any;
UtilitiesBO_AMKA_Length:any;
UtilitiesBO_AMKA_Date:any;
UtilitiesBO_AFM_Invalid:any;
UtilitiesBO_AFM_Length:any;
UtilitiesBO_RES_AT_LEAST_ONE_DEPENDENCY_CANNOT_BE_DELETED:any;
UtilitiesBO_RES_DELETE_DEPENDENCY_NOT_IMPLEMENTED:any;
UtilitiesBO_PERSONALNUMBER_Length:any;
UtilitiesBO_PERSONALNUMBER_AFMNULL:any;
UtilitiesBO_PERSONALNUMBER_WRONG:any;
UtilitiesBO_AMKA_Masked:any;
AccountingPrintingTemplateBO_Res_ASSOC_AccountingBusinessEntity_AccountingPrintingTemplate_Entity:any;
AccountingPrintingTemplateBO_Res_ASSOC_FiscalPeriod_AccountingPrintingTemplate_FiscalPeriod:any;
AccountingAllocationRelationBO_Res_ASSOC_AccountingBusinessEntity_AccountingAllocationRelation_Entity:any;
AccountingAllocationRelationBO_Res_ASSOC_FiscalPeriod_AccountingAllocationRelation_FiscalPeriod:any;
AccountingAllocationRelationBO_Res_ASSOC_Ledger_AccountingAllocationRelation_SourceLedger:any;
AccountingAllocationRelationBO_Res_ASSOC_Ledger_AccountingAllocationRelation_TargetLedger:any;
AccountingAllocationRelationBO_Res_ASSOC_AccountingJournal_AccountingAllocationRelation_TargetJournal:any;
AccountingAllocationRelationBO_Res_ASSOC_TAccount_AccountingAllocationRelationDetail_Account:any;
AccountingAllocationRelationBO_Res_ASSOC_TAccount_AccountingAllocationRelation_TAccount:any;
TaskManagementBO_Res_ASSOC_UserAccount_PendingTask_AssignedTo:any;
TaskManagementBO_Res_ASSOC_BusinessEntity_PendingTask_Entity:any;
TaskManagementBO_Res_ASSOC_UserAccount_PendingTask_HandledBy:any;
Res_ENUM_PendingTaskType_ApproveLeave:any;
Res_ENUM_PendingTaskType_CheckLeaveData:any;
Res_ENUM_PendingTaskType_Information:any;
Res_ENUM_PendingTaskType_BackoffceSyncFailed:any;
Res_ENUM_TaskResultMessageSeverity_Info:any;
Res_ENUM_TaskResultMessageSeverity_Warning:any;
Res_ENUM_TaskResultMessageSeverity_Error:any;
Res_ENUM_PendingTaskType_ApproveResignation:any;
AssetTransactionBO_Res_ASSOC_ERPFiscalYear_AssetTransaction_ERPFiscalYear:any;
AssetTransactionBO_Res_ASSOC_TransactionEntity_AssetTransaction_Customer:any;
AssetTransactionBO_Res_ASSOC_InvoiceRowType_AssetTransactionItem_TransactionDocumentDetail:any;
AssetTransactionBO_Res_ASSOC_AssetTransaction_ParentAsset_Asset_AssetTransaction_1:any;
AssetTransactionBO_Res_ASSOC_BusinessEntity_AcquisitionSubsidyEntities_Entity:any;
Res_ENUM_AssetTransactionType_Acquisition:any;
Res_ENUM_AssetTransactionType_Improvement:any;
Res_ENUM_AssetTransactionType_Sale:any;
Res_ENUM_AssetTransactionType_Destruction:any;
Res_ENUM_AssetTransactionType_Transfer:any;
Res_ENUM_AssetTransactionType_Trading:any;
Res_ENUM_AssetTransactionType_Settlement:any;
Res_ENUM_AssetTransactionType_Adjustment:any;
Res_ENUM_AssetTransactionType_Depreciation:any;
Res_ENUM_AssetAcquisionType_PurchaseInvoice:any;
Res_ENUM_AssetAcquisionType_Donation:any;
Res_ENUM_AssetAcquisionType_Expropriation:any;
Res_ENUM_AssetAcquisionType_Subsidy:any;
Res_ENUM_AssetDestructionType_Destructed:any;
Res_ENUM_AssetDestructionType_Lost:any;
Res_ENUM_AssetDestructionType_Stolen:any;
AssetTransactionBO_RES_SUBSIDY_SUM:any;
AssetTransactionBO_RES_ACQUISITION_QUANTITY_POSITIVE:any;
AssetTransactionBO_RES_FINALIZED_TRANSACTION:any;
AssetTransactionBO_RES_PARTIAL_MUST_BE_INTEGER:any;
AssetTransactionBO_RES_PARTIAL_EXCEEDS_QUANTITY:any;
AssetTransactionBO_RES_ASSET_NOT_FOUND_IN_INVOICE:any;
AssetTransactionBO_RES_QUANTITY_MUST_BE_INT:any;
AssetTransactionBO_RES_QUANTITY_MUST_BE_GREATER_THAN_ONE:any;
AssetTransactionBO_RES_PARENT_NOT_ALLOWED:any;
AssetTransactionBO_RES_SERIALS_CANNOT_HAVE_TWO:any;
AssetTransactionBO_RES_SERIALS_MUST_BE_QUANTITY:any;
Res_ENUM_SourceType_AADE:any;
Res_ENUM_SourceType_ERP:any;
Res_ENUM_SourceType_LOCAL:any;
Res_ENUM_FCParamValueType_DateTime:any;
Res_ENUM_FCParamValueType_Numeric:any;
Res_ENUM_FCParamValueType_String:any;
ClassificationTypeBO_Res_ASSOC_ExpensesClassificationCategoryValueObject_ExpensesClassificationType_ClassificationCategory:any;
ClassificationTypeBO_Res_ASSOC_IncomeClassificationCategoryValueObject_IncomeClassificationType_ClassificationCategory:any;
Res_ENUM_ClassificationType_Income:any;
Res_ENUM_ClassificationType_Expenses:any;
Res_ENUM_IncomeClassificationCategoryType_category1_1:any;
Res_ENUM_IncomeClassificationCategoryType_category1_2:any;
Res_ENUM_IncomeClassificationCategoryType_category1_3:any;
Res_ENUM_IncomeClassificationCategoryType_category1_4:any;
Res_ENUM_IncomeClassificationCategoryType_category1_5:any;
Res_ENUM_IncomeClassificationCategoryType_category1_6:any;
Res_ENUM_IncomeClassificationCategoryType_category1_7:any;
Res_ENUM_IncomeClassificationCategoryType_category1_8:any;
Res_ENUM_IncomeClassificationCategoryType_category1_9:any;
Res_ENUM_IncomeClassificationCategoryType_category1_10:any;
Res_ENUM_IncomeClassificationCategoryType_category1_95:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_1:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_2:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_3:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_4:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_5:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_6:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_7:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_8:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_9:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_10:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_11:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_12:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_13:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_14:any;
Res_ENUM_ExpensesClassificationCategoryType_category2_95:any;
ValueList_Res_ASSOC_BudgetItem_TaxCategoryValueObject_IncomeAccount:any;
ValueList_Res_ASSOC_BudgetItem_TaxCategoryValueObject_ExpenseAccount:any;
ValueList_Res_ASSOC_InvoiceTransactionConfiguration_InvoiceTypeValueObject_IncomeConfiguration:any;
ValueList_Res_ASSOC_InvoiceTransactionConfiguration_InvoiceTypeValueObject_ExpensesConfiguration:any;
ValueList_Res_ASSOC_InvoiceTransactionConfiguration_InvoiceTypeValueObject_AccountingConfiguration:any;
ValueList_Res_ASSOC_AccountingSystemEntityConfig_VatCategoryValueObject_AccountingConfig:any;
ValueList_Res_ASSOC_AccountingSystemEntityConfig_TaxCategoryValueObject_AccountingConfig:any;
ValueList_Res_ASSOC_TransactionEntity_TaxCategoryValueObject_Treasury:any;
ValueList_Res_ASSOC_PaymentMethodDetailTypeValueObject_InvoiceTypeValueObject_DefaultPaymentMethod:any;
ValueList_Res_ASSOC_BudgetItem_VatCategoryValueObject_ExpenseBudgetItem:any;
Res_ENUM_TaxType_Empty:any;
Res_ENUM_TaxType_WithHeld:any;
Res_ENUM_TaxType_Fees:any;
Res_ENUM_TaxType_OtherTax:any;
Res_ENUM_TaxType_StampDuty:any;
Res_ENUM_TaxType_Deduction:any;
Res_ENUM_CurrencyType_AED:any;
Res_ENUM_CurrencyType_AFN:any;
Res_ENUM_CurrencyType_ALL:any;
Res_ENUM_CurrencyType_AMD:any;
Res_ENUM_CurrencyType_ANG:any;
Res_ENUM_CurrencyType_AOA:any;
Res_ENUM_CurrencyType_ARS:any;
Res_ENUM_CurrencyType_AUD:any;
Res_ENUM_CurrencyType_AWG:any;
Res_ENUM_CurrencyType_AZN:any;
Res_ENUM_CurrencyType_BAM:any;
Res_ENUM_CurrencyType_BBD:any;
Res_ENUM_CurrencyType_BDT:any;
Res_ENUM_CurrencyType_BGN:any;
Res_ENUM_CurrencyType_BHD:any;
Res_ENUM_CurrencyType_BIF:any;
Res_ENUM_CurrencyType_BMD:any;
Res_ENUM_CurrencyType_BND:any;
Res_ENUM_CurrencyType_BOB:any;
Res_ENUM_CurrencyType_BOV:any;
Res_ENUM_CurrencyType_BRL:any;
Res_ENUM_CurrencyType_BSD:any;
Res_ENUM_CurrencyType_BTN:any;
Res_ENUM_CurrencyType_BWP:any;
Res_ENUM_CurrencyType_BYR:any;
Res_ENUM_CurrencyType_BZD:any;
Res_ENUM_CurrencyType_CAD:any;
Res_ENUM_CurrencyType_CDF:any;
Res_ENUM_CurrencyType_CHF:any;
Res_ENUM_CurrencyType_CLF:any;
Res_ENUM_CurrencyType_CLP:any;
Res_ENUM_CurrencyType_CNY:any;
Res_ENUM_CurrencyType_COP:any;
Res_ENUM_CurrencyType_COU:any;
Res_ENUM_CurrencyType_CRC:any;
Res_ENUM_CurrencyType_CUC:any;
Res_ENUM_CurrencyType_CUP:any;
Res_ENUM_CurrencyType_CVE:any;
Res_ENUM_CurrencyType_CZK:any;
Res_ENUM_CurrencyType_DJF:any;
Res_ENUM_CurrencyType_DKK:any;
Res_ENUM_CurrencyType_DOP:any;
Res_ENUM_CurrencyType_DZD:any;
Res_ENUM_CurrencyType_EEK:any;
Res_ENUM_CurrencyType_EGP:any;
Res_ENUM_CurrencyType_ERN:any;
Res_ENUM_CurrencyType_ETB:any;
Res_ENUM_CurrencyType_EUR:any;
Res_ENUM_CurrencyType_FJD:any;
Res_ENUM_CurrencyType_FKP:any;
Res_ENUM_CurrencyType_GBP:any;
Res_ENUM_CurrencyType_GEL:any;
Res_ENUM_CurrencyType_GHS:any;
Res_ENUM_CurrencyType_GIP:any;
Res_ENUM_CurrencyType_GMD:any;
Res_ENUM_CurrencyType_GNF:any;
Res_ENUM_CurrencyType_GTQ:any;
Res_ENUM_CurrencyType_GWP:any;
Res_ENUM_CurrencyType_GYD:any;
Res_ENUM_CurrencyType_HKD:any;
Res_ENUM_CurrencyType_HNL:any;
Res_ENUM_CurrencyType_HRK:any;
Res_ENUM_CurrencyType_HTG:any;
Res_ENUM_CurrencyType_HUF:any;
Res_ENUM_CurrencyType_IDR:any;
Res_ENUM_CurrencyType_ILS:any;
Res_ENUM_CurrencyType_INR:any;
Res_ENUM_CurrencyType_IQD:any;
Res_ENUM_CurrencyType_IRR:any;
Res_ENUM_CurrencyType_ISK:any;
Res_ENUM_CurrencyType_JMD:any;
Res_ENUM_CurrencyType_JOD:any;
Res_ENUM_CurrencyType_JPY:any;
Res_ENUM_CurrencyType_KES:any;
Res_ENUM_CurrencyType_KGS:any;
Res_ENUM_CurrencyType_KHR:any;
Res_ENUM_CurrencyType_KMF:any;
Res_ENUM_CurrencyType_KPW:any;
Res_ENUM_CurrencyType_KRW:any;
Res_ENUM_CurrencyType_KWD:any;
Res_ENUM_CurrencyType_KYD:any;
Res_ENUM_CurrencyType_KZT:any;
Res_ENUM_CurrencyType_LAK:any;
Res_ENUM_CurrencyType_LBP:any;
Res_ENUM_CurrencyType_LKR:any;
Res_ENUM_CurrencyType_LRD:any;
Res_ENUM_CurrencyType_LSL:any;
Res_ENUM_CurrencyType_LTL:any;
Res_ENUM_CurrencyType_LVL:any;
Res_ENUM_CurrencyType_LYD:any;
Res_ENUM_CurrencyType_MAD:any;
Res_ENUM_CurrencyType_MDL:any;
Res_ENUM_CurrencyType_MGA:any;
Res_ENUM_CurrencyType_MKD:any;
Res_ENUM_CurrencyType_MMK:any;
Res_ENUM_CurrencyType_MNT:any;
Res_ENUM_CurrencyType_MOP:any;
Res_ENUM_CurrencyType_MRO:any;
Res_ENUM_CurrencyType_MUR:any;
Res_ENUM_CurrencyType_MVR:any;
Res_ENUM_CurrencyType_MWK:any;
Res_ENUM_CurrencyType_MXN:any;
Res_ENUM_CurrencyType_MYR:any;
Res_ENUM_CurrencyType_MZN:any;
Res_ENUM_CurrencyType_NAD:any;
Res_ENUM_CurrencyType_NGN:any;
Res_ENUM_CurrencyType_NIO:any;
Res_ENUM_CurrencyType_NOK:any;
Res_ENUM_CurrencyType_NPR:any;
Res_ENUM_CurrencyType_NZD:any;
Res_ENUM_CurrencyType_OMR:any;
Res_ENUM_CurrencyType_PAB:any;
Res_ENUM_CurrencyType_PEN:any;
Res_ENUM_CurrencyType_PGK:any;
Res_ENUM_CurrencyType_PHP:any;
Res_ENUM_CurrencyType_PKR:any;
Res_ENUM_CurrencyType_PLN:any;
Res_ENUM_CurrencyType_PYG:any;
Res_ENUM_CurrencyType_QAR:any;
Res_ENUM_CurrencyType_RON:any;
Res_ENUM_CurrencyType_RSD:any;
Res_ENUM_CurrencyType_RUB:any;
Res_ENUM_CurrencyType_RWF:any;
Res_ENUM_CurrencyType_SAR:any;
Res_ENUM_CurrencyType_SBD:any;
Res_ENUM_CurrencyType_SCR:any;
Res_ENUM_CurrencyType_SDG:any;
Res_ENUM_CurrencyType_SEK:any;
Res_ENUM_CurrencyType_SGD:any;
Res_ENUM_CurrencyType_SHP:any;
Res_ENUM_CurrencyType_SLL:any;
Res_ENUM_CurrencyType_SOS:any;
Res_ENUM_CurrencyType_SRD:any;
Res_ENUM_CurrencyType_STD:any;
Res_ENUM_CurrencyType_SVC:any;
Res_ENUM_CurrencyType_SYP:any;
Res_ENUM_CurrencyType_SZL:any;
Res_ENUM_CurrencyType_THB:any;
Res_ENUM_CurrencyType_TJS:any;
Res_ENUM_CurrencyType_TMT:any;
Res_ENUM_CurrencyType_TND:any;
Res_ENUM_CurrencyType_TOP:any;
Res_ENUM_CurrencyType_TRY:any;
Res_ENUM_CurrencyType_TTD:any;
Res_ENUM_CurrencyType_TVD:any;
Res_ENUM_CurrencyType_TWD:any;
Res_ENUM_CurrencyType_TZS:any;
Res_ENUM_CurrencyType_UAH:any;
Res_ENUM_CurrencyType_UGX:any;
Res_ENUM_CurrencyType_USD:any;
Res_ENUM_CurrencyType_UYU:any;
Res_ENUM_CurrencyType_UZS:any;
Res_ENUM_CurrencyType_VEF:any;
Res_ENUM_CurrencyType_VND:any;
Res_ENUM_CurrencyType_VUV:any;
Res_ENUM_CurrencyType_WST:any;
Res_ENUM_CurrencyType_XAF:any;
Res_ENUM_CurrencyType_XCD:any;
Res_ENUM_CurrencyType_XOF:any;
Res_ENUM_CurrencyType_XPD:any;
Res_ENUM_CurrencyType_XPF:any;
Res_ENUM_CurrencyType_YER:any;
Res_ENUM_CurrencyType_ZAR:any;
Res_ENUM_CurrencyType_ZMK:any;
Res_ENUM_CurrencyType_ZWL:any;
AADEBO_Res_ASSOC_InvoiceHeaderType_AadeBookInvoiceType_InvoiceHeader:any;
AADEBO_Res_ASSOC_BusinessEntity_AadeBookInvoiceType_Entity:any;
AADEBO_Res_ASSOC_TransactionEntity_AadeBookInvoiceType_TransactionEntity:any;
AADEBO_Res_ASSOC_TransactionDocumentSeries_InvoiceHeaderType_ERPSeries:any;
AADEBO_Res_ASSOC_InvoiceTypeValueObject_InvoiceHeaderType_InvoiceType:any;
AADEBO_Res_ASSOC_TaxCategoryValueObject_TaxTotalsType_Tax:any;
AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_WithheldPercentCategory:any;
AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_StampDutyPercentCategory:any;
AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_FeesPercentCategory:any;
AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_OtherTaxesPercentCategory:any;
AADEBO_Res_ASSOC_TaxCategoryValueObject_InvoiceRowType_DeductionsPercentCategory:any;
AADEBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_PaymentMethodDetailType_PaymentMethod:any;
AADEBO_Res_ASSOC_Currency_InvoiceHeaderType_Currency:any;
AADEBO_Res_ASSOC_VatExemptionCategoryValueObject_InvoiceRowType_VatExemptionCategory:any;
AADEBO_Res_ASSOC_VatCategoryValueObject_InvoiceRowType_VatCategory:any;
AADEBO_Res_ASSOC_IncomeClassificationCategoryValueObject_InvoiceIncomeClassificationCategory_Category:any;
AADEBO_Res_ASSOC_IncomeClassificationTypeValueObject_InvoiceIncomeClassificationCategory_Types:any;
AADEBO_Res_ASSOC_ExpensesClassificationCategoryValueObject_InvoiceExpensesClassificationCategory_Category:any;
AADEBO_Res_ASSOC_ExpensesClassificationTypeValueObject_InvoiceExpensesClassificationCategory_Types:any;
AADEBO_Res_ASSOC_VatCategoryValueObject_InvoiceVATCategoryTotal_VATCategory:any;
AADEBO_Res_ASSOC_AadeBookInvoiceType_CorrelatedInvoicesOpposite_AadeBookInvoiceType_CorrelatedInvoices:any;
AADEBO_Res_ASSOC_AadeBookInvoiceType_AadeBookInvoiceType_DeliveryNotes:any;
AADEBO_Res_ASSOC_Project_AadeBookInvoiceType_Project:any;
AADEBO_Res_ASSOC_TaxTotalsType_PaymentOrderDeductionDetail_PaymentOrderDeductionDetail_TaxTotalsType:any;
AADEBO_Res_ASSOC_InvoiceRowType_WithheldPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_WithheldInvoiceDetail:any;
AADEBO_Res_ASSOC_InvoiceRowType_FeesPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_FeesInvoiceDetail:any;
AADEBO_Res_ASSOC_InvoiceRowType_OtherTaxesPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_OtherTaxesInvoiceDetail:any;
AADEBO_Res_ASSOC_InvoiceRowType_StampDutyPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_StampDutyInvoiceDetail:any;
AADEBO_Res_ASSOC_InvoiceRowType_DeductionsPaymentOrderDeductionDetail_PaymentOrderDeductionDetail_DeductionsInvoiceDetail:any;
AADEBO_Res_ASSOC_Cashier_AadeBookInvoiceType_Cashier:any;
AADEBO_Res_ASSOC_UserAccount_AadeBookInvoiceType_CanceledBy:any;
AADEBO_Res_ASSOC_UserAccount_AadeBookInvoiceType_IssuedBy:any;
AADEBO_Res_ASSOC_UserAccount_AadeBookInvoiceType_CreatedBy:any;
AADEBO_Res_ASSOC_Cashier_InvoiceCancellation_CancelledBy:any;
AADEBO_Res_ASSOC_TransactionDocumentSeries_InvoiceCancellation_Series:any;
AADEBO_Res_ASSOC_Note_InvoiceRowType_Note:any;
AADEBO_Res_ASSOC_GoodBase_InvoiceRowType_Good:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_101:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_001:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_002:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_003:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_004:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_005:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_102_006:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_104:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_201:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_001:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_002:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_003:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_004:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_202_005:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_204:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_207:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_209:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_301:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_001:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_002:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_003:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_004:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_302_005:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_304:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_307:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_309:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_312:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_001:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_002:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_003:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_004:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_313_005:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_315:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_581_001:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_581_002:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_581_003:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_582:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_583:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_584:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_001:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_002:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_003:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_004:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_005:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_006:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_007:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_008:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_009:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_010:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_011:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_012:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_013:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_014:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_015:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_585_016:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_586:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_587:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_588:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_589:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_882_001:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_882_002:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_882_003:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_882_004:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_883_001:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_883_002:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_883_003:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_883_004:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_361:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_362:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_363:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_364:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_365:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_VAT_366:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_103:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_203:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_303:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_208:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_308:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_314:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_106:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_205:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_305:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_210:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_310:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_318:any;
Res_ENUM_ExpensesClassificationTypeClassificationType_E3_598_002:any;
Res_ENUM_IncomeClassificationValueType_E3_106:any;
Res_ENUM_IncomeClassificationValueType_E3_205:any;
Res_ENUM_IncomeClassificationValueType_E3_210:any;
Res_ENUM_IncomeClassificationValueType_E3_305:any;
Res_ENUM_IncomeClassificationValueType_E3_310:any;
Res_ENUM_IncomeClassificationValueType_E3_318:any;
Res_ENUM_IncomeClassificationValueType_E3_561_001:any;
Res_ENUM_IncomeClassificationValueType_E3_561_002:any;
Res_ENUM_IncomeClassificationValueType_E3_561_003:any;
Res_ENUM_IncomeClassificationValueType_E3_561_004:any;
Res_ENUM_IncomeClassificationValueType_E3_561_005:any;
Res_ENUM_IncomeClassificationValueType_E3_561_006:any;
Res_ENUM_IncomeClassificationValueType_E3_561_007:any;
Res_ENUM_IncomeClassificationValueType_E3_562:any;
Res_ENUM_IncomeClassificationValueType_E3_563:any;
Res_ENUM_IncomeClassificationValueType_E3_564:any;
Res_ENUM_IncomeClassificationValueType_E3_565:any;
Res_ENUM_IncomeClassificationValueType_E3_566:any;
Res_ENUM_IncomeClassificationValueType_E3_567:any;
Res_ENUM_IncomeClassificationValueType_E3_568:any;
Res_ENUM_IncomeClassificationValueType_E3_570:any;
Res_ENUM_IncomeClassificationValueType_E3_595:any;
Res_ENUM_IncomeClassificationValueType_E3_596:any;
Res_ENUM_IncomeClassificationValueType_E3_597:any;
Res_ENUM_IncomeClassificationValueType_E3_880_001:any;
Res_ENUM_IncomeClassificationValueType_E3_880_002:any;
Res_ENUM_IncomeClassificationValueType_E3_880_003:any;
Res_ENUM_IncomeClassificationValueType_E3_880_004:any;
Res_ENUM_IncomeClassificationValueType_E3_881_001:any;
Res_ENUM_IncomeClassificationValueType_E3_881_002:any;
Res_ENUM_IncomeClassificationValueType_E3_881_003:any;
Res_ENUM_IncomeClassificationValueType_E3_881_004:any;
Res_ENUM_IncomeClassificationValueType_E3_598_001:any;
Res_ENUM_IncomeClassificationValueType_E3_598_003:any;
Res_ENUM_CountryType_AD:any;
Res_ENUM_CountryType_AE:any;
Res_ENUM_CountryType_AF:any;
Res_ENUM_CountryType_AG:any;
Res_ENUM_CountryType_AI:any;
Res_ENUM_CountryType_AL:any;
Res_ENUM_CountryType_AM:any;
Res_ENUM_CountryType_AN:any;
Res_ENUM_CountryType_AO:any;
Res_ENUM_CountryType_AQ:any;
Res_ENUM_CountryType_AR:any;
Res_ENUM_CountryType_AS:any;
Res_ENUM_CountryType_AT:any;
Res_ENUM_CountryType_AU:any;
Res_ENUM_CountryType_AW:any;
Res_ENUM_CountryType_AX:any;
Res_ENUM_CountryType_AZ:any;
Res_ENUM_CountryType_BA:any;
Res_ENUM_CountryType_BB:any;
Res_ENUM_CountryType_BD:any;
Res_ENUM_CountryType_BE:any;
Res_ENUM_CountryType_BF:any;
Res_ENUM_CountryType_BG:any;
Res_ENUM_CountryType_BH:any;
Res_ENUM_CountryType_BI:any;
Res_ENUM_CountryType_BJ:any;
Res_ENUM_CountryType_BL:any;
Res_ENUM_CountryType_BM:any;
Res_ENUM_CountryType_BN:any;
Res_ENUM_CountryType_BO:any;
Res_ENUM_CountryType_BR:any;
Res_ENUM_CountryType_BS:any;
Res_ENUM_CountryType_BT:any;
Res_ENUM_CountryType_BV:any;
Res_ENUM_CountryType_BW:any;
Res_ENUM_CountryType_BY:any;
Res_ENUM_CountryType_BZ:any;
Res_ENUM_CountryType_CA:any;
Res_ENUM_CountryType_CC:any;
Res_ENUM_CountryType_CD:any;
Res_ENUM_CountryType_CF:any;
Res_ENUM_CountryType_CG:any;
Res_ENUM_CountryType_CH:any;
Res_ENUM_CountryType_CI:any;
Res_ENUM_CountryType_CK:any;
Res_ENUM_CountryType_CL:any;
Res_ENUM_CountryType_CM:any;
Res_ENUM_CountryType_CN:any;
Res_ENUM_CountryType_CO:any;
Res_ENUM_CountryType_CR:any;
Res_ENUM_CountryType_CU:any;
Res_ENUM_CountryType_CV:any;
Res_ENUM_CountryType_CX:any;
Res_ENUM_CountryType_CY:any;
Res_ENUM_CountryType_CZ:any;
Res_ENUM_CountryType_DE:any;
Res_ENUM_CountryType_DJ:any;
Res_ENUM_CountryType_DK:any;
Res_ENUM_CountryType_DM:any;
Res_ENUM_CountryType_DO:any;
Res_ENUM_CountryType_DZ:any;
Res_ENUM_CountryType_EC:any;
Res_ENUM_CountryType_EE:any;
Res_ENUM_CountryType_EG:any;
Res_ENUM_CountryType_EH:any;
Res_ENUM_CountryType_ER:any;
Res_ENUM_CountryType_ES:any;
Res_ENUM_CountryType_ET:any;
Res_ENUM_CountryType_FI:any;
Res_ENUM_CountryType_FJ:any;
Res_ENUM_CountryType_FK:any;
Res_ENUM_CountryType_FM:any;
Res_ENUM_CountryType_FO:any;
Res_ENUM_CountryType_FR:any;
Res_ENUM_CountryType_GA:any;
Res_ENUM_CountryType_GB:any;
Res_ENUM_CountryType_GD:any;
Res_ENUM_CountryType_GE:any;
Res_ENUM_CountryType_GF:any;
Res_ENUM_CountryType_GG:any;
Res_ENUM_CountryType_GH:any;
Res_ENUM_CountryType_GI:any;
Res_ENUM_CountryType_GL:any;
Res_ENUM_CountryType_GM:any;
Res_ENUM_CountryType_GN:any;
Res_ENUM_CountryType_GP:any;
Res_ENUM_CountryType_GQ:any;
Res_ENUM_CountryType_GR:any;
Res_ENUM_CountryType_GS:any;
Res_ENUM_CountryType_GT:any;
Res_ENUM_CountryType_GU:any;
Res_ENUM_CountryType_GW:any;
Res_ENUM_CountryType_GY:any;
Res_ENUM_CountryType_HK:any;
Res_ENUM_CountryType_HM:any;
Res_ENUM_CountryType_HN:any;
Res_ENUM_CountryType_HR:any;
Res_ENUM_CountryType_HT:any;
Res_ENUM_CountryType_HU:any;
Res_ENUM_CountryType_ID:any;
Res_ENUM_CountryType_IE:any;
Res_ENUM_CountryType_IL:any;
Res_ENUM_CountryType_IM:any;
Res_ENUM_CountryType_IN:any;
Res_ENUM_CountryType_IO:any;
Res_ENUM_CountryType_IQ:any;
Res_ENUM_CountryType_IR:any;
Res_ENUM_CountryType_IS:any;
Res_ENUM_CountryType_IT:any;
Res_ENUM_CountryType_JE:any;
Res_ENUM_CountryType_JM:any;
Res_ENUM_CountryType_JO:any;
Res_ENUM_CountryType_JP:any;
Res_ENUM_CountryType_KE:any;
Res_ENUM_CountryType_KG:any;
Res_ENUM_CountryType_KH:any;
Res_ENUM_CountryType_KI:any;
Res_ENUM_CountryType_KM:any;
Res_ENUM_CountryType_KN:any;
Res_ENUM_CountryType_KP:any;
Res_ENUM_CountryType_KR:any;
Res_ENUM_CountryType_KW:any;
Res_ENUM_CountryType_KY:any;
Res_ENUM_CountryType_KZ:any;
Res_ENUM_CountryType_LA:any;
Res_ENUM_CountryType_LB:any;
Res_ENUM_CountryType_LC:any;
Res_ENUM_CountryType_LI:any;
Res_ENUM_CountryType_LK:any;
Res_ENUM_CountryType_LR:any;
Res_ENUM_CountryType_LS:any;
Res_ENUM_CountryType_LT:any;
Res_ENUM_CountryType_LU:any;
Res_ENUM_CountryType_LV:any;
Res_ENUM_CountryType_LY:any;
Res_ENUM_CountryType_MA:any;
Res_ENUM_CountryType_MC:any;
Res_ENUM_CountryType_MD:any;
Res_ENUM_CountryType_ME:any;
Res_ENUM_CountryType_MF:any;
Res_ENUM_CountryType_MG:any;
Res_ENUM_CountryType_MH:any;
Res_ENUM_CountryType_MK:any;
Res_ENUM_CountryType_ML:any;
Res_ENUM_CountryType_MM:any;
Res_ENUM_CountryType_MN:any;
Res_ENUM_CountryType_MO:any;
Res_ENUM_CountryType_MP:any;
Res_ENUM_CountryType_MQ:any;
Res_ENUM_CountryType_MR:any;
Res_ENUM_CountryType_MS:any;
Res_ENUM_CountryType_MT:any;
Res_ENUM_CountryType_MU:any;
Res_ENUM_CountryType_MV:any;
Res_ENUM_CountryType_MW:any;
Res_ENUM_CountryType_MX:any;
Res_ENUM_CountryType_MY:any;
Res_ENUM_CountryType_MZ:any;
Res_ENUM_CountryType_NA:any;
Res_ENUM_CountryType_NC:any;
Res_ENUM_CountryType_NE:any;
Res_ENUM_CountryType_NF:any;
Res_ENUM_CountryType_NG:any;
Res_ENUM_CountryType_NI:any;
Res_ENUM_CountryType_NL:any;
Res_ENUM_CountryType_NO:any;
Res_ENUM_CountryType_NP:any;
Res_ENUM_CountryType_NR:any;
Res_ENUM_CountryType_NU:any;
Res_ENUM_CountryType_NZ:any;
Res_ENUM_CountryType_OM:any;
Res_ENUM_CountryType_PA:any;
Res_ENUM_CountryType_PE:any;
Res_ENUM_CountryType_PF:any;
Res_ENUM_CountryType_PG:any;
Res_ENUM_CountryType_PH:any;
Res_ENUM_CountryType_PK:any;
Res_ENUM_CountryType_PL:any;
Res_ENUM_CountryType_PM:any;
Res_ENUM_CountryType_PN:any;
Res_ENUM_CountryType_PR:any;
Res_ENUM_CountryType_PS:any;
Res_ENUM_CountryType_PT:any;
Res_ENUM_CountryType_PW:any;
Res_ENUM_CountryType_PY:any;
Res_ENUM_CountryType_QA:any;
Res_ENUM_CountryType_RE:any;
Res_ENUM_CountryType_RO:any;
Res_ENUM_CountryType_RS:any;
Res_ENUM_CountryType_RU:any;
Res_ENUM_CountryType_RW:any;
Res_ENUM_CountryType_SA:any;
Res_ENUM_CountryType_SB:any;
Res_ENUM_CountryType_SC:any;
Res_ENUM_CountryType_SD:any;
Res_ENUM_CountryType_SE:any;
Res_ENUM_CountryType_SG:any;
Res_ENUM_CountryType_SH:any;
Res_ENUM_CountryType_SI:any;
Res_ENUM_CountryType_SJ:any;
Res_ENUM_CountryType_SK:any;
Res_ENUM_CountryType_SL:any;
Res_ENUM_CountryType_SM:any;
Res_ENUM_CountryType_SN:any;
Res_ENUM_CountryType_SO:any;
Res_ENUM_CountryType_SR:any;
Res_ENUM_CountryType_ST:any;
Res_ENUM_CountryType_SV:any;
Res_ENUM_CountryType_SY:any;
Res_ENUM_CountryType_SZ:any;
Res_ENUM_CountryType_TC:any;
Res_ENUM_CountryType_TD:any;
Res_ENUM_CountryType_TF:any;
Res_ENUM_CountryType_TG:any;
Res_ENUM_CountryType_TH:any;
Res_ENUM_CountryType_TJ:any;
Res_ENUM_CountryType_TK:any;
Res_ENUM_CountryType_TL:any;
Res_ENUM_CountryType_TM:any;
Res_ENUM_CountryType_TN:any;
Res_ENUM_CountryType_TO:any;
Res_ENUM_CountryType_TR:any;
Res_ENUM_CountryType_TT:any;
Res_ENUM_CountryType_TV:any;
Res_ENUM_CountryType_TW:any;
Res_ENUM_CountryType_TZ:any;
Res_ENUM_CountryType_UA:any;
Res_ENUM_CountryType_UG:any;
Res_ENUM_CountryType_UM:any;
Res_ENUM_CountryType_US:any;
Res_ENUM_CountryType_UY:any;
Res_ENUM_CountryType_UZ:any;
Res_ENUM_CountryType_VA:any;
Res_ENUM_CountryType_VC:any;
Res_ENUM_CountryType_VE:any;
Res_ENUM_CountryType_VG:any;
Res_ENUM_CountryType_VI:any;
Res_ENUM_CountryType_VN:any;
Res_ENUM_CountryType_VU:any;
Res_ENUM_CountryType_WF:any;
Res_ENUM_CountryType_WS:any;
Res_ENUM_CountryType_YE:any;
Res_ENUM_CountryType_YT:any;
Res_ENUM_CountryType_ZA:any;
Res_ENUM_CountryType_ZM:any;
Res_ENUM_CountryType_ZW:any;
Res_ENUM_InvoiceType_Item11:any;
Res_ENUM_InvoiceType_Item12:any;
Res_ENUM_InvoiceType_Item13:any;
Res_ENUM_InvoiceType_Item14:any;
Res_ENUM_InvoiceType_Item15:any;
Res_ENUM_InvoiceType_Item16:any;
Res_ENUM_InvoiceType_Item21:any;
Res_ENUM_InvoiceType_Item22:any;
Res_ENUM_InvoiceType_Item23:any;
Res_ENUM_InvoiceType_Item24:any;
Res_ENUM_InvoiceType_Item31:any;
Res_ENUM_InvoiceType_Item32:any;
Res_ENUM_InvoiceType_Item4:any;
Res_ENUM_InvoiceType_Item51:any;
Res_ENUM_InvoiceType_Item52:any;
Res_ENUM_InvoiceType_Item61:any;
Res_ENUM_InvoiceType_Item62:any;
Res_ENUM_InvoiceType_Item71:any;
Res_ENUM_InvoiceType_Item81:any;
Res_ENUM_InvoiceType_Item82:any;
Res_ENUM_InvoiceType_Item84:any;
Res_ENUM_InvoiceType_Item85:any;
Res_ENUM_InvoiceType_Item86:any;
Res_ENUM_InvoiceType_Item111:any;
Res_ENUM_InvoiceType_Item112:any;
Res_ENUM_InvoiceType_Item113:any;
Res_ENUM_InvoiceType_Item114:any;
Res_ENUM_InvoiceType_Item115:any;
Res_ENUM_InvoiceType_Item121:any;
Res_ENUM_InvoiceType_Item131:any;
Res_ENUM_InvoiceType_Item132:any;
Res_ENUM_InvoiceType_Item133:any;
Res_ENUM_InvoiceType_Item134:any;
Res_ENUM_InvoiceType_Item1330:any;
Res_ENUM_InvoiceType_Item1331:any;
Res_ENUM_InvoiceType_Item141:any;
Res_ENUM_InvoiceType_Item142:any;
Res_ENUM_InvoiceType_Item143:any;
Res_ENUM_InvoiceType_Item144:any;
Res_ENUM_InvoiceType_Item145:any;
Res_ENUM_InvoiceType_Item1430:any;
Res_ENUM_InvoiceType_Item1431:any;
Res_ENUM_InvoiceType_Item151:any;
Res_ENUM_InvoiceType_Item161:any;
Res_ENUM_InvoiceType_Item171:any;
Res_ENUM_InvoiceType_Item172:any;
Res_ENUM_InvoiceType_Item173:any;
Res_ENUM_InvoiceType_Item174:any;
Res_ENUM_InvoiceType_Item175:any;
Res_ENUM_InvoiceType_Item176:any;
Res_ENUM_InvoiceType_Item93:any;
Res_ENUM_Status_Imported:any;
Res_ENUM_Status_Sucess:any;
Res_ENUM_Status_Failed:any;
Res_ENUM_Status_Cancelled:any;
Res_ENUM_AadeInvoiceClassificationStatus_NotClassified:any;
Res_ENUM_AadeInvoiceClassificationStatus_PartiallyClassified:any;
Res_ENUM_AadeInvoiceClassificationStatus_Classified:any;
Res_ENUM_BookInvoiceERPStatus_Draft:any;
Res_ENUM_BookInvoiceERPStatus_Issued:any;
Res_ENUM_BookInvoiceERPStatus_ToBeIssued:any;
Res_ENUM_TransactionType_Income:any;
Res_ENUM_TransactionType_Expense:any;
Res_ENUM_TransactionType_Accounting:any;
Res_ENUM_InvoiceValidationErrorType_NoIncomeClassificationProvided:any;
Res_ENUM_InvoiceValidationErrorType_IncomeClassificationAmountDoesNotMatch:any;
Res_ENUM_InvoiceValidationErrorType_NoExpensesClassificationProvided:any;
Res_ENUM_InvoiceValidationErrorType_ExpensesClassificationAmountDoesNotMatch:any;
Res_ENUM_InvoiceValidationErrorType_NoExpensesVATClassificationProvided:any;
Res_ENUM_InvoiceValidationErrorType_ExpensesVATClassificationAmountDoesNotMatch:any;
Res_ENUM_InvoiceValidationErrorType_AccountingClassificationAmountDoesNotMatch:any;
Res_ENUM_InvoiceValidationErrorType_NoPaymentMethod:any;
Res_ENUM_InvoiceValidationErrorType_PaymentsTotalAmountDoesNotMatch:any;
Res_ENUM_InvoiceValidationErrorType_NoCurrency:any;
Res_ENUM_InvoiceValidationErrorType_NoIssuer:any;
Res_ENUM_InvoiceValidationErrorType_NoCounterpart:any;
Res_ENUM_InvoiceValidationErrorType_NoSpendingRequestWarning:any;
Res_ENUM_InvoiceValidationErrorType_NoSpendingRequestError:any;
Res_ENUM_InvoiceValidationErrorType_NoSeries:any;
Res_ENUM_InvoiceValidationErrorType_NoInvoiceType:any;
Res_ENUM_InvoiceValidationErrorType_NoInvoiceLines:any;
Res_ENUM_MyDataSyncStatus_None:any;
Res_ENUM_MyDataSyncStatus_SubmitInvoice:any;
Res_ENUM_MyDataSyncStatus_SubmitClassifications:any;
Res_ENUM_MyDataSyncStatus_FillClassifications:any;
Res_ENUM_MyDataSyncStatus_CompleteInvoice:any;
Res_ENUM_MatchingInvoiceActionType_Skip:any;
Res_ENUM_MatchingInvoiceActionType_Overwrite:any;
Res_ENUM_MatchingInvoiceActionType_Duplicate:any;
AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_SEND_INVOICE:any;
AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_SEND_CLASSIFICATIONS:any;
AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_FILL_CLASSIFICATIONS:any;
AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_COMPLETE_INVOICE:any;
AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_NONE:any;
AADEBO_RES_CUSTOM_MYDATA_MARK_NOT_NULL:any;
AADEBO_RES_CUSTOM_WRONG_INVOICE_MYDATA_STATUS:any;
AADEBO_RES_CUSTOM_SPENDING_REQUESTS_EXIST:any;
AADEBO_RES_CUSTOM_PAYMENT_ORDERS_EXIST:any;
AADEBO_RES_CUSTOM_INCOME_RECEIPTS_EXIST:any;
AADEBO_RES_PAYMENT_ORDER:any;
AADEBO_RES_CUSTOM_INCOME_RECEIPT:any;
AADEBO_RES_CUSTOM_NO_GJ_CREATED:any;
AADEBO_RES_CUSTOM_VALIDATION_NO_SPENDING_REQ:any;
AADEBO_RES_CUSTOM_INVOICE_PENDING_STATUS_CANCELED:any;
AADEBO_RES_CUSTOM_INVOICE_WRONG_STATUS:any;
AADEBO_RES_CUSTOM_CANCELLATION_INVOICE_TYPE_IS_NOT_CONFIGURED:any;
AADEBO_RES_CUSTOM_INVOICE_NO_AA:any;
AADEBO_RES_INVOICE:any;
AADEBO_RES_TRANSACTION_ENTITY_NOT_FOUND_AND_CREATED:any;
PaymentOrderListBO_Res_ASSOC_PaymentOrder_PaymentOrderList_PaymentOrderList_PaymentOrders:any;
PaymentOrderListBO_Res_ASSOC_UserAccount_PaymentOrderList_Owner:any;
PaymentOrderListBO_Res_ASSOC_Budget_PaymentOrderList_Budget:any;
PaymentOrderListBO_Res_ASSOC_BusinessEntity_PaymentOrderList_Entity:any;
PaymentOrderListBO_Res_ASSOC_UserAccount_PaymentOrderList_ApprovedBy:any;
DynamicWorkflowBO_Res_ASSOC_UserAccount_DynamicWorkflowStep_Owner:any;
DynamicWorkflowBO_Res_ASSOC_Department_DynamicWorkflowStep_Department:any;
DynamicWorkflowBO_Res_ASSOC_UserAccount_DynamicWorkflowStep_Creator:any;
PayrollIntegrationsBO_Res_ASSOC_EmployeePayroll_APDEmployeeGroup_EmployeePayroll:any;
PayrollIntegrationsBO_Res_ASSOC_Address_APDHeader_Address:any;
PayrollIntegrationsBO_Res_ASSOC_APDHeader_PayrollIntegration_APDHeader:any;
PaymentOrderPaymentBO_Res_ASSOC_BankAccount_PaymentOrderPaymentLine_PaymentLine_BankAccountFrom:any;
PaymentOrderPaymentBO_Res_ASSOC_CashAccount_PaymentLine_CashAccount:any;
PaymentOrderPaymentBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_PaymentLine_PaymentMethod:any;
PaymentOrderPaymentBO_Res_ASSOC_BusinessEntity_Payment_Entity:any;
PaymentOrderPaymentBO_Res_ASSOC_BankAccount_PaymentLine_BankAccountTo:any;
PaymentOrderPaymentBO_Res_ASSOC_Check_Payment_PaymentLine_Check:any;
PaymentOrderPaymentBO_Res_ASSOC_Checkbook_PaymentLine_Checkbook:any;
PaymentOrderPaymentBO_Res_ASSOC_MoneyTransaction_PaymentLine_CancelMoneyTransaction:any;
PaymentOrderPaymentBO_Res_ASSOC_Cashier_PaymentLine_Cashier:any;
PaymentOrderPaymentBO_Res_ASSOC_UserAccount_Payment_CreatedBy:any;
Res_ENUM_PaymentStatus_None:any;
Res_ENUM_PaymentStatus_Pending:any;
Res_ENUM_PaymentStatus_Dropped:any;
Res_ENUM_PaymentStatus_Completed:any;
PaymentOrderPaymentBO_RES_MONEY_TRANSACTION:any;
PaymentOrderPaymentBO_RES_PAYMENT_ORDER:any;
PaymentOrderPaymentBO_RES_SETTLEMENT_PAYMENT_ORDER:any;
InvoiceTemplateBO_Res_ASSOC_TransactionEntity_InvoiceTemplate_TransactionEntity:any;
InvoiceTemplateBO_Res_ASSOC_GoodBase_InvoiceTemplateLine_TransactionItem:any;
InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_WithheldTaxCategory:any;
InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_StampDutyTaxCategory:any;
InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_FeesTaxCategory:any;
InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_OtherTaxCategory:any;
InvoiceTemplateBO_Res_ASSOC_TaxCategoryValueObject_InvoiceTemplateLine_DeductionTaxCategory:any;
InvoiceTemplateBO_Res_ASSOC_InvoiceTypeValueObject_InvoiceTemplate_InvoiceType:any;
InvoiceTemplateBO_Res_ASSOC_AccountingSystemEntity_InvoiceTemplate_BO:any;
InvoiceTemplateBO_Res_ASSOC_VatCategoryValueObject_InvoiceTemplateLine_VatCategory:any;
InvoiceTemplateBO_Res_ASSOC_AccountingEvent_InvoiceTemplate_AccountingEvent:any;
InvoiceTemplateBO_Res_ASSOC_BudgetItem_SpendingRequestInvoiceTemplate_BudgetItem:any;
InvoiceTemplateBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_InvoiceTemplate_PaymentMethod:any;
InvoiceTemplateBO_Res_ASSOC_TransactionDocumentSeries_InvoiceTemplate_Series:any;
InvoiceTemplateBO_RES_ISSUE_DATE_VARIABLE:any;
InvoiceTemplateBO_RES_INVOICE_LINE_AMOUNT_VARIABLE:any;
InvoiceTemplateBO_RES_INVOICE_LINE_GOOD_VARIABLE:any;
PaidPaymentOrdersListBO_Res_ASSOC_PaymentOrder_PaymentOrderPaymentList_PaidPaymentOrdersList_PaymentOrders:any;
PaidPaymentOrdersListBO_Res_ASSOC_BusinessEntity_PaidPaymentOrdersList_Entity:any;
TransactionDocumentSeriesBO_Res_ASSOC_BusinessEntity_TransactionDocumentSeries_Entity:any;
TransactionDocumentSeriesBO_Res_ASSOC_InvoiceTypeValueObject_TransactionDocumentSeries_InvoiceTypeValueObject:any;
SHRChangeRequestBO_Res_ASSOC_Employee_EmployeeDataChangeRequest_Employee:any;
Res_ENUM_EmployeeDataChangeRequestStatus_Pending:any;
Res_ENUM_EmployeeDataChangeRequestStatus_Accepted:any;
Res_ENUM_EmployeeDataChangeRequestStatus_Rejected:any;
BudgetTargetingBO_Res_ASSOC_BudgetItem_BudgetTargetingCategory_BudgetItems:any;
BudgetTargetingBO_Res_ASSOC_BudgetTargetingCategory_BudgetTargetingCategoryMonth_Category:any;
BudgetTargetingBO_Res_ASSOC_ERPFiscalYear_BudgetTargetingTable_FiscalYear:any;
BudgetTargetingBO_Res_ASSOC_BusinessEntity_BudgetTargetingTable_Entity:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_1:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_2:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_3:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_4:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_5:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_6:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_7:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_8:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_9:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_10:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_11:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_12:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_13:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_14:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_15:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_16:any;
BudgetTargetingBO_RES_CUSTOM_MONTH_17:any;
AmountAggregatorBO_Res_ASSOC_AccountingSystemEntity_AmountAggregator_BO:any;
AmountAggregatorBO_Res_ASSOC_AmountAggregator_AmountAggregatorPart_AggregatorRef:any;
AmountAggregatorBO_Res_ASSOC_AmountAggregator_AmountAggregatorInstance_AmountAggregator:any;
AmountAggregatorBO_Res_ASSOC_ERPFiscalYear_AmountAggregatorInstance_FiscalYear:any;
Res_ENUM_AmountAggregatorPartType_Aggregator:any;
Res_ENUM_AmountAggregatorPartType_Field:any;
Res_ENUM_AmountAggregatorType_Amount:any;
Res_ENUM_AmountAggregatorType_Hours:any;
Res_ENUM_AmountAggregatorType_Days:any;
Res_ENUM_AmountAggregatorUpdateFrequency_PerFiscalYear:any;
Res_ENUM_AmountAggregatorUpdateFrequency_Manually:any;
Res_ENUM_AmountAggregatorOperatorType_Addition:any;
Res_ENUM_AmountAggregatorOperatorType_Subtraction:any;
InventoryValuationBO_Res_ASSOC_BusinessEntity_InventoryValuation_Entity:any;
InventoryValuationBO_Res_ASSOC_ERPFiscalYear_FiscalInventoryValuation_FiscalYear:any;
InventoryValuationBO_Res_ASSOC_Good_GoodInventoryValuation_Good:any;
InventoryValuationBO_Res_ASSOC_ERPFiscalYear_FiscalYearDTO_FiscalYear:any;
InventoryValuationBO_Res_ASSOC_Good_GoodValuationDTO_Good:any;
Res_ENUM_ValuationMethod_FIFO:any;
Res_ENUM_ValuationMethod_LIFO:any;
Res_ENUM_ValuationMethod_Average:any;
InventoryValuationBO_RES_CURRENT_FISCAL_YEAR:any;
Res_ENUM_ExcelConverterEntity_PaySlip:any;
Res_ENUM_ExcelConverterEntity_PaymentOrder:any;
Res_ENUM_ExcelConverterEntity_SpendingRequest:any;
Res_ENUM_ExcelConverterEntity_Payroll:any;
Res_ENUM_ExcelConverterEntity_PayrollSummary:any;
Res_ENUM_ExcelConverterEntity_BudgetAdjustment:any;
Res_ENUM_ExcelConverterEntity_TransactionEntity:any;
Res_ENUM_ExcelConverterEntity_CheckNotary:any;
Res_ENUM_ExcelConverterEntity_BankAccountList:any;
Res_ENUM_ExcelConverterEntity_BankAccountTransactions:any;
Res_ENUM_ExcelConverterEntity_Budget:any;
Res_ENUM_ExcelConverterEntity_AssetDepreciations:any;
Res_ENUM_ExcelConverterEntity_LeaveRequest:any;
Res_ENUM_ExcelConverterEntity_CVEmployee:any;
Res_ENUM_ExcelConverterEntity_EmployeeOvertime:any;
Res_ENUM_ExcelConverterEntity_PeriodOvertime:any;
Res_ENUM_ExcelConverterEntity_PaymentOrderPayment:any;
Res_ENUM_ExcelConverterEntity_PayrollAdvance:any;
Res_ENUM_ExcelConverterEntity_PayrollReport:any;
Res_ENUM_ExcelConverterEntity_AdhocAdvancePayment:any;
Res_ENUM_ExcelConverterEntity_EmployeeSalaryLoanInstalment:any;
Res_ENUM_ExcelConverterEntity_DetailedPayrollReport:any;
Res_ENUM_ExcelConverterEntity_APD:any;
Res_ENUM_ExcelExporterVariableType_Generic:any;
Res_ENUM_ExcelExporterVariableType_Currency:any;
Res_ENUM_ExcelExporterVariableType_Days:any;
Res_ENUM_ExcelExporterVariableType_Hours:any;
Res_ENUM_ExcelExporterVariableType_Rate:any;
AssetDepreciationTransactionBO_Res_ASSOC_DepreciationPreview_DepreciationTransaction_TaxPreview:any;
AssetDepreciationTransactionBO_Res_ASSOC_DepreciationPreview_DepreciationTransaction_AccountingPreview:any;
AssetDepreciationTransactionBO_Res_ASSOC_AssetCategory_DepreciationTransaction_Categories:any;
AssetDepreciationTransactionBO_RES_NO_ASSETS_SELECTED:any;
BankingBO_Res_ASSOC_Bank_BankAccount_Bank:any;
BankingBO_Res_ASSOC_Currency_BankAccount_Currency:any;
BankingBO_Res_ASSOC_Currency_CashAccount_Currency:any;
BankingBO_Res_ASSOC_Check_MoneyTransaction_MoneyTransaction_Check:any;
BankingBO_Res_ASSOC_Cashier_MoneyTransaction_Cashier:any;
BankingBO_Res_ASSOC_BusinessEntity_CashAccountInventoryInvoice_Entity:any;
BankingBO_Res_ASSOC_CashAccount_CashAccountInventoryInvoiceDetail_CashAccount:any;
BankingBO_Res_ASSOC_CashAccount_CashAccountViewDetailDTO_CashAccount:any;
BankingBO_Res_ASSOC_CashAccount_CashAccountViewTotalDTO_CashAccount:any;
Res_ENUM_BankAccountType_Current:any;
Res_ENUM_BankAccountType_Savings:any;
Res_ENUM_MoneyTransactionType_Transfer:any;
Res_ENUM_MoneyTransactionType_Withdraw:any;
Res_ENUM_MoneyTransactionType_Deposit:any;
Res_ENUM_MoneyTransactionType_Collection:any;
Res_ENUM_MoneyTransactionType_Payment:any;
Res_ENUM_MoneyTransactionType_Other:any;
Res_ENUM_MoneyAccountType_Bank:any;
Res_ENUM_MoneyAccountType_Cash:any;
Res_ENUM_MoneyAccountType_Other:any;
BankingBO_RES_TRANSACTION_IS_FINALIZED:any;
BankingBO_RES_FROM_BANK_MISSING:any;
BankingBO_RES_FROM_CASH_MISSING:any;
BankingBO_RES_TO_BANK_MISSING:any;
BankingBO_RES_TO_CASH_MISSING:any;
BankingBO_RES_AMOUNT_MUST_BE_POSITIVE:any;
BankingBO_RES_ACCOUNTS_MUST_BE_DIFFERENT:any;
BankingBO_RES_BOTH_OTHER:any;
BankingBO_RES_SAME_CURRENCY:any;
BankingBO_RES_INSUFFICIENT_CASH_BALANCE:any;
BankingBO_RES_MISSING_CURRENCY:any;
BankingBO_RES_CASH_ACCOUNT_SERIES_NAME_EMPTY:any;
BankingBO_RES_MONEY_TRANSACTION_SERIES_NAME_EMPTY:any;
BankingBO_RES_MONEY_TRANSACTION_CANT_MODIFY:any;
BankingBO_RES_CASH_ACCOUNT_CODE_EXISTS:any;
BankingBO_RES_CASH_ACOUNT_CODE_WITHOUT_SERIES:any;
BankingBO_RES_MONEY_TRANSACTION_NOT_FINALIZED:any;
BankingBO_RES_CASH_ACOUNT_CANNOT_BE_DELETED:any;
BankingBO_RES_INSUFFICIENT_BANK_BALANCE:any;
BankingBO_RES_STATEMENTS_DUPLICATE_KEYS:any;
BankingBO_Bank_MASS_IMPORT_COMPLETE:any;
CheckIntegrationsBO_Res_ASSOC_CheckNotaryFilters_Currency_Currency_CheckLixiografaFilters:any;
BankingIntegrationsBO_Res_ASSOC_BankAccount_BankAccountTransactionFilter_BankAccount:any;
InventoryReports_Res_ASSOC_InventoryListRangeReport_Goods_InventoryListRangeGoodReport_InventoryListRangeReport:any;
InventoryReports_Res_ASSOC_InventoryListReport_Goods_InventoryListGoodReport_InventoryListReport:any;
InventoryReports_Res_ASSOC_InventoryTransactionsReport_Transactions_InventoryTransactionsSingleReport_InventoryTransactionsReport:any;
InventoryReports_Res_ASSOC_InventoryTransactionsReport_PeriodSum_InventoryTransactionsPeriodSum_InventoryTransactionsReport:any;
InventoryReports_Res_ASSOC_InventoryTransactionsReport_GlobalSum_InventoryTransactionsGlobalSum_InventoryTransactionsReport:any;
TransactionEntityReportsBO_Res_ASSOC_TransactionEntityTransactionsReport_TransactionEntity_TransactionEntity_TransactionEntityTransactionsReport:any;
TransactionEntityReportsBO_Res_ASSOC_TransactionEntityTransactionsReport_Transactions_TransactionEntityTransactionsSingleReport_TransactionEntityTransactionsReport:any;
TransactionEntityReportsBO_Res_ASSOC_TransactionEntityTransactionsSingleReport_TransactionEntityTransactionsReport_PreviousReport:any;
TransactionEntityReportsBO_Res_ASSOC_TransactionEntityTransactionsSingleReport_TransactionEntityTransactionsReport_TotalReport:any;
TransactionEntityReportsBO_Res_ASSOC_TransactionEntity_TransactionEntityListSingleReport_TransactionEntity:any;
TransactionEntityReportsBO_Res_ASSOC_TransactionEntityListReport_TransactionEntities_TransactionEntityListSingleReport_TransactionEntityListReport:any;
TransactionEntityReportsBO_Res_ASSOC_TransactionEntityListSingleReport_TransactionEntityListReport_TotalReport:any;
AssetLocationBO_Res_ASSOC_BusinessEntity_AssetLocation_Entity:any;
AssetLocationBO_Res_ASSOC_AssetLocation_AssetLocation_ParentLocation:any;
AssetLocationBO_RES_SAME_CODE_EXISTS:any;
Res_ENUM_VatStatementStatus_Draft:any;
Res_ENUM_VatStatementStatus_Submitted:any;
Res_ENUM_VatStatementStatus_Cancelled:any;
DynamicReportBO_Res_ASSOC_FileData_DynamicReportImage_Image:any;
DynamicReportBO_RES_CUSTOM_FILE_DATA_NOT_FOUND:any;
AccountingEntityCategoryBO_Res_ASSOC_AccountingSystemEntity_AccountingEntityCategory_SystemEntity:any;
AccountingEntityCategoryBO_Res_ASSOC_SystemEntityParameter_AccountingEntityCategory_AvailableFor:any;
Res_ENUM_HRPartyStatus_Active:any;
Res_ENUM_HRPartyStatus_Paused:any;
Res_ENUM_HRPartyStatus_Stopped:any;
Res_ENUM_HRPartyStatus_Completed:any;
Res_ENUM_HRPartyPayingPolicy_PerCommittee:any;
Res_ENUM_HRPartyPayingPolicy_PerSession:any;
Res_ENUM_MeetingStatus_New:any;
Res_ENUM_MeetingStatus_Cancelled:any;
Res_ENUM_MeetingStatus_Completed:any;
ProjectBO_Res_ASSOC_Employee_Project_EmployeeProjectManager:any;
ProjectBO_Res_ASSOC_TransactionEntity_Projects_Project_TransactionEntityClient:any;
ProjectBO_MASS_IMPORT_COMPLETE:any;
ProjectBO_MASS_IMPORT_PROJECT_STARTDATE:any;
ProjectBO_MASS_IMPORT_PROJECT_ENDDATE:any;
Res_ENUM_RewardsProgramImpementation_Internal:any;
Res_ENUM_RewardsProgramImpementation_External:any;
AccountLocatorRuleBO_Res_ASSOC_Ledger_AccountLocatorRule_Ledger:any;
AccountLocatorRuleBO_Res_ASSOC_AccountLocatorRule_AccountLocatorRuleInvocation_Rule:any;
AccountLocatorRuleBO_Res_ASSOC_AccountingSystemEntity_AccountLocatorRule_MainEntity:any;
AccountLocatorRuleBO_Res_ASSOC_AccountingEvent_AccountLocatorPartSelectionCondition_Condition:any;
AccountLocatorRuleBO_Res_ASSOC_Account_AccountLocatorPart_Accounts:any;
AccountLocatorRuleBO_Res_ASSOC_AccountingSystemEntity_AccountLocatorRuleContextItem_Entity:any;
AccountLocatorRuleBO_Res_ASSOC_AccountingSystemEntity_AccountLocatorRuleInvocationInput_Entity:any;
AccountLocatorRuleBO_Res_ASSOC_AccountingEntityCategory_AccountLocatorConditionLine_Category:any;
AccountLocatorRuleBO_Res_ASSOC_AccountingEntityCategoryValue_AccountLocatorConditionLine_Value:any;
AccountLocatorRuleBO_Res_ASSOC_AccountingEntityCategory_AccountLocatorPartConditionLine_Category:any;
AccountLocatorRuleBO_Res_ASSOC_AccountingEntityCategoryValue_AccountLocatorPartConditionLine_Values:any;
Res_ENUM_AccountLocatorType_HardCoded:any;
Res_ENUM_AccountLocatorType_Expression:any;
Res_ENUM_AccountLocatorType_Conditions:any;
Res_ENUM_AccountLocatorType_DynamicGroup:any;
Res_ENUM_AccountLocatorType_SpecificAccount:any;
Res_ENUM_AccountLocatorType_ChildAccounts:any;
Res_ENUM_AccountLocatorRuleType_Normal:any;
Res_ENUM_AccountLocatorRuleType_Composite:any;
Res_ENUM_AccountingDatatype_Number:any;
Res_ENUM_AccountingDatatype_String:any;
Res_ENUM_AccountingDatatype_Boolean:any;
Res_ENUM_AccountingDatatype_DateTime:any;
Res_ENUM_AccountingDatatype_Collection:any;
Res_ENUM_AccountingDatatype_ObjectInstance:any;
Res_ENUM_AccountLocatorAccountNameMethod_Property:any;
Res_ENUM_AccountLocatorAccountNameMethod_HardCoded:any;
BackOfficeBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_BackofficePaymentMethodMapping_ERPPaymentMethod:any;
BackOfficeBO_Res_ASSOC_BusinessEntity_BackOfficeGeneralConfiguration_Entity:any;
BackOfficeBO_Res_ASSOC_TransactionEntity_BackOfficeInvoiceConfig_MainTransactionEntity:any;
BackOfficeBO_Res_ASSOC_InvoiceTypeValueObject_BackOfficeInvoiceConfig_InvoiceType:any;
BackOfficeBO_Res_ASSOC_TransactionDocumentSeries_BackOfficeInvoiceConfig_Series:any;
BackOfficeBO_Res_ASSOC_PaymentMethodDetailTypeValueObject_BackOfficeDividendPaymentTypesMapping_ERPPaymentMethod:any;
BackOfficeBO_Res_ASSOC_BackofficePaymentMethodMapping_IssueInvoicePaymentType_PaymentMethodMapping:any;
Res_ENUM_BackOfficeDocumentType_Proeispraxi:any;
Res_ENUM_BackOfficeDocumentType_Eispraxi:any;
Res_ENUM_BackOfficeDocumentType_Stamp:any;
Res_ENUM_BackOfficeDocumentType_Contract:any;
Res_ENUM_BackOfficeDocumentType_Dividend:any;
Res_ENUM_BackOfficeDocumentType_DailyRegister:any;
Res_ENUM_BackOfficeDocumentType_Payment:any;
Res_ENUM_BackOfficeDocumentType_TrialBankruptcy:any;
Res_ENUM_BackOfficeDocumentType_Confiscation:any;
Res_ENUM_BackOfficeDocumentType_Invoice:any;
Res_ENUM_BackOfficeDocumentType_Receipt:any;
Res_ENUM_BackOfficeDocumentType_Expropriation:any;
Res_ENUM_ExternalSystemSyncResult_Success:any;
Res_ENUM_ExternalSystemSyncResult_PartialSuccess:any;
Res_ENUM_ExternalSystemSyncResult_Failed:any;
Res_ENUM_ExternalSystemSyncResult_InProgress:any;
Res_ENUM_ExternalSystemSyncLogSeverity_Info:any;
Res_ENUM_ExternalSystemSyncLogSeverity_Warning:any;
Res_ENUM_ExternalSystemSyncLogSeverity_Error:any;
Res_ENUM_ExternalSystemItemMappingType_Tax:any;
Res_ENUM_ExternalSystemItemMappingType_Product:any;
BackOfficeBO_RES_CUSTOM_DocumentTypeNotImplemented:any;
BackOfficeBO_RES_CUSTOM_TAX_NOT_MAPPED:any;
BackOfficeBO_RES_CUSTOM_DEPARTMENT_NOT_FOUND:any;
BackOfficeBO_RES_CUSTOM_UKNOWN_PROEISPRAKSI_CASE:any;
BackOfficeBO_RES_CUSTOM_PAYMENTMETHOD_NOT_FOUND:any;
BackOfficeBO_RES_CUSTOM_SYNC_FAILED:any;
BackOfficeBO_RES_CUSTOM_DOCUMENT_TAX_NOT_FOUND:any;
BackOfficeBO_RES_CASHIER_NOT_FOUND:any;
BackOfficeBO_RES_MODE_NOT_DECIDED:any;
BackOfficeBO_RES_CUSTOM_INV_ISSUE_ERROR:any;
BackOfficeBO_RES_CUSTOM_IR_ISSUE_ERROR:any;
BackOfficeBO_RES_CUSTOM_CANNOT_CANCEL_MANY_DOCS:any;
BackOfficeBO_RES_CUSTOM_UNHANDLED_SYNC_ERROR:any;
SeriesCodeGenerator_RES_DUPLICATE_GENERATOR:any;
SeriesCodeGenerator_RES_SERIES_INVALID:any;
SeriesCodeGenerator_RES_CONTEXT_INVALID:any;
SeriesCodeGenerator_Res_ASSOC_ERPFiscalYear_SeriesCode_FiscalYear:any;
SEPE_BO_Res_ASSOC_SepeSpecialization_ProfessionSpecialization_SepeSpecialization:any;
CashierBO_Res_ASSOC_CashAccount_Cashier_CashAccount:any;
CashierBO_Res_ASSOC_BusinessEntity_Cashier_Entity:any;
BackOfficeEispraksiBO_Res_ASSOC_BankAccount_BackofficeEispraxiConfig_BankAccount:any;
BackOfficeEispraksiBO_RES_CUSTOM_CLIENTID_NOTFOUND:any;
BackOfficeEispraksiBO_RES_CUSTOM_CLIENTID_ERROR:any;
BackofficeUtilitiesBO_RES_CASHIER_NOT_FOUND:any;
BackofficeUtilitiesBO_RES_CUSTOM_REMAINING_AMOUNT:any;
BackofficeUtilitiesBO_RES_CUSTOM_AMOUNT_NOT_MAPED:any;
BackofficeUtilitiesBO_RES_GENERIC_SYNC_ERROR:any;
BackOfficeContractBO_Res_ASSOC_CashAccount_BackOfficeContractConfig_TaxesCashAccount:any;
BackOfficeContractBO_Res_ASSOC_CashAccount_BackOfficeContractConfig_CashAccount:any;
BackOfficeStampBO_Res_ASSOC_BankAccount_BackOfficeStampConfig_BankAccount:any;
BackOfficeDividendBO_Res_ASSOC_CashAccount_BackOfficeDividendConfig_CashAccount:any;
BackOfficeDividendBO_RES_DIVIDENT_TYPE_NOT_MAPED:any;
BackOfficeDailyRegisterBO_Res_ASSOC_AccountingEvent_BackOfficeDailyRegisterConfig_AccountingEvent:any;
BackOfficePaymentBO_Res_ASSOC_BankAccount_BackOfficePaymentConfig_BankAccount:any;
BackOfficePaymentBO_Res_ASSOC_CashAccount_BackOfficePaymentConfig_CashAccount:any;
Res_ENUM_PayrollExportItemType_Salary:any;
Res_ENUM_PayrollExportItemType_Contribution:any;
Res_ENUM_PayrollExportItemType_Deduction:any;
PayrollVariableBO_Res_ASSOC_PayrollVariable_PayrollVariableInstance_Variable:any;
PayrollVariableBO_Res_ASSOC_PayrollVariable_PayrollVariableAssigment_Variable:any;
PayrollVariableBO_Res_ASSOC_PayrollCalculatedExpression_PayrollVariableAssigment_Formula:any;
PayrollVariableBO_Res_ASSOC_PayrollVariable_PayrollVariableHistoryEntry_PayrollVariable:any;
PayrollVariableBO_Res_ASSOC_PayrollVariableHistoryEntry_PayrollVariableInstanceValue_HistoryEntry:any;
Res_ENUM_PayrollVariableType_Days:any;
Res_ENUM_PayrollVariableType_Hours:any;
Res_ENUM_PayrollVariableType_Value:any;
Res_ENUM_PayrollVariableType_Year:any;
Res_ENUM_EntityDefinitionLevel_UserDefined:any;
Res_ENUM_EntityDefinitionLevel_Library:any;
Res_ENUM_EntityDefinitionLevel_Systemic:any;
PayrollVariableBO_MASS_IMPORT_COMPLETE:any;
PayrollVariableBO_MASS_IMPORT_NAME:any;
PayrollVariableBO_MASS_IMPORT_CODE:any;
PayrollVariableBO_MASS_IMPORT_DATASOURCE:any;
PayrollVariableBO_MASS_IMPORT_FIELDNAME:any;
PayrollVariableBO_MASS_IMPORT_WRONGFILL:any;
PayrollDTOs_Res_ASSOC_PayrollGroupData_PayrollGroup_data:any;
EStatementsBO_Res_ASSOC_InvoiceTemplate_StatementsConfiguration_InvoiceTemplate:any;
EStatementsBO_Res_ASSOC_BankAccount_BankStatementImportSection_BankAccount:any;
EStatementsBO_Res_ASSOC_AadeBookInvoiceType_BankStatementImportRow_Invoice:any;
EStatementsBO_RES_NO_BANK_FOUND:any;
EStatementsBO_RES_MULTIPLE_BANKS_FOUND:any;
EStatementsBO_RES_FROM_DATE_NOT_FOUND:any;
EStatementsBO_RES_TO_DATE_NOT_FOUND:any;
EStatementsBO_RES_ACCOUNT_NUMBER_NOT_FOUND:any;
EStatementsBO_RES_CURRENCY_NOT_FOUND:any;
EStatementsBO_RES_OPENING_BALANCE_NOT_FOUND:any;
EStatementsBO_RES_IBAN_NOT_FOUND:any;
EStatementsBO_RES_BIC_NOT_FOUND:any;
EStatementsBO_RES_NUMBER_OF_RECORDS_NOT_FOUND:any;
EStatementsBO_RES_SUM_AMOUNT_NOT_FOUND:any;
EStatementsBO_RES_CLOSING_BALANCE_NOT_FOUND:any;
EStatementsBO_RES_CURRENCY_MISMATCH:any;
EStatementsBO_RES_ACCOUNT_NUMBER_MISMATCH:any;
EStatementsBO_RES_NUMBER_OF_RECORDS_MISMATCH:any;
EStatementsBO_RES_SUM_AMOUNT_MISMATCH:any;
EStatementsBO_RES_CLOSING_BALANCE_MISMATCH:any;
EStatementsBO_RES_STATEMENT_IMPORT_FINALIZED:any;
EStatementsBO_RES_CUSTOM_SAME_DATE_RANGE_IMPORT:any;
EStatementsBO_RES_STATEMENT_ROW_NO_TEMPLATE:any;
EStatementsBO_RES_DUPLICATE_CHECK_NUMBER:any;
ApprovalFlowBO_Res_ASSOC_UserAccount_ApprovalFlowStep_User:any;
ApprovalFlowBO_Res_ASSOC_Department_ApprovalFlowStep_Department:any;
ApprovalFlowBO_Res_ASSOC_Department_ApprovalFlowScenario_Department:any;
ApprovalFlowBO_Res_ASSOC_DepartmentCategory_ApprovalFlowScenario_DepartmentCategory:any;
Res_ENUM_ApprovalFlowAction_Approve:any;
Res_ENUM_ApprovalFlowAction_Check:any;
Res_ENUM_ApprovalFlowAction_Notice:any;
Res_ENUM_ApprovalFlowSubsystem_Leaves:any;
Res_ENUM_ApprovalFlowStepActorType_SpecificRole:any;
Res_ENUM_ApprovalFlowStepActorType_DepartmentManager:any;
Res_ENUM_ApprovalFlowStepActorType_SpecificUser:any;
Res_ENUM_ApprovalFlowStepActorType_Department:any;
Res_ENUM_ApprovalFlowSubsystem_Resignations:any;
BackOfficeReceiptBO_RES_CUSTOM_SERIES_NOT_FOUND:any;
BackOfficeReceiptBO_RES_CUSTOM_INVOICE_NOT_FOUND:any;
BackOfficeReceiptBO_RES_CUSTOM_ISSUE_IR_ERROR:any;
BackOfficeInvoiceBO_RES_CUSTOM_PAYMENT_REASON_ERROR:any;
CostCenterBO_MASS_IMPORT_COMPLETE:any;
CostCenterBO_MASS_IMPORT_COSTCENTER_NO:any;
Res_ENUM_WorkProgramType_Work:any;
Res_ENUM_WorkProgramType_RemoteWork:any;
Res_ENUM_WorkProgramType_OverHours:any;
Res_ENUM_WorkProgramType_Rest:any;
Res_ENUM_WorkProgramType_NoWork:any;
Res_ENUM_WeekDay_Monday:any;
Res_ENUM_WeekDay_Tuesday:any;
Res_ENUM_WeekDay_Wendesday:any;
Res_ENUM_WeekDay_Thursday:any;
Res_ENUM_WeekDay_Friday:any;
Res_ENUM_WeekDay_Saturday:any;
Res_ENUM_WeekDay_Sunday:any;
Res_ENUM_Week_First:any;
Res_ENUM_Week_Second:any;
Res_ENUM_Week_Third:any;
Res_ENUM_Week_Fourth:any;
WorkCalendarBO_MASS_IMPORT_DAY_FROM1:any;
WorkCalendarBO_MASS_IMPORT_DAY_TO1:any;
WorkCalendarBO_MASS_IMPORT_COMPLETE:any;
WorkCalendarBO_MASS_IMPORT_MONDAY_CODE:any;
WorkCalendarBO_MASS_IMPORT_TUESDAY_CODE:any;
WorkCalendarBO_MASS_IMPORT_WENDESDAY_CODE:any;
WorkCalendarBO_MASS_IMPORT_THURSDAY_CODE:any;
WorkCalendarBO_MASS_IMPORT_FRIDAY_CODE:any;
WorkCalendarBO_MASS_IMPORT_SATURDAY_CODE:any;
WorkCalendarBO_MASS_IMPORT_SUNDAY_CODE:any;
Res_ENUM_Type_Employee:any;
Res_ENUM_Type_Party:any;
RoleBO_MASS_IMPORT_NAME:any;
RoleBO_MASS_IMPORT_COMPLETE:any;
CharacterizationBO_MASS_IMPORT_COMPLETE:any;
Res_ENUM_BenefitCategory_Money:any;
Res_ENUM_BenefitCategory_Object:any;
Res_ENUM_BenefitCategory_Service:any;
Res_ENUM_BenefitStatus_Active:any;
Res_ENUM_BenefitStatus_Inactive:any;
Res_ENUM_HistoricityType_Daily:any;
Res_ENUM_HistoricityType_Dimentional:any;
Res_ENUM_HistoricityType_Fixed:any;
Res_ENUM_DefinitionLevel_System:any;
Res_ENUM_DefinitionLevel_Library:any;
Res_ENUM_DefinitionLevel_Installation:any;
Res_ENUM_DataType_Integer:any;
Res_ENUM_DataType_Numeric:any;
Res_ENUM_DataType_String:any;
Res_ENUM_DataType_Logic:any;
Res_ENUM_DataType_DateTime:any;
Res_ENUM_DataType_Date:any;
Res_ENUM_DataType_Time:any;
Res_ENUM_DataType_Money:any;
Res_ENUM_DataType_ListValue:any;
Res_ENUM_DataType_Entity:any;
Res_ENUM_DataType_Duration:any;
Res_ENUM_DefinitionLevelEntityType_System:any;
Res_ENUM_DefinitionLevelEntityType_User:any;
Res_ENUM_AttributeSystemEntity_Employee:any;
Res_ENUM_AttributeSystemEntity_EmployeeContract:any;
Res_ENUM_AttributeSystemEntity_BusinessEntity:any;
Res_ENUM_AttributeSystemEntity_Department:any;
Res_ENUM_LinkEntity_Benefit:any;
Res_ENUM_LinkEntity_Questionnaire:any;
Res_ENUM_LinkEntity_EntityHistory:any;
Res_ENUM_LinkEntity_Modification:any;
Res_ENUM_LinkOperation_View:any;
Res_ENUM_LinkOperation_Stapled:any;
AdhocAdvancePaymentBO_Res_ASSOC_EmployeeContract_AdhocAdvancePayment_EmployeeContract:any;
AdhocAdvancePaymentBO_Res_ASSOC_PayrollVariable_AdhocAdvancePaymentType_PayrollVariable:any;
AdhocAdvancePaymentBO_Res_ASSOC_AdhocAdvancePaymentType_AdhocAdvancePayment_Type:any;
AdhocAdvancePaymentBO_Res_ASSOC_SalaryPeriod_AdhocAdvancePayment_SalaryPeriod:any;
AdhocAdvancePaymentBO_Res_ASSOC_PayrollPeriod_AdhocAdvancePayment_PayrollPeriod:any;
Res_ENUM_AdhocAdvancePaymentStatus_Pending:any;
Res_ENUM_AdhocAdvancePaymentStatus_Payment:any;
Res_ENUM_AdhocAdvancePaymentStatus_Clearance:any;
Res_ENUM_AdhocAdvancePaymentStatus_Canceled:any;
BackOfficeExpropriationBO_Res_ASSOC_CashAccount_BackOfficeExpropriationConfig_CashAccount:any;
Res_ENUM_SurveyEmployeeStatus_Active:any;
Res_ENUM_SurveyEmployeeStatus_InActive:any;
EntityHistoryBO_EntityFieldDTO_Initialization_Failed:any;
Res_ENUM_WorkPlace_CompanyDepartment:any;
Res_ENUM_WorkPlace_Other:any;
ErganiBO_MASS_IMPORT_COMPLETE:any;
Res_ENUM_CertificationStatus_Active:any;
Res_ENUM_CertificationStatus_Inactive:any;
CertificationBO_MASS_IMPORT_COMPLETE:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_NAME:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_VALIDATION_FROM:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_VALIDATION_TO:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_CATEGORY_EMLPOYEE:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_TYPE:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_DOMAIN:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_CATEGORY:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_SUITE:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_INSTITUTION:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_LEVEL:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_NAME_SPACE:any;
CertificationBO_MASS_IMPORT_CERTIFICATION:any;
CertificationBO_MASS_IMPORT_CERTIFICATION_DOCUMENT_TYPE:any;
CertificationBO_MASS_IMPORT_CERTIFICATIONLEVEL_DESCRIPTION_NO:any;
ForeignLanguangeBO_Res_ASSOC_Institution_ForeignLanguange_Institution:any;
VocationalEducationBO_Res_ASSOC_FileData_VocationalEducation_Diploma:any;
VocationalEducationBO_Res_ASSOC_EmployeeCategory_VocationalEducation_EmployeeCategory:any;
VocationalEducationBO_Res_ASSOC_KnowledgeDomain_VocationalEducation_KnowledgeDomain:any;
VocationalEducationBO_Res_ASSOC_Institution_VocationalEducation_Institution:any;
Res_ENUM_DepMemberFMY_Full:any;
Res_ENUM_DepMemberFMY_None:any;
Res_ENUM_PeriodType_Item1:any;
Res_ENUM_PeriodType_Item3:any;
Res_ENUM_PeriodType_Item4:any;
Res_ENUM_PeriodType_Item5:any;
Res_ENUM_PeriodType_Item11:any;
Res_ENUM_PeriodType_Item12:any;
Res_ENUM_PeriodType_Item13:any;
Res_ENUM_PeriodType_Item14:any;
Res_ENUM_PeriodType_Item15:any;
Res_ENUM_PeriodType_Item16:any;
Res_ENUM_AdvancePayments_Status_Normal:any;
Res_ENUM_AdvancePayments_Status_Canceled:any;
ResignationRuleBO_Res_ASSOC_ApprovalFlow_ResignationRule_ApprovalFlow:any;
EmployeeResignationBO_Res_ASSOC_UserAccount_EmployeeResignationRequest_RequestedBy:any;
EmployeeResignationBO_Res_ASSOC_PendingTask_EmployeeResignationRequest_ActiveTask:any;
EmployeeResignationBO_Res_ASSOC_ApprovalFlowScenario_EmployeeResignationRequest_ApprovalFlowScenario:any;
EmployeeResignationBO_Res_ASSOC_Employee_EmployeeResignationRequest_Employee:any;
EmployeeResignationBO_Res_ASSOC_ResignationRule_EmployeeResignationRequest_ResignationRule:any;
EmployeeResignationBO_Res_ASSOC_EmployeeContract_EmployeeResignationRequest_EmployeeContract:any;
Res_ENUM_ResignationRequestStatus_Temporary:any;
Res_ENUM_ResignationRequestStatus_Pending:any;
Res_ENUM_ResignationRequestStatus_Validating:any;
Res_ENUM_ResignationRequestStatus_Approved:any;
Res_ENUM_ResignationRequestStatus_Rejected:any;
EmployeeResignationBO_EmployeeLeaveBO_RES_CUSTOM_INVALID_STATUS_TRANSITION:any;
EmployeeResignationBO_EmployeeLeaveBO_RES_CUSTOM_VALIDATION_OVERLAPING_DAYS:any;
EmployeeResignationBO_RES_NOTIFY_RESIGNATION_APPROVAL:any;
EmployeeResignationBO_RES_NOTIFY_RESIGNATION_INFORM:any;
EmployeeResignationBO_RES_NOTIFY_RESIGNATION_ACCEPTED:any;
EmployeeResignationBO_RES_NOTIFY_RESIGNATION_REJECTED:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_EMPLOYEE_CONTRACT_NO:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TYPE_CODE_NO:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_DATE_REQUIRED:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_REQUESTED_DATE_NO:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_HOURS_FROM_TO_REQUIRED:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_COMPLETE:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_EMPLOYEE_CODE_NO:any;
EmployeeResignationBO_EmployeeLeaveBO_RES_WRONG_EMPLOEE_CODE:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TYPE_CODE_REQUIRED:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_HOURS_WRONG:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_FROM_HOURS_WRONG:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TO_HOURS_WRONG:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_FROM_MIN_WRONG:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TO__WRONG:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_TIME_WRONG:any;
EmployeeResignationBO_EmployeeLeaveBO_MASS_IMPORT_OVERTIME_ERGANIS_TYPE_WRONG:any;
Res_ENUM_MovementType_Entry:any;
Res_ENUM_MovementType_Exit:any;
Res_ENUM_MovementType_Unknown:any;
Res_ENUM_CardStatus_Active:any;
Res_ENUM_CardStatus_Lost:any;
Res_ENUM_CardStatus_Damaged:any;
Res_ENUM_CardStatus_Expired:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_DateTime:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_MovementType:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_EmployeeContract:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_CardID:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_Location:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_Inserted:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_Updated:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_Skipped:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_NotFound:any;
AttendanceBO_MASS_IMPORT_MOVEMENT_NotInserted:any;
Res_ENUM_ModificationEmployeeState_IsPending:any;
Res_ENUM_ModificationEmployeeState_Accepted:any;
Res_ENUM_ModificationEmployeeState_Cancelled:any;
Res_ENUM_ModificationTypeStatus_Active:any;
Res_ENUM_ModificationTypeStatus_InActive:any;
PowerBIBO_Res_ASSOC_EmbedConfigFilters_EmbedConfigPanes_filters:any;
PowerBIBO_Res_ASSOC_EmbedConfigPanes_EmbedConfigSettings_panes:any;
PowerBIBO_Res_ASSOC_EmbedConfigSettings_EmbedConfig_settings:any;
PayrollScaleDTOs_Res_ASSOC_PayrollCategoryDTO_PayrollScaleItemDTO_PayrollCategory:any;
PayrollScaleDTOs_Res_ASSOC_PayrollVariable_DTO_PayrollScaleDataDTO_PayrollVariable:any;




}